{
  "level": "q313",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:q313",
    "objects": "AREAS.E3:q313.e3",
    "mesh": "TREES.E3:q313.e3"
  },
  "spawn_point": {
    "position": [
      79.40923938334949,
      1908.122024137086,
      -276.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      79.40923938334949,
      2008.122024137086,
      -276.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      -6158.31884765625,
      -4547.06494140625,
      -300.0
    ],
    "bbox_max": [
      6166.0625,
      7450.0,
      1783.6751708984375
    ],
    "vertex_count": 803,
    "vertices": [
      [
        -3714.042724609375,
        -2323.521484375,
        1179.1292724609375
      ],
      [
        -5545.388671875,
        4741.15380859375,
        334.1224365234375
      ],
      [
        -6158.31884765625,
        3750.8916015625,
        976.300048828125
      ],
      [
        -5532.3203125,
        4687.76513671875,
        347.86444091796875
      ],
      [
        -5504.7001953125,
        4729.1015625,
        -22.699951171875
      ],
      [
        -3461.156005859375,
        -4521.4228515625,
        1390.116943359375
      ],
      [
        -3400.0,
        -4452.255859375,
        1098.934814453125
      ],
      [
        -3400.0,
        -4540.619140625,
        1370.3192138671875
      ],
      [
        -5704.5439453125,
        4430.013671875,
        976.300048828125
      ],
      [
        -5573.556640625,
        4626.0498046875,
        901.113525390625
      ],
      [
        -3921.887939453125,
        1500.0,
        -300.0
      ],
      [
        -4008.181640625,
        2279.415283203125,
        -300.0
      ],
      [
        -5174.01171875,
        5224.01171875,
        -11.83916187286377
      ],
      [
        -5532.3203125,
        4687.76513671875,
        347.86444091796875
      ],
      [
        -5174.01171875,
        5224.01171875,
        -11.83917236328125
      ],
      [
        -5158.470703125,
        5234.39599609375,
        -22.699951171875
      ],
      [
        -5174.01171875,
        5224.01171875,
        671.7750244140625
      ],
      [
        -5174.01171875,
        5224.01171875,
        671.7750244140625
      ],
      [
        -4901.68505859375,
        5405.974609375,
        546.6460571289062
      ],
      [
        -4485.72412109375,
        5683.91064453125,
        -4.9591064453125e-05
      ],
      [
        -4478.6357421875,
        5688.64697265625,
        -22.699951171875
      ],
      [
        -3777.331787109375,
        1500.0,
        -300.0
      ],
      [
        -3875.56787109375,
        2387.280029296875,
        -300.0
      ],
      [
        -4468.451171875,
        5695.4521484375,
        -22.699951171875
      ],
      [
        -3400.0,
        2940.080810546875,
        336.2261657714844
      ],
      [
        -3400.0,
        2786.4052734375,
        73.41243743896484
      ],
      [
        -3662.578857421875,
        6233.91845703125,
        -22.699951171875
      ],
      [
        -3400.0,
        2755.17236328125,
        0.0
      ],
      [
        -3400.0,
        2786.4052734375,
        73.41243743896484
      ],
      [
        -3861.6328125,
        2261.4169921875,
        -300.0
      ],
      [
        -3400.0,
        2774.09521484375,
        -300.0
      ],
      [
        -3400.0,
        2627.539306640625,
        -300.0
      ],
      [
        -3856.35498046875,
        2213.74609375,
        -300.0
      ],
      [
        -3400.0,
        2568.059326171875,
        -300.0
      ],
      [
        -3400.0,
        1500.0,
        -300.0
      ],
      [
        -5579.16064453125,
        4617.6630859375,
        976.300048828125
      ],
      [
        -5573.556640625,
        4626.0498046875,
        901.113525390625
      ],
      [
        -3400.0,
        -4547.06494140625,
        1390.1160888671875
      ],
      [
        -3400.0,
        6409.3681640625,
        976.300048828125
      ],
      [
        -3400.0,
        6409.3681640625,
        -22.699951171875
      ],
      [
        -3400.0,
        2993.050048828125,
        426.8134765625
      ],
      [
        6166.0625,
        5070.96875,
        1783.6751708984375
      ],
      [
        5574.01171875,
        5224.01171875,
        727.609130859375
      ],
      [
        5240.630859375,
        5446.76953125,
        -22.699951171875
      ],
      [
        4117.16162109375,
        2301.5830078125,
        1016.0430908203125
      ],
      [
        4089.31982421875,
        3098.861083984375,
        938.4326782226562
      ],
      [
        4104.1787109375,
        4205.02490234375,
        -300.0
      ],
      [
        6166.0625,
        5070.96875,
        1783.6751708984375
      ],
      [
        4031.279296875,
        4760.92822265625,
        0.0
      ],
      [
        4024.458251953125,
        4956.259765625,
        44.461669921875
      ],
      [
        6113.7509765625,
        5124.94384765625,
        1755.6993408203125
      ],
      [
        4978.5498046875,
        5621.88623046875,
        976.300048828125
      ],
      [
        3977.864501953125,
        6290.52294921875,
        -22.699951171875
      ],
      [
        3977.864501953125,
        6290.52294921875,
        348.1690368652344
      ],
      [
        4031.279296875,
        4760.92822265625,
        0.0
      ],
      [
        4044.14013671875,
        4392.6396484375,
        -300.0
      ],
      [
        6113.7509765625,
        5124.94384765625,
        1755.69921875
      ],
      [
        4024.458251953125,
        4956.259765625,
        44.46170425415039
      ],
      [
        4021.62939453125,
        5037.267578125,
        101.1990966796875
      ],
      [
        4447.9970703125,
        5744.82666015625,
        939.7493286132812
      ],
      [
        4447.9970703125,
        5744.82666015625,
        939.7494506835938
      ],
      [
        4021.62939453125,
        5037.267578125,
        101.19913482666016
      ],
      [
        3988.998046875,
        5971.7080078125,
        711.0925903320312
      ],
      [
        4550.60546875,
        5907.82958984375,
        976.300048828125
      ],
      [
        3977.864501953125,
        6290.52294921875,
        684.1944580078125
      ],
      [
        4059.62060546875,
        3949.339111328125,
        65.54586791992188
      ],
      [
        4087.392822265625,
        3154.04345703125,
        933.06103515625
      ],
      [
        4087.392822265625,
        3154.043701171875,
        933.0609741210938
      ],
      [
        4529.33349609375,
        5879.8046875,
        1099.716064453125
      ],
      [
        4529.33349609375,
        5879.8046875,
        1099.716064453125
      ],
      [
        3981.694580078125,
        6180.85302734375,
        847.597900390625
      ],
      [
        4264.15087890625,
        6099.232421875,
        976.300048828125
      ],
      [
        3977.864501953125,
        6290.52294921875,
        843.8876953125
      ],
      [
        3956.501220703125,
        6902.2900390625,
        1318.467529296875
      ],
      [
        4128.34423828125,
        6189.9755859375,
        976.300048828125
      ],
      [
        3977.864501953125,
        6290.52294921875,
        919.1776733398438
      ],
      [
        3977.864501953125,
        6290.52294921875,
        976.300048828125
      ],
      [
        200.0,
        7450.0,
        680.7955932617188
      ],
      [
        3108.39404296875,
        6871.484375,
        547.1160278320312
      ],
      [
        235.99966430664062,
        5035.24365234375,
        -36.83790969848633
      ],
      [
        228.268310546875,
        5028.201171875,
        -58.07283020019531
      ],
      [
        427.0267028808594,
        7267.0830078125,
        -58.07281494140625
      ],
      [
        3108.39404296875,
        6871.484375,
        547.1160278320312
      ],
      [
        3977.864501953125,
        6290.52294921875,
        385.8159484863281
      ],
      [
        427.0267028808594,
        7267.0830078125,
        -58.07281494140625
      ],
      [
        231.0294647216797,
        7173.888671875,
        -300.0
      ],
      [
        259.23272705078125,
        5158.08642578125,
        0.0
      ],
      [
        235.99966430664062,
        5035.24365234375,
        -36.837890625
      ],
      [
        200.0,
        7450.0,
        680.7955932617188
      ],
      [
        100.0,
        7430.10888671875,
        -22.699951171875
      ],
      [
        100.0,
        7430.10888671875,
        673.5613403320312
      ],
      [
        100.0,
        7265.8046875,
        0.0
      ],
      [
        100.0,
        7165.60498046875,
        -300.0
      ],
      [
        4035.890380859375,
        4628.8798828125,
        -107.56373596191406
      ],
      [
        3966.75,
        4947.60009765625,
        -13.693594932556152
      ],
      [
        3986.6806640625,
        4979.27001953125,
        32.46458435058594
      ],
      [
        3108.39404296875,
        6871.484375,
        589.1254272460938
      ],
      [
        3170.04638671875,
        6830.28955078125,
        612.5288696289062
      ],
      [
        3977.864501953125,
        6290.52294921875,
        474.2994384765625
      ],
      [
        3108.39404296875,
        6871.484375,
        589.1254272460938
      ],
      [
        3052.0458984375,
        6882.69287109375,
        549.7059936523438
      ],
      [
        4000.447998046875,
        4954.3212890625,
        24.796052932739258
      ],
      [
        3986.6806640625,
        4979.27001953125,
        32.464569091796875
      ],
      [
        3973.222900390625,
        4917.76171875,
        -22.481624603271484
      ],
      [
        3975.082763671875,
        4909.18798828125,
        -25.006759643554688
      ],
      [
        4000.447998046875,
        4954.3212890625,
        24.79603385925293
      ],
      [
        3999.897216796875,
        4949.3115234375,
        23.076147079467773
      ],
      [
        3108.39404296875,
        6871.484375,
        620.9074096679688
      ],
      [
        816.3768920898438,
        7327.39501953125,
        652.46484375
      ],
      [
        3018.31005859375,
        6889.4033203125,
        624.2333984375
      ],
      [
        4035.839111328125,
        4630.34521484375,
        -106.37005615234375
      ],
      [
        3108.39404296875,
        6871.484375,
        620.9073486328125
      ],
      [
        3163.70068359375,
        6834.52978515625,
        610.1199951171875
      ],
      [
        3992.506103515625,
        4882.0908203125,
        0.0
      ],
      [
        4034.1044921875,
        4680.0224609375,
        -65.90400695800781
      ],
      [
        3992.506103515625,
        4882.0908203125,
        0.0
      ],
      [
        3108.39404296875,
        6871.484375,
        623.0784301757812
      ],
      [
        3108.39404296875,
        6871.484375,
        623.0784912109375
      ],
      [
        3963.516845703125,
        6701.3896484375,
        1187.3433837890625
      ],
      [
        3156.055419921875,
        6862.00390625,
        622.4673461914062
      ],
      [
        4020.44775390625,
        5071.1044921875,
        123.28406524658203
      ],
      [
        3956.206787109375,
        5048.34375,
        54.11053466796875
      ],
      [
        3977.864501953125,
        6290.52294921875,
        919.1775512695312
      ],
      [
        3170.04638671875,
        6830.28955078125,
        612.5288696289062
      ],
      [
        100.0,
        7430.10888671875,
        976.300048828125
      ],
      [
        3960.09619140625,
        5039.52783203125,
        51.34784698486328
      ],
      [
        3958.969970703125,
        5049.32275390625,
        57.08589172363281
      ],
      [
        -2708.39404296875,
        6871.484375,
        38.73223876953125
      ],
      [
        -1165.5225830078125,
        7178.380859375,
        976.300048828125
      ],
      [
        -248.8677978515625,
        4693.4443359375,
        0.0
      ],
      [
        -248.8677978515625,
        4693.4443359375,
        0.0
      ],
      [
        -246.8081817626953,
        4169.818359375,
        -300.0
      ],
      [
        -2708.39404296875,
        6871.484375,
        38.732234954833984
      ],
      [
        -2778.40673828125,
        6824.70361328125,
        -22.699951171875
      ],
      [
        -109.37823486328125,
        7252.56787109375,
        0.0
      ],
      [
        69.84530639648438,
        7163.69873046875,
        -300.0
      ],
      [
        -302.08367919921875,
        3879.621826171875,
        -300.0
      ],
      [
        -366.4575500488281,
        3873.98974609375,
        -113.45060729980469
      ],
      [
        -475.55438232421875,
        3864.445068359375,
        0.0
      ],
      [
        -619.7982788085938,
        3851.8251953125,
        150.0
      ],
      [
        -475.5544128417969,
        3864.445068359375,
        0.0
      ],
      [
        -366.4575500488281,
        3873.98974609375,
        -113.45060729980469
      ],
      [
        3966.056884765625,
        3861.65869140625,
        100.0
      ],
      [
        4060.7236328125,
        3917.75341796875,
        100.0
      ],
      [
        -1846.6666259765625,
        2096.666748046875,
        -10.0
      ],
      [
        -1846.6666259765625,
        1326.6666259765625,
        -10.000000953674316
      ],
      [
        -1846.6668701171875,
        1750.0,
        -10.0
      ],
      [
        -1846.6668701171875,
        1950.0,
        -10.0
      ],
      [
        -601.791748046875,
        1515.3333740234375,
        -10.0
      ],
      [
        107.416259765625,
        1515.3333740234375,
        -10.000000953674316
      ],
      [
        -1526.6666259765625,
        2573.333251953125,
        -10.0
      ],
      [
        -1526.6666259765625,
        2096.666748046875,
        -10.000000953674316
      ],
      [
        -1526.6666259765625,
        2096.666748046875,
        -10.0
      ],
      [
        -1846.6666259765625,
        2096.666748046875,
        -10.000000953674316
      ],
      [
        -1840.0,
        2000.0,
        -10.0
      ],
      [
        -1840.0,
        1950.0,
        -10.0
      ],
      [
        -1840.0,
        1800.0,
        -10.0
      ],
      [
        -1840.0,
        1750.0,
        -10.0
      ],
      [
        -1840.0,
        1750.0,
        -10.0
      ],
      [
        -1840.0,
        1950.0,
        -10.0
      ],
      [
        205.60003662109375,
        1744.39990234375,
        -10.0
      ],
      [
        317.7317199707031,
        1819.3238525390625,
        -10.000000953674316
      ],
      [
        130.67605590820312,
        1632.268310546875,
        -10.0
      ],
      [
        205.60003662109375,
        1744.39990234375,
        -10.000000953674316
      ],
      [
        107.416259765625,
        1515.3333740234375,
        -10.0
      ],
      [
        130.67605590820312,
        1632.268310546875,
        -10.000000953674316
      ],
      [
        -1850.0001220703125,
        1750.0,
        0.0
      ],
      [
        -1846.6668701171875,
        1750.0,
        -10.0
      ],
      [
        -1846.6668701171875,
        1950.0,
        -10.0
      ],
      [
        -1880.0,
        1950.0,
        0.0
      ],
      [
        -1850.0001220703125,
        1950.0,
        0.0
      ],
      [
        -1840.0,
        1950.0,
        0.0
      ],
      [
        -1840.0,
        1800.0,
        0.0
      ],
      [
        -1840.0,
        1950.0,
        0.0
      ],
      [
        -2183.333251953125,
        3400.0,
        0.0
      ],
      [
        -2652.67138671875,
        3400.0,
        150.0
      ],
      [
        -2700.0,
        3381.37744140625,
        161.4759979248047
      ],
      [
        -2700.0,
        3372.810546875,
        146.8248748779297
      ],
      [
        -2700.0,
        3310.3447265625,
        0.0
      ],
      [
        -2700.0,
        3372.810546875,
        146.8248748779297
      ],
      [
        -1551.5946044921875,
        690.0,
        66.98198699951172
      ],
      [
        -1517.6541748046875,
        690.0,
        0.0
      ],
      [
        -1580.0,
        423.6956481933594,
        100.0
      ],
      [
        -1580.0,
        460.0,
        100.0
      ],
      [
        -1580.0,
        440.0,
        106.0
      ],
      [
        -1580.0,
        440.0,
        140.0
      ],
      [
        -1580.0,
        440.0,
        106.0
      ],
      [
        -1580.0,
        440.0,
        100.0
      ],
      [
        -1560.0,
        440.0,
        140.0
      ],
      [
        -1560.0,
        440.0,
        170.0
      ],
      [
        228.09024047851562,
        690.0,
        280.0
      ],
      [
        137.42349243164062,
        690.0,
        280.0
      ],
      [
        250.98464965820312,
        690.0,
        280.0
      ],
      [
        228.09024047851562,
        690.0,
        280.0
      ],
      [
        137.4235076904297,
        690.0,
        280.0
      ],
      [
        228.09024047851562,
        690.0,
        350.0
      ],
      [
        137.42349243164062,
        690.0,
        350.0
      ],
      [
        250.98464965820312,
        690.0,
        350.0
      ],
      [
        228.09024047851562,
        690.0,
        350.0
      ],
      [
        137.4235076904297,
        690.0,
        350.0
      ],
      [
        254.0325927734375,
        690.0,
        350.0
      ],
      [
        250.98464965820312,
        690.0,
        350.0
      ],
      [
        -100.0,
        650.0,
        350.0
      ],
      [
        -100.0,
        690.0,
        350.0
      ],
      [
        254.0325927734375,
        690.0,
        350.0
      ],
      [
        254.0325927734375,
        690.0,
        420.0
      ],
      [
        254.0325927734375,
        650.0,
        350.0
      ],
      [
        -100.0,
        650.0,
        280.0
      ],
      [
        -100.0,
        690.0,
        280.0
      ],
      [
        254.0325927734375,
        690.0,
        280.0
      ],
      [
        254.0325927734375,
        650.0,
        280.0
      ],
      [
        137.4235076904297,
        690.0,
        210.0
      ],
      [
        -100.0,
        650.0,
        210.0
      ],
      [
        -100.0,
        690.0,
        210.0
      ],
      [
        254.0325927734375,
        690.0,
        210.0
      ],
      [
        254.0325927734375,
        650.0,
        210.0
      ],
      [
        254.0325927734375,
        690.0,
        160.0
      ],
      [
        1645.0,
        1830.0,
        500.0
      ],
      [
        1645.0,
        1830.0,
        1180.0
      ],
      [
        1975.4892578125,
        1830.0,
        1060.0
      ],
      [
        1975.800048828125,
        1830.0,
        1059.6484375
      ],
      [
        1968.064697265625,
        1837.4246826171875,
        1060.0
      ],
      [
        1975.489501953125,
        1830.0,
        1060.0
      ],
      [
        1917.3709716796875,
        1888.11865234375,
        1060.0
      ],
      [
        1865.3895263671875,
        1940.0999755859375,
        1060.0
      ],
      [
        1968.064697265625,
        1837.4246826171875,
        1060.0
      ],
      [
        1917.3709716796875,
        1888.11865234375,
        1060.0
      ],
      [
        1913.6177978515625,
        1830.0,
        1130.0
      ],
      [
        1961.243408203125,
        1830.0,
        1130.0
      ],
      [
        1892.56787109375,
        1851.050048828125,
        1130.0
      ],
      [
        1956.5875244140625,
        1830.0,
        1060.0
      ],
      [
        1723.412353515625,
        1830.0,
        1060.0
      ],
      [
        1892.9425048828125,
        1830.0,
        1060.0
      ],
      [
        1956.5875244140625,
        1830.0,
        1060.0
      ],
      [
        1723.412353515625,
        1830.0,
        1060.0
      ],
      [
        1787.0577392578125,
        1830.0,
        1060.0
      ],
      [
        1913.2427978515625,
        1830.375,
        1130.0
      ],
      [
        1872.5,
        1841.2916259765625,
        1110.0
      ],
      [
        1852.5001220703125,
        1846.6507568359375,
        1110.0
      ],
      [
        1892.9425048828125,
        1830.0,
        1060.0
      ],
      [
        1892.9427490234375,
        1830.0,
        1106.0
      ],
      [
        1892.9425048828125,
        1830.0,
        1130.0
      ],
      [
        1892.9425048828125,
        1830.0,
        1130.0
      ],
      [
        1880.41455078125,
        1830.0,
        1130.0
      ],
      [
        1706.639892578125,
        1830.0,
        1130.0
      ],
      [
        1675.58154296875,
        1830.0,
        1130.0
      ],
      [
        1869.4744873046875,
        1830.0,
        1110.0
      ],
      [
        1848.03857421875,
        1830.0,
        1110.0
      ],
      [
        1704.19970703125,
        1830.0,
        1060.0
      ],
      [
        1704.19970703125,
        1830.0,
        1059.6480712890625
      ],
      [
        1660.0,
        1771.8487548828125,
        1130.0
      ],
      [
        1660.0,
        1767.4713134765625,
        1130.0
      ],
      [
        -1530.0,
        2550.0,
        200.0
      ],
      [
        -1530.0,
        2550.0,
        0.0
      ],
      [
        -1698.58056640625,
        2364.470947265625,
        429.07421875
      ],
      [
        -1726.9398193359375,
        2306.16845703125,
        426.95050048828125
      ],
      [
        -1688.00927734375,
        2338.93994140625,
        426.9678039550781
      ],
      [
        -1691.032470703125,
        2341.456787109375,
        475.0
      ],
      [
        -1691.463623046875,
        2342.42822265625,
        485.0
      ],
      [
        -1691.032470703125,
        2341.456787109375,
        475.0
      ],
      [
        -1696.6881103515625,
        2317.318359375,
        429.10107421875
      ],
      [
        -1680.0238037109375,
        2326.370849609375,
        460.0
      ],
      [
        -1696.6881103515625,
        2317.318359375,
        429.10107421875
      ],
      [
        -1698.7021484375,
        2321.261474609375,
        485.0
      ],
      [
        -1679.344970703125,
        2327.900390625,
        475.0
      ],
      [
        -1680.0238037109375,
        2326.370849609375,
        460.0
      ],
      [
        -1679.344970703125,
        2327.900390625,
        475.0
      ],
      [
        -1724.36083984375,
        2309.230224609375,
        475.0
      ],
      [
        -1723.2684326171875,
        2309.652587890625,
        485.0
      ],
      [
        -1724.36083984375,
        2309.230224609375,
        475.0
      ],
      [
        190.0,
        1715.052978515625,
        0.0
      ],
      [
        190.0,
        1693.45361328125,
        60.0
      ],
      [
        254.03260803222656,
        820.0,
        160.0
      ],
      [
        254.03260803222656,
        820.0,
        420.0
      ],
      [
        241.07882690429688,
        820.0,
        350.0
      ],
      [
        195.3977813720703,
        820.0,
        350.0
      ],
      [
        254.03260803222656,
        820.0,
        350.0
      ],
      [
        241.07882690429688,
        820.0,
        350.0
      ],
      [
        195.3977813720703,
        820.0,
        370.0
      ],
      [
        195.3977813720703,
        820.0,
        350.0
      ],
      [
        241.07882690429688,
        820.0,
        280.0
      ],
      [
        195.3977813720703,
        820.0,
        280.0
      ],
      [
        195.3977813720703,
        820.0,
        300.0
      ],
      [
        195.3977813720703,
        820.0,
        280.0
      ],
      [
        0.0,
        1490.0,
        60.0
      ],
      [
        0.0,
        1490.0,
        214.0
      ],
      [
        -595.0115356445312,
        1430.0,
        60.0
      ],
      [
        -595.0115356445312,
        1430.0,
        214.0
      ],
      [
        -50.0,
        1250.4873046875,
        60.0
      ],
      [
        -50.0,
        1250.4873046875,
        120.0
      ],
      [
        -309.5,
        1006.4411010742188,
        225.0
      ],
      [
        -289.4999694824219,
        971.800048828125,
        225.0
      ],
      [
        -309.5,
        1006.4411010742188,
        300.0
      ],
      [
        -289.4999694824219,
        971.800048828125,
        300.0
      ],
      [
        -309.5,
        1006.4411010742188,
        200.0
      ],
      [
        -289.4999694824219,
        971.800048828125,
        200.0
      ],
      [
        -289.4999694824219,
        971.800048828125,
        210.0
      ],
      [
        -289.4999694824219,
        971.800048828125,
        225.0
      ],
      [
        -253.3668670654297,
        909.215576171875,
        78.04346466064453
      ],
      [
        -288.3668518066406,
        848.59375,
        78.04347229003906
      ],
      [
        -134.50001525878906,
        1201.7012939453125,
        100.00611877441406
      ],
      [
        -134.50001525878906,
        1201.7012939453125,
        120.00611877441406
      ],
      [
        -134.50001525878906,
        1201.7012939453125,
        80.0
      ],
      [
        -134.50001525878906,
        1201.7012939453125,
        100.00611877441406
      ],
      [
        -134.50001525878906,
        1201.7012939453125,
        120.00611877441406
      ],
      [
        -134.50001525878906,
        1201.7012939453125,
        500.0
      ],
      [
        -241.81982421875,
        929.2155151367188,
        60.00611877441406
      ],
      [
        -252.2337188720703,
        911.17822265625,
        78.04346466064453
      ],
      [
        -252.2337188720703,
        911.17822265625,
        78.04346466064453
      ],
      [
        -134.50001525878906,
        1201.7012939453125,
        80.0
      ],
      [
        -117.17955017089844,
        1211.7012939453125,
        60.00611877441406
      ],
      [
        -97.95298767089844,
        1178.39990234375,
        60.00611877441406
      ],
      [
        -100.0,
        1050.0,
        60.0
      ],
      [
        -100.0,
        1050.0,
        82.0
      ],
      [
        -100.0,
        1158.39990234375,
        71.77527618408203
      ],
      [
        -100.0,
        1134.8543701171875,
        60.00611877441406
      ],
      [
        -100.0,
        1174.8543701171875,
        63.550559997558594
      ],
      [
        -100.0,
        1158.39990234375,
        71.77527618408203
      ],
      [
        -50.843994140625,
        1250.0,
        60.0
      ],
      [
        -50.843994140625,
        1250.0,
        75.0040283203125
      ],
      [
        -50.0,
        1250.0,
        74.27332305908203
      ],
      [
        -50.843994140625,
        1250.0,
        82.0
      ],
      [
        -50.0,
        1250.0,
        82.0
      ],
      [
        -50.843994140625,
        1250.0,
        120.0
      ],
      [
        -50.0,
        1250.4873046875,
        120.0
      ],
      [
        -50.843994140625,
        1250.0,
        120.0
      ],
      [
        0.0,
        839.9456176757812,
        144.0
      ],
      [
        0.0,
        1027.272705078125,
        102.0
      ],
      [
        0.0,
        903.6550903320312,
        102.0
      ],
      [
        0.0,
        1027.272705078125,
        102.0
      ],
      [
        0.0,
        1027.272705078125,
        104.0
      ],
      [
        0.0,
        903.6550903320312,
        104.0
      ],
      [
        0.0,
        1027.272705078125,
        104.0
      ],
      [
        -50.0,
        830.0,
        104.0
      ],
      [
        -50.0,
        830.0,
        102.0
      ],
      [
        0.0,
        839.9456176757812,
        102.0
      ],
      [
        0.0,
        839.9456176757812,
        104.0
      ],
      [
        0.0,
        903.6550903320312,
        124.0
      ],
      [
        0.0,
        1000.0,
        124.0
      ],
      [
        0.0,
        1000.0,
        124.0
      ],
      [
        0.0,
        839.9456176757812,
        124.0
      ],
      [
        0.0,
        839.9456176757812,
        140.0
      ],
      [
        -50.0,
        830.0,
        124.0
      ],
      [
        -50.0,
        830.0,
        124.0
      ],
      [
        0.0,
        839.9456176757812,
        124.0
      ],
      [
        0.0,
        839.9456176757812,
        144.0
      ],
      [
        0.0,
        839.9456176757812,
        120.0
      ],
      [
        0.0,
        1000.0,
        82.0
      ],
      [
        0.0,
        903.6550903320312,
        82.0
      ],
      [
        0.0,
        1000.0,
        82.0
      ],
      [
        0.0,
        903.6550903320312,
        80.0
      ],
      [
        0.0,
        1000.0,
        80.0
      ],
      [
        0.0,
        1000.0,
        80.0
      ],
      [
        -28.569734573364258,
        864.2627563476562,
        80.0
      ],
      [
        1.9584635424507724e-07,
        869.9456176757812,
        80.0
      ],
      [
        1.639127589214695e-07,
        869.9456176757812,
        82.0
      ],
      [
        -33.161930084228516,
        893.3493041992188,
        80.0
      ],
      [
        -33.16192626953125,
        875.3493041992188,
        80.0
      ],
      [
        -50.0,
        890.0,
        80.0
      ],
      [
        -33.16192626953125,
        893.3493041992188,
        80.0
      ],
      [
        -33.161930084228516,
        875.3493041992188,
        80.0
      ],
      [
        -28.56973648071289,
        864.2627563476562,
        80.0
      ],
      [
        0.0,
        879.289306640625,
        77.0
      ],
      [
        0.0,
        869.9456176757812,
        77.33370208740234
      ],
      [
        0.0,
        879.289306640625,
        77.0
      ],
      [
        0.0,
        898.7388305664062,
        76.30537414550781
      ],
      [
        0.0,
        899.9456176757812,
        76.20401763916016
      ],
      [
        0.0,
        898.7388305664062,
        76.30537414550781
      ],
      [
        2.384185791015625e-07,
        869.9456176757812,
        77.33370208740234
      ],
      [
        0.0,
        903.6550903320312,
        60.0
      ],
      [
        0.0,
        903.6550903320312,
        75.89246368408203
      ],
      [
        0.0,
        903.6550903320312,
        75.89246368408203
      ],
      [
        2.384185791015625e-07,
        869.9456176757812,
        92.26585388183594
      ],
      [
        0.0,
        867.943359375,
        92.26585388183594
      ],
      [
        0.0,
        869.9456176757812,
        92.26585388183594
      ],
      [
        0.0,
        839.9456176757812,
        90.45423126220703
      ],
      [
        0.0,
        839.9456176757812,
        92.26585388183594
      ],
      [
        -615.3160400390625,
        1210.361328125,
        60.0
      ],
      [
        -615.3160400390625,
        1210.361328125,
        214.0
      ],
      [
        -329.5,
        1130.4095458984375,
        400.0
      ],
      [
        -320.5,
        1130.4095458984375,
        400.0
      ],
      [
        -391.0191650390625,
        1130.4095458984375,
        400.0
      ],
      [
        -329.5,
        1130.4095458984375,
        400.0
      ],
      [
        -320.5,
        1130.4095458984375,
        400.0
      ],
      [
        -257.9808349609375,
        1130.4095458984375,
        400.0
      ],
      [
        -429.4999084472656,
        1210.361328125,
        100.00611877441406
      ],
      [
        -429.4999084472656,
        1210.361328125,
        80.00611877441406
      ],
      [
        -429.4999084472656,
        1210.361328125,
        120.0008773803711
      ],
      [
        -429.4999084472656,
        1210.361328125,
        500.0
      ],
      [
        -383.3397521972656,
        1130.4095458984375,
        400.0
      ],
      [
        -399.5,
        1158.39990234375,
        400.0
      ],
      [
        -429.4999084472656,
        1210.361328125,
        80.00611877441406
      ],
      [
        -406.4058837890625,
        1210.361328125,
        60.00611877441406
      ],
      [
        -295.0,
        1210.361328125,
        120.0
      ],
      [
        -295.0,
        1210.361328125,
        125.0
      ],
      [
        -279.4776611328125,
        1210.361328125,
        120.0
      ],
      [
        -279.4776611328125,
        1210.361328125,
        110.0
      ],
      [
        -279.4776611328125,
        1210.361328125,
        80.0
      ],
      [
        -279.4776611328125,
        1210.361328125,
        95.0
      ],
      [
        -279.4776611328125,
        1210.361328125,
        110.0
      ],
      [
        -279.4776611328125,
        1210.361328125,
        95.0
      ],
      [
        -219.50009155273438,
        1210.361328125,
        120.00524139404297
      ],
      [
        -219.5000762939453,
        1210.361328125,
        500.0
      ],
      [
        -139.49990844726562,
        1210.361328125,
        100.00611877441406
      ],
      [
        -139.49990844726562,
        1210.361328125,
        120.00611877441406
      ],
      [
        -139.49990844726562,
        1210.361328125,
        80.0
      ],
      [
        -139.49990844726562,
        1210.361328125,
        100.00611877441406
      ],
      [
        -139.49990844726562,
        1210.361328125,
        120.00611877441406
      ],
      [
        -139.49990844726562,
        1210.361328125,
        500.0
      ],
      [
        -139.49990844726562,
        1210.361328125,
        80.0
      ],
      [
        -119.50043487548828,
        1210.361328125,
        62.68523025512695
      ],
      [
        -616.1632690429688,
        1219.021728515625,
        60.0
      ],
      [
        -616.1632690429688,
        1219.021728515625,
        214.0
      ],
      [
        -340.0,
        1219.021728515625,
        80.0
      ],
      [
        -340.0,
        1219.021728515625,
        125.0
      ],
      [
        -411.4059753417969,
        1219.021728515625,
        60.00611877441406
      ],
      [
        -355.0,
        1219.021728515625,
        80.0
      ],
      [
        -341.4645080566406,
        1213.535400390625,
        80.0
      ],
      [
        -354.7092590332031,
        1219.021728515625,
        80.0
      ],
      [
        -355.0,
        1219.021728515625,
        125.0
      ],
      [
        -354.7092590332031,
        1219.021728515625,
        125.0
      ],
      [
        -341.4645080566406,
        1213.535400390625,
        125.0
      ],
      [
        -340.0,
        1212.9288330078125,
        80.0
      ],
      [
        -340.0,
        1212.9288330078125,
        125.0
      ],
      [
        -340.0,
        1219.021728515625,
        80.0
      ],
      [
        -340.0,
        1219.021728515625,
        125.0
      ],
      [
        -295.0,
        1219.021728515625,
        80.0
      ],
      [
        -295.0,
        1219.021728515625,
        125.0
      ],
      [
        -310.0,
        1219.021728515625,
        80.0
      ],
      [
        -295.0,
        1219.021728515625,
        80.0
      ],
      [
        -340.0,
        1219.021728515625,
        80.0
      ],
      [
        -310.0,
        1219.021728515625,
        80.0
      ],
      [
        -310.0,
        1219.021728515625,
        125.0
      ],
      [
        -295.0,
        1219.021728515625,
        125.0
      ],
      [
        -295.0,
        1210.4000244140625,
        60.0
      ],
      [
        -540.0,
        1430.0,
        120.0
      ],
      [
        -394.65386962890625,
        1410.0,
        60.0
      ],
      [
        -400.42303466796875,
        1420.0,
        120.0
      ],
      [
        -406.1922912597656,
        1430.0,
        120.0
      ],
      [
        -400.42303466796875,
        1420.0,
        120.0
      ],
      [
        -299.5139465332031,
        1239.0279541015625,
        60.0
      ],
      [
        -295.0,
        1230.0,
        69.02786254882812
      ],
      [
        -340.0,
        1239.0279541015625,
        60.0
      ],
      [
        -340.0,
        1230.0,
        69.02786254882812
      ],
      [
        -310.0,
        1235.0,
        64.02790069580078
      ],
      [
        -310.0,
        1239.02783203125,
        60.0
      ],
      [
        -450.0,
        1370.0,
        62.0
      ],
      [
        -432.32232666015625,
        1362.6776123046875,
        62.0
      ],
      [
        -432.32232666015625,
        1327.3223876953125,
        62.0
      ],
      [
        -450.0,
        1320.0,
        62.0
      ],
      [
        -432.32232666015625,
        1362.6776123046875,
        62.0
      ],
      [
        -425.0,
        1345.0,
        62.0
      ],
      [
        -425.0,
        1345.0,
        62.0
      ],
      [
        -432.32232666015625,
        1327.3223876953125,
        62.0
      ],
      [
        -450.0,
        1322.164794921875,
        62.0
      ],
      [
        -433.8530578613281,
        1328.8531494140625,
        62.0
      ],
      [
        -466.1469421386719,
        1328.8531494140625,
        62.0
      ],
      [
        -450.0,
        1322.164794921875,
        62.0
      ],
      [
        -450.0,
        1367.835205078125,
        62.0
      ],
      [
        -466.1469421386719,
        1361.1468505859375,
        62.0
      ],
      [
        -472.835205078125,
        1345.0,
        62.0
      ],
      [
        -466.1469421386719,
        1328.8531494140625,
        62.0
      ],
      [
        -466.1469421386719,
        1361.1468505859375,
        62.0
      ],
      [
        -472.835205078125,
        1345.0,
        62.0
      ],
      [
        -340.0,
        1240.0,
        65.0
      ],
      [
        -310.0,
        1240.0,
        65.0
      ],
      [
        -310.0,
        1240.0,
        65.0
      ],
      [
        -310.0,
        1240.0,
        60.0
      ],
      [
        -315.0000305175781,
        1270.0,
        65.0
      ],
      [
        -313.3333435058594,
        1266.666748046875,
        65.0
      ],
      [
        -310.0,
        1260.0,
        65.0
      ],
      [
        -313.3333435058594,
        1266.666748046875,
        65.0
      ],
      [
        -310.0,
        1260.0,
        65.0
      ],
      [
        -310.0,
        1260.0,
        60.0
      ],
      [
        -313.88458251953125,
        1270.0,
        65.0
      ],
      [
        -312.4634094238281,
        1267.53662109375,
        65.0
      ],
      [
        -310.0,
        1263.2667236328125,
        65.0
      ],
      [
        -312.4634094238281,
        1267.53662109375,
        65.0
      ],
      [
        -310.0,
        1263.2667236328125,
        65.0
      ],
      [
        -310.0,
        1263.2667236328125,
        60.0
      ],
      [
        -121.40599822998047,
        1219.021728515625,
        60.00611877441406
      ],
      [
        -182.32232666015625,
        1327.3223876953125,
        62.0
      ],
      [
        -200.0,
        1320.0,
        62.0
      ],
      [
        -182.32232666015625,
        1362.6776123046875,
        62.0
      ],
      [
        -175.0,
        1345.0,
        62.0
      ],
      [
        -175.0,
        1345.0,
        62.0
      ],
      [
        -182.32232666015625,
        1327.3223876953125,
        62.0
      ],
      [
        -216.14694213867188,
        1328.8531494140625,
        62.0
      ],
      [
        -200.0,
        1322.164794921875,
        62.0
      ],
      [
        -183.85305786132812,
        1361.1468505859375,
        62.0
      ],
      [
        -200.0,
        1367.835205078125,
        62.0
      ],
      [
        -200.0,
        1367.835205078125,
        62.0
      ],
      [
        -216.14694213867188,
        1361.1468505859375,
        62.0
      ],
      [
        -216.14694213867188,
        1361.1468505859375,
        62.0
      ],
      [
        -222.835205078125,
        1345.0,
        62.0
      ],
      [
        -222.835205078125,
        1345.0,
        62.0
      ],
      [
        -216.14694213867188,
        1328.8531494140625,
        62.0
      ],
      [
        -310.0,
        1270.0,
        62.0
      ],
      [
        -310.0,
        1263.2667236328125,
        62.0
      ],
      [
        10.0,
        1336.1817626953125,
        144.0
      ],
      [
        110.0,
        1336.1817626953125,
        144.0
      ],
      [
        110.0,
        1336.1817626953125,
        144.0
      ],
      [
        110.0,
        1490.0,
        144.0
      ],
      [
        10.0,
        1490.0,
        144.0
      ],
      [
        10.0,
        1336.1817626953125,
        144.0
      ],
      [
        110.0,
        1490.0,
        144.0
      ],
      [
        10.0,
        1490.0,
        144.0
      ],
      [
        10.0,
        1490.0,
        214.0
      ],
      [
        110.0,
        1490.0,
        214.0
      ],
      [
        110.0,
        1490.0,
        144.0
      ],
      [
        10.0,
        1490.0,
        144.0
      ],
      [
        89.74484252929688,
        1502.4483642578125,
        218.25515747070312
      ],
      [
        35.0,
        1495.0,
        217.0
      ],
      [
        0.0,
        1490.0,
        144.0
      ],
      [
        120.0,
        1490.0,
        214.0
      ],
      [
        120.0,
        1490.0,
        144.0
      ],
      [
        22.5,
        1270.0,
        144.0
      ],
      [
        97.5,
        1270.0,
        144.0
      ],
      [
        0.0,
        1250.0,
        144.0
      ],
      [
        10.0,
        1265.0,
        144.0
      ],
      [
        120.0,
        1250.0,
        144.0
      ],
      [
        110.0,
        1265.0,
        144.0
      ],
      [
        10.0,
        1265.0,
        144.0
      ],
      [
        22.5,
        1270.0,
        144.0
      ],
      [
        110.0,
        1265.0,
        144.0
      ],
      [
        97.5,
        1270.0,
        144.0
      ],
      [
        10.0,
        1490.0,
        82.0
      ],
      [
        10.0,
        1310.0,
        82.0
      ],
      [
        110.0,
        1310.0,
        82.0
      ],
      [
        110.0,
        1490.0,
        82.0
      ],
      [
        10.0,
        1310.0,
        82.0
      ],
      [
        110.0,
        1310.0,
        82.0
      ],
      [
        110.0,
        1490.0,
        82.0
      ],
      [
        10.0,
        1490.0,
        82.0
      ],
      [
        10.0,
        1490.0,
        82.0
      ],
      [
        110.0,
        1490.0,
        82.0
      ],
      [
        110.0,
        1490.0,
        80.0
      ],
      [
        10.0,
        1490.0,
        80.0
      ],
      [
        22.5,
        1270.0,
        82.0
      ],
      [
        97.5,
        1270.0,
        82.0
      ],
      [
        90.0,
        1000.0,
        80.0
      ],
      [
        90.0,
        1000.0,
        82.0
      ],
      [
        79.34313201904297,
        946.42431640625,
        82.0
      ],
      [
        79.34313201904297,
        946.42431640625,
        80.0
      ],
      [
        110.0,
        1000.0,
        82.0
      ],
      [
        90.0,
        1000.0,
        82.0
      ],
      [
        90.0,
        1000.0,
        80.0
      ],
      [
        110.0,
        1000.0,
        80.0
      ],
      [
        79.34313201904297,
        946.42431640625,
        80.0
      ],
      [
        79.34313201904297,
        946.42431640625,
        82.0
      ],
      [
        48.99494934082031,
        901.0050659179688,
        82.0
      ],
      [
        48.99494934082031,
        901.0050659179688,
        80.0
      ],
      [
        48.99494934082031,
        901.0050659179688,
        80.0
      ],
      [
        48.99494934082031,
        901.0050659179688,
        82.0
      ],
      [
        10.0,
        874.949462890625,
        82.0
      ],
      [
        10.0,
        874.949462890625,
        80.0
      ],
      [
        10.0,
        1265.0,
        82.0
      ],
      [
        22.5,
        1270.0,
        82.0
      ],
      [
        110.0,
        1265.0,
        82.0
      ],
      [
        97.5,
        1270.0,
        82.0
      ],
      [
        120.0,
        1250.0,
        82.0
      ],
      [
        110.0,
        1265.0,
        82.0
      ],
      [
        120.0,
        1000.0,
        80.0
      ],
      [
        120.0,
        1000.0,
        82.0
      ],
      [
        120.0,
        1490.0,
        82.0
      ],
      [
        120.0,
        1490.0,
        80.0
      ],
      [
        0.0,
        1250.0,
        82.0
      ],
      [
        10.0,
        1265.0,
        82.0
      ],
      [
        0.0,
        1050.0,
        82.0
      ],
      [
        0.0,
        1050.0,
        80.0
      ],
      [
        10.0,
        1050.0,
        80.0
      ],
      [
        10.0,
        1050.0,
        82.0
      ],
      [
        3.5756804943084717,
        870.6568603515625,
        82.0
      ],
      [
        3.5756804943084717,
        870.6568603515625,
        80.0
      ],
      [
        1.6391277313232422e-07,
        869.9456176757812,
        82.0
      ],
      [
        1.9584635424507724e-07,
        869.9456176757812,
        80.0
      ],
      [
        3.5756804943084717,
        870.6568603515625,
        80.0
      ],
      [
        3.5756804943084717,
        870.6568603515625,
        82.0
      ],
      [
        0.0,
        1490.0,
        80.0
      ],
      [
        0.0,
        1490.0,
        82.0
      ],
      [
        10.0,
        1490.0,
        124.0
      ],
      [
        10.0,
        1314.3636474609375,
        124.0
      ],
      [
        110.0,
        1314.3636474609375,
        124.0
      ],
      [
        110.0,
        1490.0,
        124.0
      ],
      [
        10.0,
        1314.3636474609375,
        124.0
      ],
      [
        110.0,
        1314.3636474609375,
        124.0
      ],
      [
        110.0,
        1490.0,
        124.0
      ],
      [
        10.0,
        1490.0,
        124.0
      ],
      [
        10.0,
        1490.0,
        144.0
      ],
      [
        110.0,
        1490.0,
        144.0
      ],
      [
        110.0,
        1490.0,
        124.0
      ],
      [
        10.0,
        1490.0,
        124.0
      ],
      [
        22.5,
        1270.0,
        124.0
      ],
      [
        97.5,
        1270.0,
        124.0
      ],
      [
        70.2081527709961,
        879.7918701171875,
        124.0
      ],
      [
        15.056182861328125,
        842.9404907226562,
        124.0
      ],
      [
        15.056182861328125,
        842.9404907226562,
        124.0
      ],
      [
        70.2081527709961,
        879.7918701171875,
        124.0
      ],
      [
        107.05952453613281,
        934.9437866210938,
        124.0
      ],
      [
        70.2081527709961,
        879.7918701171875,
        124.0
      ],
      [
        70.2081527709961,
        879.7918701171875,
        124.0
      ],
      [
        107.05951690673828,
        934.9437866210938,
        124.0
      ],
      [
        110.0,
        949.7265625,
        140.0
      ],
      [
        107.05952453613281,
        934.9437866210938,
        124.0
      ],
      [
        110.0,
        949.7265625,
        124.0
      ],
      [
        107.05951690673828,
        934.9437866210938,
        124.0
      ],
      [
        110.0,
        949.7265625,
        124.0
      ],
      [
        110.0,
        949.7265625,
        144.0
      ],
      [
        10.0,
        1265.0,
        124.0
      ],
      [
        22.5,
        1270.0,
        124.0
      ],
      [
        110.0,
        1265.0,
        124.0
      ],
      [
        97.5,
        1270.0,
        124.0
      ],
      [
        15.056182861328125,
        842.9404907226562,
        124.0
      ],
      [
        10.0,
        841.9347534179688,
        140.0
      ],
      [
        10.0,
        841.9347534179688,
        124.0
      ],
      [
        15.056182861328125,
        842.9404907226562,
        124.0
      ],
      [
        10.0,
        841.9347534179688,
        144.0
      ],
      [
        10.0,
        841.9347534179688,
        124.0
      ],
      [
        110.0,
        1000.0,
        126.0
      ],
      [
        90.0,
        1000.0,
        124.0
      ],
      [
        110.0,
        1000.0,
        124.0
      ],
      [
        90.0,
        1000.0,
        124.0
      ],
      [
        88.2238540649414,
        991.0707397460938,
        124.0
      ],
      [
        120.0,
        1000.0,
        124.0
      ],
      [
        117.84325408935547,
        989.1572875976562,
        124.0
      ],
      [
        120.0,
        1250.0,
        124.0
      ],
      [
        110.0,
        1265.0,
        124.0
      ],
      [
        120.0,
        1000.0,
        124.0
      ],
      [
        120.0,
        1490.0,
        124.0
      ],
      [
        0.0,
        1250.0,
        124.0
      ],
      [
        10.0,
        1265.0,
        124.0
      ],
      [
        0.0,
        839.9456176757812,
        124.0
      ],
      [
        0.0,
        839.9456176757812,
        124.0
      ],
      [
        0.0,
        1050.0,
        124.0
      ],
      [
        10.0,
        1050.0,
        124.0
      ],
      [
        0.0,
        1490.0,
        124.0
      ],
      [
        110.0,
        1310.0,
        102.0
      ],
      [
        110.0,
        1310.0,
        104.0
      ],
      [
        110.0,
        1490.0,
        104.0
      ],
      [
        110.0,
        1490.0,
        102.0
      ],
      [
        10.0,
        1490.0,
        102.0
      ],
      [
        10.0,
        1490.0,
        104.0
      ],
      [
        10.0,
        1310.0,
        104.0
      ],
      [
        10.0,
        1310.0,
        102.0
      ],
      [
        10.0,
        1310.0,
        102.0
      ],
      [
        10.0,
        1310.0,
        104.0
      ],
      [
        110.0,
        1310.0,
        104.0
      ],
      [
        110.0,
        1310.0,
        102.0
      ],
      [
        110.0,
        1490.0,
        102.0
      ],
      [
        110.0,
        1490.0,
        104.0
      ],
      [
        10.0,
        1490.0,
        104.0
      ],
      [
        10.0,
        1490.0,
        102.0
      ],
      [
        10.0,
        1490.0,
        104.0
      ],
      [
        110.0,
        1490.0,
        104.0
      ],
      [
        110.0,
        1490.0,
        102.0
      ],
      [
        10.0,
        1490.0,
        102.0
      ],
      [
        10.0,
        1210.0,
        102.0
      ],
      [
        10.0,
        1210.0,
        104.0
      ],
      [
        15.056183815002441,
        842.9404907226562,
        104.0
      ],
      [
        15.056183815002441,
        842.9404907226562,
        102.0
      ],
      [
        60.18052291870117,
        873.0916137695312,
        102.0
      ],
      [
        90.0,
        1000.0,
        102.0
      ],
      [
        90.0,
        1000.0,
        104.0
      ],
      [
        79.34313201904297,
        946.42431640625,
        104.0
      ],
      [
        79.34313201904297,
        946.42431640625,
        102.0
      ],
      [
        110.0,
        1000.0,
        104.0
      ],
      [
        90.0,
        1000.0,
        104.0
      ],
      [
        90.0,
        1000.0,
        102.0
      ],
      [
        110.0,
        1000.0,
        102.0
      ],
      [
        79.34313201904297,
        946.42431640625,
        102.0
      ],
      [
        79.34313201904297,
        946.42431640625,
        104.0
      ],
      [
        48.99494934082031,
        901.0050659179688,
        102.0
      ],
      [
        15.056183815002441,
        842.9404907226562,
        102.0
      ],
      [
        15.056183815002441,
        842.9404907226562,
        104.0
      ],
      [
        10.0,
        841.9347534179688,
        104.0
      ],
      [
        10.0,
        841.9347534179688,
        102.0
      ],
      [
        48.99494934082031,
        901.0050659179688,
        102.0
      ],
      [
        40.736900329589844,
        895.4871826171875,
        102.0
      ],
      [
        22.5,
        1270.0,
        104.0
      ],
      [
        22.5,
        1270.0,
        102.0
      ],
      [
        97.5,
        1270.0,
        102.0
      ],
      [
        97.5,
        1270.0,
        104.0
      ],
      [
        84.09091186523438,
        1240.0,
        102.0
      ],
      [
        84.09091186523438,
        1210.0,
        102.0
      ],
      [
        110.0,
        1265.0,
        102.0
      ],
      [
        110.0,
        1265.0,
        104.0
      ],
      [
        97.5,
        1270.0,
        104.0
      ],
      [
        97.5,
        1270.0,
        102.0
      ],
      [
        10.0,
        1265.0,
        104.0
      ],
      [
        10.0,
        1265.0,
        102.0
      ],
      [
        22.5,
        1270.0,
        102.0
      ],
      [
        22.5,
        1270.0,
        104.0
      ],
      [
        0.0,
        1250.0,
        104.0
      ],
      [
        0.0,
        1250.0,
        102.0
      ],
      [
        10.0,
        1265.0,
        102.0
      ],
      [
        10.0,
        1265.0,
        104.0
      ],
      [
        0.0,
        839.9456176757812,
        104.0
      ],
      [
        0.0,
        839.9456176757812,
        102.0
      ],
      [
        0.0,
        1050.0,
        104.0
      ],
      [
        0.0,
        1050.0,
        102.0
      ],
      [
        10.0,
        1050.0,
        102.0
      ],
      [
        10.0,
        1050.0,
        104.0
      ],
      [
        0.0,
        1490.0,
        102.0
      ],
      [
        0.0,
        1490.0,
        104.0
      ],
      [
        120.0,
        1250.0,
        102.0
      ],
      [
        120.0,
        1250.0,
        104.0
      ],
      [
        110.0,
        1265.0,
        104.0
      ],
      [
        110.0,
        1265.0,
        102.0
      ],
      [
        120.0,
        1000.0,
        102.0
      ],
      [
        120.0,
        1000.0,
        104.0
      ],
      [
        120.0,
        1490.0,
        104.0
      ],
      [
        120.0,
        1490.0,
        102.0
      ],
      [
        10.0,
        1490.0,
        102.0
      ],
      [
        110.0,
        1490.0,
        102.0
      ],
      [
        110.0,
        1490.0,
        82.0
      ],
      [
        10.0,
        1490.0,
        82.0
      ],
      [
        79.34313201904297,
        946.42431640625,
        100.39305114746094
      ],
      [
        48.99494934082031,
        901.0050659179688,
        90.1213607788086
      ],
      [
        84.09092712402344,
        970.2930908203125,
        102.0
      ],
      [
        79.34313201904297,
        946.42431640625,
        100.39305114746094
      ],
      [
        110.0,
        1000.0,
        102.0
      ],
      [
        110.0,
        1000.0,
        82.0
      ],
      [
        48.99494934082031,
        901.0050659179688,
        90.1213607788086
      ],
      [
        25.000009536743164,
        884.97216796875,
        82.0
      ],
      [
        10.0,
        841.9347534179688,
        92.14508056640625
      ],
      [
        10.0,
        841.9347534179688,
        102.0
      ],
      [
        10.0,
        874.949462890625,
        94.55589294433594
      ],
      [
        10.0,
        874.949462890625,
        82.0
      ],
      [
        3.8616164488303184e-08,
        868.2676391601562,
        92.26585388183594
      ],
      [
        10.0,
        1490.0,
        124.0
      ],
      [
        110.0,
        1490.0,
        124.0
      ],
      [
        110.0,
        1490.0,
        104.0
      ],
      [
        10.0,
        1490.0,
        104.0
      ],
      [
        10.0,
        841.9347534179688,
        120.0
      ],
      [
        10.0,
        841.9347534179688,
        124.0
      ],
      [
        10.0,
        841.9347534179688,
        124.0
      ],
      [
        10.0,
        841.9347534179688,
        104.0
      ],
      [
        110.0,
        949.7265625,
        120.0
      ],
      [
        110.0,
        949.7265625,
        124.0
      ],
      [
        110.0,
        949.7265625,
        116.72677612304688
      ],
      [
        110.0,
        949.7265625,
        124.0
      ],
      [
        110.0,
        1000.0,
        124.0
      ],
      [
        110.0,
        1000.0,
        104.0
      ],
      [
        110.0,
        1250.0,
        80.0
      ],
      [
        10.0,
        1250.0,
        80.0
      ],
      [
        10.0,
        1250.0,
        60.0
      ],
      [
        110.0,
        1250.0,
        60.0
      ],
      [
        10.0,
        910.3368530273438,
        60.0
      ],
      [
        10.0,
        910.3368530273438,
        73.95751190185547
      ],
      [
        48.99494934082031,
        901.0050659179688,
        73.9999771118164
      ],
      [
        48.99494934082031,
        901.0050659179688,
        73.99998474121094
      ],
      [
        10.0,
        874.949462890625,
        79.09492492675781
      ],
      [
        10.0,
        874.949462890625,
        76.29277801513672
      ],
      [
        10.0,
        874.949462890625,
        76.29277801513672
      ],
      [
        10.0,
        899.2013549804688,
        75.4266357421875
      ],
      [
        10.0,
        910.3368530273438,
        74.49137878417969
      ],
      [
        10.0,
        899.2013549804688,
        75.4266357421875
      ],
      [
        10.0,
        910.3368530273438,
        74.49137878417969
      ],
      [
        110.0,
        1000.0,
        60.0
      ],
      [
        110.0,
        1000.0,
        80.0
      ],
      [
        10.0,
        874.949462890625,
        80.0
      ],
      [
        110.0,
        1490.0,
        60.0
      ],
      [
        10.0,
        1490.0,
        60.0
      ],
      [
        10.0,
        1490.0,
        80.0
      ],
      [
        110.0,
        1490.0,
        80.0
      ],
      [
        0.0,
        1050.0,
        70.90319061279297
      ],
      [
        10.0,
        1050.0,
        70.04096984863281
      ],
      [
        0.0,
        1250.0,
        63.76032638549805
      ],
      [
        10.0,
        1250.0,
        62.89810562133789
      ],
      [
        120.0,
        1490.0,
        60.0
      ],
      [
        190.0,
        1693.45361328125,
        120.0
      ],
      [
        190.0,
        1693.45361328125,
        140.0
      ],
      [
        190.0,
        1693.45361328125,
        60.0
      ],
      [
        190.0,
        1693.45361328125,
        120.0
      ],
      [
        1001.6588745117188,
        2530.0,
        273.4599304199219
      ],
      [
        998.7774047851562,
        2530.0,
        250.1707000732422
      ],
      [
        450.0,
        1110.0,
        190.0
      ],
      [
        450.0,
        1240.0,
        190.0
      ],
      [
        450.0,
        1240.0,
        190.0
      ],
      [
        450.0,
        1240.0,
        330.0
      ],
      [
        254.03265380859375,
        1240.0,
        192.38693237304688
      ],
      [
        254.03262329101562,
        1000.0,
        192.38694763183594
      ],
      [
        210.0,
        841.853759765625,
        350.0
      ],
      [
        210.0,
        820.0,
        350.0
      ],
      [
        210.0,
        841.853759765625,
        370.0
      ],
      [
        210.0,
        841.853759765625,
        350.0
      ],
      [
        224.19573974609375,
        820.0,
        280.0
      ],
      [
        210.0,
        841.853759765625,
        280.0
      ],
      [
        210.0,
        820.0,
        280.0
      ],
      [
        210.0,
        841.853759765625,
        300.0
      ],
      [
        210.0,
        841.853759765625,
        280.0
      ],
      [
        210.0,
        1236.24072265625,
        75.0
      ],
      [
        210.0,
        1210.3587646484375,
        75.0
      ],
      [
        210.0,
        1210.3587646484375,
        75.0
      ],
      [
        210.0,
        1210.3587646484375,
        60.0
      ],
      [
        252.0435028076172,
        1460.0,
        240.0
      ],
      [
        440.13531494140625,
        1717.5289306640625,
        240.0
      ],
      [
        358.3660888671875,
        1698.2799072265625,
        240.0
      ],
      [
        231.15760803222656,
        1507.89892578125,
        240.0
      ],
      [
        1549.9998779296875,
        1550.0,
        500.0
      ],
      [
        1549.9998779296875,
        1550.0,
        1180.0
      ],
      [
        1550.0,
        1910.0,
        500.0
      ],
      [
        1550.0,
        1910.0,
        1180.0
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        0.34176069498062134,
        0.1286875456571579,
        0.930934488773346
      ],
      "plane_d": 470.6300048828125,
      "bbox_min": [
        -6971.595703125,
        -4547.06494140625,
        -300.0
      ],
      "bbox_max": [
        -3400.0,
        6409.3681640625,
        1650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3910660445690155,
        0.31802985072135925,
        0.8636690974235535
      ],
      "plane_d": 372.213623046875,
      "bbox_min": [
        -6971.595703125,
        -4540.619140625,
        -22.699951171875
      ],
      "bbox_max": [
        -3400.0,
        4741.15380859375,
        1650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314697742462158,
        -0.5555701851844788,
        0.0
      ],
      "plane_d": 7204.33935546875,
      "bbox_min": [
        -6821.484375,
        -4540.619140625,
        -22.699951171875
      ],
      "bbox_max": [
        -3400.0,
        4729.1015625,
        1390.1221923828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3703444004058838,
        0.8832541108131409,
        0.2875887453556061
      ],
      "plane_d": 4875.603515625,
      "bbox_min": [
        -3833.671875,
        -4540.619140625,
        1040.098388671875
      ],
      "bbox_max": [
        -3400.0,
        -4327.0185546875,
        1390.1221923828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314697742462158,
        -0.5555701851844788,
        0.0
      ],
      "plane_d": 7204.33935546875,
      "bbox_min": [
        -6158.31884765625,
        3750.8916015625,
        347.86444091796875
      ],
      "bbox_max": [
        -5532.3203125,
        4687.76513671875,
        976.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7714905142784119,
        0.08541621267795563,
        0.6304812431335449
      ],
      "plane_d": 2975.195556640625,
      "bbox_min": [
        -5573.556640625,
        -2269.10009765625,
        -300.0
      ],
      "bbox_max": [
        -3400.0,
        6233.91845703125,
        1000.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9429216384887695,
        0.10439633578062057,
        0.3162280023097992
      ],
      "plane_d": 3636.306884765625,
      "bbox_min": [
        -5573.556640625,
        -2269.10009765625,
        -300.0
      ],
      "bbox_max": [
        -3509.2900390625,
        5695.4521484375,
        1000.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3910660445690155,
        0.31802985072135925,
        0.8636690974235535
      ],
      "plane_d": 372.213623046875,
      "bbox_min": [
        -5573.556640625,
        1500.0,
        -300.0
      ],
      "bbox_max": [
        -3921.887939453125,
        5688.64697265625,
        1000.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314697742462158,
        -0.5555701851844788,
        0.0
      ],
      "plane_d": 7204.33935546875,
      "bbox_min": [
        -5532.3203125,
        4687.76513671875,
        -22.699951171875
      ],
      "bbox_max": [
        -5158.470703125,
        5234.39599609375,
        347.86444091796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555701851844788,
        -0.8314697742462158,
        0.0
      ],
      "plane_d": 7218.134765625,
      "bbox_min": [
        -5174.01171875,
        5224.01171875,
        -22.699951171875
      ],
      "bbox_max": [
        -5158.470703125,
        5234.39599609375,
        -11.83917236328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314697742462158,
        -0.5555701851844788,
        0.0
      ],
      "plane_d": 7204.33935546875,
      "bbox_min": [
        -5573.556640625,
        4626.0498046875,
        -22.699951171875
      ],
      "bbox_max": [
        -4478.6357421875,
        5688.64697265625,
        901.113525390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555701851844788,
        -0.8314697742462158,
        0.0
      ],
      "plane_d": 7218.134765625,
      "bbox_min": [
        -5174.01171875,
        5224.01171875,
        -22.699951171875
      ],
      "bbox_max": [
        -4478.6357421875,
        5688.64697265625,
        671.7750244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 300.0,
      "bbox_min": [
        -4485.72412109375,
        1500.0,
        -300.0
      ],
      "bbox_max": [
        -3777.331787109375,
        5695.4521484375,
        -4.9591064453125e-05
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555701851844788,
        -0.8314697742462158,
        0.0
      ],
      "plane_d": 7218.134765625,
      "bbox_min": [
        -4485.72412109375,
        5683.91064453125,
        -22.699951171875
      ],
      "bbox_max": [
        -4468.451171875,
        5695.4521484375,
        -4.9591064453125e-05
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5567466616630554,
        -0.7170891761779785,
        0.41930466890335083
      ],
      "plane_d": 3860.257568359375,
      "bbox_min": [
        -4912.15185546875,
        1500.0,
        -300.0
      ],
      "bbox_max": [
        -3400.0,
        6233.91845703125,
        1000.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555701851844788,
        -0.8314697742462158,
        0.0
      ],
      "plane_d": 7218.134765625,
      "bbox_min": [
        -4901.68505859375,
        2200.0,
        -300.0
      ],
      "bbox_max": [
        -3400.0,
        6233.91845703125,
        546.6460571289062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 300.0,
      "bbox_min": [
        -3875.56787109375,
        2261.4169921875,
        -300.0
      ],
      "bbox_max": [
        -3400.0,
        2774.09521484375,
        -300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 300.0,
      "bbox_min": [
        -3861.6328125,
        2213.74609375,
        -300.0
      ],
      "bbox_max": [
        -3400.0,
        2627.539306640625,
        -300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 300.0,
      "bbox_min": [
        -3856.35498046875,
        1500.0,
        -300.0
      ],
      "bbox_max": [
        -3400.0,
        2568.059326171875,
        -300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9600966572761536,
        0.2609225809574127,
        0.10066688805818558
      ],
      "plane_d": 4053.39990234375,
      "bbox_min": [
        -5704.5439453125,
        -4547.06494140625,
        -22.699951171875
      ],
      "bbox_max": [
        -3400.0,
        6409.3681640625,
        1390.116943359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314697742462158,
        -0.5555701851844788,
        0.0
      ],
      "plane_d": 7204.33935546875,
      "bbox_min": [
        -5704.5439453125,
        -4547.06494140625,
        901.113525390625
      ],
      "bbox_max": [
        -3400.0,
        4626.0498046875,
        1390.116943359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3703444004058838,
        0.8832541108131409,
        0.2875887453556061
      ],
      "plane_d": 4875.603515625,
      "bbox_min": [
        -3461.156005859375,
        -4547.06494140625,
        1370.3192138671875
      ],
      "bbox_max": [
        -3400.0,
        -4521.4228515625,
        1390.116943359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555701851844788,
        -0.8314697742462158,
        0.0
      ],
      "plane_d": 7218.134765625,
      "bbox_min": [
        -5579.16064453125,
        2154.178466796875,
        -22.699951171875
      ],
      "bbox_max": [
        -3400.0,
        6409.3681640625,
        1000.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5567466616630554,
        -0.7170891761779785,
        0.41930466890335083
      ],
      "plane_d": 3860.257568359375,
      "bbox_min": [
        -5579.16064453125,
        2154.178466796875,
        336.2261657714844
      ],
      "bbox_max": [
        -3400.0,
        5224.01171875,
        1000.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314697742462158,
        -0.5555701851844788,
        0.0
      ],
      "plane_d": 7204.33935546875,
      "bbox_min": [
        -5579.16064453125,
        4617.6630859375,
        671.7750244140625
      ],
      "bbox_max": [
        -5174.01171875,
        5224.01171875,
        976.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3156070411205292,
        0.8320549726486206,
        0.45615431666374207
      ],
      "plane_d": 1686.0640869140625,
      "bbox_min": [
        -3400.0,
        -5072.0185546875,
        0.0
      ],
      "bbox_max": [
        -1701.24462890625,
        -2671.68505859375,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3703444004058838,
        0.8832541108131409,
        0.2875887453556061
      ],
      "plane_d": 4875.603515625,
      "bbox_min": [
        -3400.0,
        -5072.0185546875,
        1098.934814453125
      ],
      "bbox_max": [
        -2147.99658203125,
        -4452.255859375,
        1390.1160888671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16772790253162384,
        0.9131852984428406,
        0.3714297413825989
      ],
      "plane_d": 2361.634521484375,
      "bbox_min": [
        -3260.67529296875,
        -3618.21142578125,
        0.0
      ],
      "bbox_max": [
        -2100.0,
        -3111.68505859375,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.965404748916626,
        -0.2439502775669098,
        0.09209758043289185
      ],
      "plane_d": 2003.16259765625,
      "bbox_min": [
        -3260.67529296875,
        -3618.21142578125,
        0.0
      ],
      "bbox_max": [
        -2861.24462890625,
        -3111.68505859375,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8451709151268005,
        -0.3576369881629944,
        0.3972178101539612
      ],
      "plane_d": 904.6746826171875,
      "bbox_min": [
        -3260.67529296875,
        -3618.21142578125,
        1052.5999755859375
      ],
      "bbox_max": [
        -3003.01416015625,
        -3212.1396484375,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.738960862159729,
        0.6707490682601929,
        -0.06350246071815491
      ],
      "plane_d": 2243.716064453125,
      "bbox_min": [
        -1201.24462890625,
        -3700.0,
        0.0
      ],
      "bbox_max": [
        400.0,
        -2021.68505859375,
        1852.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7596201300621033,
        0.64952552318573,
        -0.03307165205478668
      ],
      "plane_d": 2160.664794921875,
      "bbox_min": [
        -825.0,
        -3700.0,
        0.0
      ],
      "bbox_max": [
        400.0,
        -2275.0,
        1852.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 300.0,
      "bbox_min": [
        -3400.0,
        -150.0,
        -300.0
      ],
      "bbox_max": [
        6811.5068359375,
        7700.0,
        2163.576171875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.4204522669315338,
        0.06168942153453827,
        0.9052150249481201
      ],
      "plane_d": 665.100341796875,
      "bbox_min": [
        3956.501220703125,
        2280.14306640625,
        -300.0
      ],
      "bbox_max": [
        6811.5068359375,
        6902.2900390625,
        2163.576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7007350325584412,
        0.5362348556518555,
        0.4705556631088257
      ],
      "plane_d": 762.2275390625,
      "bbox_min": [
        3977.864501953125,
        2280.14306640625,
        -300.0
      ],
      "bbox_max": [
        6166.0625,
        6290.52294921875,
        1783.6751708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5660791993141174,
        0.06026303768157959,
        0.8221452236175537
      ],
      "plane_d": 1356.604248046875,
      "bbox_min": [
        4089.31982421875,
        2280.14306640625,
        -300.0
      ],
      "bbox_max": [
        4237.6171875,
        4205.02490234375,
        1031.6990966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9035463333129883,
        -0.28914403915405273,
        0.31622743606567383
      ],
      "plane_d": 5019.0419921875,
      "bbox_min": [
        4104.1787109375,
        4116.14306640625,
        -300.0
      ],
      "bbox_max": [
        4237.6171875,
        4205.02490234375,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6118655800819397,
        -0.1958032250404358,
        0.7663430571556091
      ],
      "plane_d": 3398.80615234375,
      "bbox_min": [
        3977.864501953125,
        3098.861083984375,
        -300.0
      ],
      "bbox_max": [
        6166.0625,
        6290.52294921875,
        1783.6751708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555701851844788,
        -0.8314697742462158,
        -0.0
      ],
      "plane_d": 7440.36279296875,
      "bbox_min": [
        3977.864501953125,
        4116.14306640625,
        -300.0
      ],
      "bbox_max": [
        5574.01171875,
        6290.52294921875,
        976.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9035463333129883,
        -0.28914403915405273,
        0.31622743606567383
      ],
      "plane_d": 5019.0419921875,
      "bbox_min": [
        4031.279296875,
        4116.14306640625,
        -300.0
      ],
      "bbox_max": [
        4237.6171875,
        4760.92822265625,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5238755941390991,
        -0.5008544921875,
        0.6889841556549072
      ],
      "plane_d": 4560.046875,
      "bbox_min": [
        3977.864501953125,
        3098.861083984375,
        0.0
      ],
      "bbox_max": [
        6113.7509765625,
        6290.52294921875,
        1755.69921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.567955493927002,
        -0.463673859834671,
        0.6800244450569153
      ],
      "plane_d": 4550.9375,
      "bbox_min": [
        3977.864501953125,
        5037.267578125,
        101.19913482666016
      ],
      "bbox_max": [
        4978.5498046875,
        6290.52294921875,
        976.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555701851844788,
        -0.8314697742462158,
        -0.0
      ],
      "plane_d": 7440.36279296875,
      "bbox_min": [
        3977.864501953125,
        5621.88623046875,
        348.1690368652344
      ],
      "bbox_max": [
        4978.5498046875,
        6290.52294921875,
        976.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3970937132835388,
        0.6701478362083435,
        0.6270713210105896
      ],
      "plane_d": -1075.6932373046875,
      "bbox_min": [
        4059.62060546875,
        3098.861083984375,
        0.0
      ],
      "bbox_max": [
        4237.6171875,
        4116.14306640625,
        981.6990966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5660791993141174,
        0.06026303768157959,
        0.8221452236175537
      ],
      "plane_d": 1356.604248046875,
      "bbox_min": [
        4087.392822265625,
        3098.861083984375,
        933.0609741210938
      ],
      "bbox_max": [
        4157.6171875,
        3154.043701171875,
        981.6990966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4106284976005554,
        0.01650269143283367,
        0.9116533994674683
      ],
      "plane_d": 760.2809448242188,
      "bbox_min": [
        3956.501220703125,
        3150.14306640625,
        684.1944580078125
      ],
      "bbox_max": [
        6811.5068359375,
        6902.2900390625,
        2163.576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7007350325584412,
        0.5362348556518555,
        0.4705556631088257
      ],
      "plane_d": 762.2275390625,
      "bbox_min": [
        3977.864501953125,
        3150.14306640625,
        684.1944580078125
      ],
      "bbox_max": [
        6306.5068359375,
        6290.52294921875,
        1913.5762939453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555701851844788,
        -0.8314697742462158,
        -0.0
      ],
      "plane_d": 7440.36279296875,
      "bbox_min": [
        3977.864501953125,
        5907.82958984375,
        684.1944580078125
      ],
      "bbox_max": [
        4550.60546875,
        6290.52294921875,
        976.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6118655800819397,
        -0.1958032250404358,
        0.7663430571556091
      ],
      "plane_d": 3398.80615234375,
      "bbox_min": [
        6113.7509765625,
        5070.96875,
        1755.6993408203125
      ],
      "bbox_max": [
        6306.5068359375,
        5140.50634765625,
        1913.5762939453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5238755941390991,
        -0.5008544921875,
        0.6889841556549072
      ],
      "plane_d": 4560.046875,
      "bbox_min": [
        3956.501220703125,
        5140.50634765625,
        843.8876953125
      ],
      "bbox_max": [
        6306.5068359375,
        6902.2900390625,
        1954.7119140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.567955493927002,
        -0.463673859834671,
        0.6800244450569153
      ],
      "plane_d": 4550.9375,
      "bbox_min": [
        3956.501220703125,
        5879.8046875,
        843.8876953125
      ],
      "bbox_max": [
        4964.0634765625,
        6902.2900390625,
        1954.7119140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555701851844788,
        -0.8314697742462158,
        -0.0
      ],
      "plane_d": 7440.36279296875,
      "bbox_min": [
        3977.864501953125,
        6099.232421875,
        843.8876953125
      ],
      "bbox_max": [
        4264.15087890625,
        6290.52294921875,
        976.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555701851844788,
        -0.8314697742462158,
        -0.0
      ],
      "plane_d": 7440.36279296875,
      "bbox_min": [
        3977.864501953125,
        6189.9755859375,
        919.1776733398438
      ],
      "bbox_max": [
        4128.34423828125,
        6290.52294921875,
        976.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.01264164224267006,
        -0.2850233018398285,
        0.9584372639656067
      ],
      "plane_d": 1473.4520263671875,
      "bbox_min": [
        100.0,
        4392.6396484375,
        -300.0
      ],
      "bbox_max": [
        4044.14013671875,
        7450.0,
        1318.467529296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509035348892212,
        -0.9807853102684021,
        -0.0
      ],
      "plane_d": 7345.86865234375,
      "bbox_min": [
        100.0,
        4392.6396484375,
        -300.0
      ],
      "bbox_max": [
        4044.14013671875,
        7450.0,
        680.7955932617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.004390379413962364,
        -0.9486730098724365,
        0.31622809171676636
      ],
      "plane_d": 4789.4853515625,
      "bbox_min": [
        100.0,
        4392.6396484375,
        -300.0
      ],
      "bbox_max": [
        4044.14013671875,
        7450.0,
        680.7955932617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9449668526649475,
        0.08389011770486832,
        0.3162277042865753
      ],
      "plane_d": -187.74609375,
      "bbox_min": [
        140.185791015625,
        4947.96533203125,
        -300.0
      ],
      "bbox_max": [
        3977.864501953125,
        7267.0830078125,
        547.1160278320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555701851844788,
        -0.8314697742462158,
        -0.0
      ],
      "plane_d": 7440.36279296875,
      "bbox_min": [
        3108.39404296875,
        6290.52294921875,
        -22.699951171875
      ],
      "bbox_max": [
        3977.864501953125,
        6871.484375,
        547.1160278320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.05985559523105621,
        -0.9467930197715759,
        0.3162282705307007
      ],
      "plane_d": 6873.22802734375,
      "bbox_min": [
        231.0294647216797,
        7173.888671875,
        -300.0
      ],
      "bbox_max": [
        427.0267028808594,
        7267.0830078125,
        -58.07281494140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9449668526649475,
        0.08389011770486832,
        0.3162277042865753
      ],
      "plane_d": -187.74609375,
      "bbox_min": [
        100.0,
        5028.201171875,
        -300.0
      ],
      "bbox_max": [
        448.3017578125,
        7450.0,
        680.7955932617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509035348892212,
        -0.9807853102684021,
        0.0
      ],
      "plane_d": 7267.83251953125,
      "bbox_min": [
        100.0,
        7165.60498046875,
        -300.0
      ],
      "bbox_max": [
        448.3017578125,
        7450.0,
        680.7955932617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.05985559523105621,
        -0.9467930197715759,
        0.3162282705307007
      ],
      "plane_d": 6873.22802734375,
      "bbox_min": [
        100.0,
        7165.60498046875,
        -300.0
      ],
      "bbox_max": [
        448.3017578125,
        7287.82421875,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9035463333129883,
        -0.28914403915405273,
        0.31622743606567383
      ],
      "plane_d": 5019.0419921875,
      "bbox_min": [
        3895.162109375,
        4392.6396484375,
        -300.0
      ],
      "bbox_max": [
        4044.14013671875,
        4947.60009765625,
        -13.693594932556152
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05136118829250336,
        -0.319204717874527,
        0.9462930560112
      ],
      "plane_d": 1763.4461669921875,
      "bbox_min": [
        100.0,
        4628.8798828125,
        -107.56373596191406
      ],
      "bbox_max": [
        4035.890380859375,
        7450.0,
        1318.467529296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.567955493927002,
        -0.463673859834671,
        0.6800244450569153
      ],
      "plane_d": 4550.9375,
      "bbox_min": [
        816.3768920898438,
        4628.8798828125,
        -107.56373596191406
      ],
      "bbox_max": [
        4035.890380859375,
        7327.39501953125,
        723.3372802734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9035463333129883,
        -0.28914403915405273,
        0.31622743606567383
      ],
      "plane_d": 5019.0419921875,
      "bbox_min": [
        3966.75,
        4917.76171875,
        -22.481624603271484
      ],
      "bbox_max": [
        3973.222900390625,
        4951.876953125,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9035463333129883,
        -0.28914403915405273,
        0.31622743606567383
      ],
      "plane_d": 5019.0419921875,
      "bbox_min": [
        3970.173828125,
        4909.18798828125,
        -25.006759643554688
      ],
      "bbox_max": [
        4000.447998046875,
        4954.3212890625,
        24.79603385925293
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6118655800819397,
        -0.1958032250404358,
        0.7663430571556091
      ],
      "plane_d": 3398.80615234375,
      "bbox_min": [
        3970.173828125,
        4949.3115234375,
        0.0
      ],
      "bbox_max": [
        4000.447998046875,
        4954.3212890625,
        24.79603385925293
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.028518805280327797,
        -0.31919899582862854,
        0.947258472442627
      ],
      "plane_d": 1693.8587646484375,
      "bbox_min": [
        816.3768920898438,
        4628.8798828125,
        -107.56373596191406
      ],
      "bbox_max": [
        4035.890380859375,
        7327.39501953125,
        723.3372802734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509035348892212,
        -0.9807853102684021,
        -0.0
      ],
      "plane_d": 7345.86865234375,
      "bbox_min": [
        816.3768920898438,
        4628.8798828125,
        -107.56373596191406
      ],
      "bbox_max": [
        4035.890380859375,
        7327.39501953125,
        652.46484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9035463333129883,
        -0.28914403915405273,
        0.31622743606567383
      ],
      "plane_d": 5019.0419921875,
      "bbox_min": [
        3018.31005859375,
        4630.34521484375,
        -106.37005615234375
      ],
      "bbox_max": [
        4035.839111328125,
        6889.4033203125,
        624.2333984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6118655800819397,
        -0.1958032250404358,
        0.7663430571556091
      ],
      "plane_d": 3398.80615234375,
      "bbox_min": [
        3970.173828125,
        4882.0908203125,
        0.0
      ],
      "bbox_max": [
        3999.897216796875,
        4951.876953125,
        23.076147079467773
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509035348892212,
        -0.9807853102684021,
        -0.0
      ],
      "plane_d": 7345.86865234375,
      "bbox_min": [
        3018.31005859375,
        6830.28955078125,
        610.1199951171875
      ],
      "bbox_max": [
        3170.04638671875,
        6889.4033203125,
        624.2333984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555701851844788,
        -0.8314697742462158,
        -0.0
      ],
      "plane_d": 7440.36279296875,
      "bbox_min": [
        3108.39404296875,
        6830.28955078125,
        610.1199951171875
      ],
      "bbox_max": [
        3170.04638671875,
        6871.484375,
        623.0784912109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.567955493927002,
        -0.463673859834671,
        0.6800244450569153
      ],
      "plane_d": 4550.9375,
      "bbox_min": [
        100.0,
        5035.24365234375,
        -36.837890625
      ],
      "bbox_max": [
        4020.44775390625,
        7450.0,
        1187.3433837890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555701851844788,
        -0.8314697742462158,
        -0.0
      ],
      "plane_d": 7440.36279296875,
      "bbox_min": [
        3170.04638671875,
        6290.52294921875,
        474.2994384765625
      ],
      "bbox_max": [
        3977.864501953125,
        6830.28955078125,
        919.1775512695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555701851844788,
        -0.8314697742462158,
        -0.0
      ],
      "plane_d": 7440.36279296875,
      "bbox_min": [
        100.0,
        5035.24365234375,
        -36.837890625
      ],
      "bbox_max": [
        3977.864501953125,
        7450.0,
        976.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509035348892212,
        -0.9807853102684021,
        0.0
      ],
      "plane_d": 7267.83251953125,
      "bbox_min": [
        100.0,
        5035.24365234375,
        -36.837890625
      ],
      "bbox_max": [
        259.23272705078125,
        7450.0,
        976.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9449668526649475,
        0.08389011770486832,
        0.3162277042865753
      ],
      "plane_d": -187.74609375,
      "bbox_min": [
        235.99966430664062,
        5035.24365234375,
        -36.837890625
      ],
      "bbox_max": [
        259.23272705078125,
        5158.08642578125,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9035463333129883,
        -0.28914403915405273,
        0.31622743606567383
      ],
      "plane_d": 5019.0419921875,
      "bbox_min": [
        3956.206787109375,
        4680.0224609375,
        -65.90400695800781
      ],
      "bbox_max": [
        4034.1044921875,
        5071.1044921875,
        123.28406524658203
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.567955493927002,
        -0.463673859834671,
        0.6800244450569153
      ],
      "plane_d": 4550.9375,
      "bbox_min": [
        3958.969970703125,
        4954.3212890625,
        24.796052932739258
      ],
      "bbox_max": [
        4024.458251953125,
        5071.1044921875,
        123.28406524658203
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5238755941390991,
        -0.5008544921875,
        0.6889841556549072
      ],
      "plane_d": 4560.046875,
      "bbox_min": [
        3986.6806640625,
        4954.3212890625,
        24.796052932739258
      ],
      "bbox_max": [
        4024.458251953125,
        5037.267578125,
        101.1990966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.567955493927002,
        -0.463673859834671,
        0.6800244450569153
      ],
      "plane_d": 4550.9375,
      "bbox_min": [
        3956.206787109375,
        5039.52783203125,
        51.34784698486328
      ],
      "bbox_max": [
        3960.09619140625,
        5049.32275390625,
        57.08589172363281
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3932375907897949,
        -0.4582340121269226,
        0.797110915184021
      ],
      "plane_d": 2052.83154296875,
      "bbox_min": [
        -3400.0,
        3851.8251953125,
        -300.0
      ],
      "bbox_max": [
        100.0,
        7430.10888671875,
        1050.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509035348892212,
        -0.9807853102684021,
        0.0
      ],
      "plane_d": 7267.83251953125,
      "bbox_min": [
        -2778.40673828125,
        4169.818359375,
        -300.0
      ],
      "bbox_max": [
        100.0,
        7430.10888671875,
        1050.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8558866381645203,
        -0.018606234341859818,
        0.5168285369873047
      ],
      "plane_d": 228.558349609375,
      "bbox_min": [
        -2778.40673828125,
        4169.818359375,
        -300.0
      ],
      "bbox_max": [
        100.0,
        7265.8046875,
        1050.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9484592080116272,
        -0.020618677139282227,
        0.3162277638912201
      ],
      "plane_d": 291.7543029785156,
      "bbox_min": [
        -2778.40673828125,
        4169.818359375,
        -300.0
      ],
      "bbox_max": [
        69.84530639648438,
        7252.56787109375,
        150.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9319282174110413,
        -0.1775101274251938,
        0.31622785329818726
      ],
      "plane_d": 1065.060791015625,
      "bbox_min": [
        -2778.40673828125,
        4169.818359375,
        -300.0
      ],
      "bbox_max": [
        -100.20496368408203,
        6871.484375,
        150.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5555701851844788,
        -0.8314697742462158,
        0.0
      ],
      "plane_d": 7218.134765625,
      "bbox_min": [
        -2778.40673828125,
        6824.70361328125,
        -22.699951171875
      ],
      "bbox_max": [
        -2708.39404296875,
        6871.484375,
        38.732234954833984
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.05985559523105621,
        -0.9467930197715759,
        0.3162282705307007
      ],
      "plane_d": 6873.22802734375,
      "bbox_min": [
        -150.0,
        7155.99462890625,
        -300.0
      ],
      "bbox_max": [
        69.84530639648438,
        7252.56787109375,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.05985559523105621,
        -0.9467930197715759,
        0.3162282705307007
      ],
      "plane_d": 6873.22802734375,
      "bbox_min": [
        -109.37823486328125,
        7163.69873046875,
        -300.0
      ],
      "bbox_max": [
        100.0,
        7265.8046875,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509035348892212,
        -0.9807853102684021,
        0.0
      ],
      "plane_d": 7267.83251953125,
      "bbox_min": [
        -3400.0,
        3851.8251953125,
        -300.0
      ],
      "bbox_max": [
        -246.8081817626953,
        7178.380859375,
        976.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555701851844788,
        -0.8314697742462158,
        0.0
      ],
      "plane_d": 7218.134765625,
      "bbox_min": [
        -3400.0,
        3851.8251953125,
        -300.0
      ],
      "bbox_max": [
        -246.8081817626953,
        6871.484375,
        976.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9319281578063965,
        -0.1775101125240326,
        0.31622785329818726
      ],
      "plane_d": 1065.0606689453125,
      "bbox_min": [
        -619.7982788085938,
        3851.8251953125,
        -300.0
      ],
      "bbox_max": [
        -246.8081817626953,
        4955.25732421875,
        150.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.40394648909568787,
        -0.8583862781524658,
        0.31622806191444397
      ],
      "plane_d": 3509.28515625,
      "bbox_min": [
        -619.7982788085938,
        3851.8251953125,
        -113.45060729980469
      ],
      "bbox_max": [
        -366.4575500488281,
        3934.389892578125,
        150.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3970937132835388,
        0.6701478362083435,
        0.6270713210105896
      ],
      "plane_d": -1075.6932373046875,
      "bbox_min": [
        3966.056884765625,
        3861.65869140625,
        65.54586791992188
      ],
      "bbox_max": [
        4060.7236328125,
        3949.339111328125,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -0.0,
      "bbox_min": [
        -3400.0,
        -150.0,
        -300.0
      ],
      "bbox_max": [
        2992.29638671875,
        3879.621826171875,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1010662093758583,
        -0.9432846307754517,
        0.3162275552749634
      ],
      "plane_d": 3427.828857421875,
      "bbox_min": [
        -2700.0,
        1230.0,
        -300.0
      ],
      "bbox_max": [
        319.0323181152344,
        3879.621826171875,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.40394654870033264,
        -0.8583863973617554,
        0.31622761487960815
      ],
      "plane_d": 3509.285400390625,
      "bbox_min": [
        -1250.0,
        3402.360107421875,
        -300.0
      ],
      "bbox_max": [
        -302.08367919921875,
        3879.621826171875,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9319282174110413,
        -0.1775101274251938,
        0.31622785329818726
      ],
      "plane_d": 1065.060791015625,
      "bbox_min": [
        -366.4575500488281,
        3831.220458984375,
        -300.0
      ],
      "bbox_max": [
        -302.08367919921875,
        3879.621826171875,
        -113.45060729980469
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 10.0,
      "bbox_min": [
        -2700.0,
        1230.0,
        -300.0
      ],
      "bbox_max": [
        319.0323181152344,
        2670.0,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9486832618713379,
        0.0,
        0.3162277638912201
      ],
      "plane_d": 1755.0640869140625,
      "bbox_min": [
        -1880.0,
        1230.0,
        -300.0
      ],
      "bbox_max": [
        317.7317199707031,
        2670.0,
        -10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1750.0,
      "bbox_min": [
        -1880.0,
        1750.0,
        -30.0
      ],
      "bbox_max": [
        -1840.0,
        1950.0,
        -10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 1949.9998779296875,
      "bbox_min": [
        -1880.0,
        1950.0,
        -30.0
      ],
      "bbox_max": [
        -1840.0,
        1950.0,
        -10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9486832618713379,
        0.3162277638912201
      ],
      "plane_d": -1434.4090576171875,
      "bbox_min": [
        -1846.6668701171875,
        1515.3333740234375,
        -300.0
      ],
      "bbox_max": [
        317.7317199707031,
        2670.0,
        -10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9486833214759827,
        0.0,
        0.3162277638912201
      ],
      "plane_d": 1451.4854736328125,
      "bbox_min": [
        -1846.6668701171875,
        1515.3333740234375,
        -300.0
      ],
      "bbox_max": [
        317.7317199707031,
        2670.0,
        -10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9486832618713379,
        0.3162277638912201
      ],
      "plane_d": 1992.23486328125,
      "bbox_min": [
        -1846.6668701171875,
        1750.0,
        -300.0
      ],
      "bbox_max": [
        -1430.0,
        2096.666748046875,
        -10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1840.0,
      "bbox_min": [
        -1846.6668701171875,
        1750.0,
        -30.0
      ],
      "bbox_max": [
        -1840.0,
        2000.0,
        -10.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1750.0,
      "bbox_min": [
        -1846.6668701171875,
        1750.0,
        -30.0
      ],
      "bbox_max": [
        -1840.0,
        1950.0,
        -10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 1949.9998779296875,
      "bbox_min": [
        -1846.6668701171875,
        1950.0,
        -30.0
      ],
      "bbox_max": [
        -1840.0,
        1950.0,
        -10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5270602107048035,
        0.7888013124465942,
        0.31622767448425293
      ],
      "plane_d": -1264.458984375,
      "bbox_min": [
        28.08397674560547,
        1515.3333740234375,
        -300.0
      ],
      "bbox_max": [
        317.7317199707031,
        1910.3818359375,
        -10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7888013124465942,
        0.5270602107048035,
        0.3162277936935425
      ],
      "plane_d": -754.0639038085938,
      "bbox_min": [
        28.08397674560547,
        1515.3333740234375,
        -300.0
      ],
      "bbox_max": [
        205.60003662109375,
        1814.0926513671875,
        -10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9304545521736145,
        0.1850789338350296,
        0.3162277638912201
      ],
      "plane_d": -177.34805297851562,
      "bbox_min": [
        28.08397674560547,
        1515.3333740234375,
        -300.0
      ],
      "bbox_max": [
        130.67605590820312,
        1669.9857177734375,
        -10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2700.0,
      "bbox_min": [
        -2700.0,
        1326.6666259765625,
        -10.000000953674316
      ],
      "bbox_max": [
        319.0323181152344,
        2573.333251953125,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9486832618713379,
        0.0,
        0.3162277638912201
      ],
      "plane_d": 1755.0640869140625,
      "bbox_min": [
        -1880.0,
        1326.6666259765625,
        -10.000000953674316
      ],
      "bbox_max": [
        319.0323181152344,
        2573.333251953125,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1750.0,
      "bbox_min": [
        -1880.0,
        1750.0,
        -10.0
      ],
      "bbox_max": [
        -1846.6668701171875,
        1950.0,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 1949.9998779296875,
      "bbox_min": [
        -1880.0,
        1950.0,
        -10.0
      ],
      "bbox_max": [
        -1846.6668701171875,
        1950.0,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9486832618713379,
        0.3162277638912201
      ],
      "plane_d": -1434.4090576171875,
      "bbox_min": [
        -1850.0001220703125,
        1512.0,
        -10.000000953674316
      ],
      "bbox_max": [
        319.0323181152344,
        2573.333251953125,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9486833214759827,
        0.0,
        0.3162277638912201
      ],
      "plane_d": 1451.4854736328125,
      "bbox_min": [
        -1850.0001220703125,
        1512.0,
        -10.000000953674316
      ],
      "bbox_max": [
        319.0323181152344,
        2573.333251953125,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9486832618713379,
        0.3162277638912201
      ],
      "plane_d": 1992.23486328125,
      "bbox_min": [
        -1850.0001220703125,
        1750.0,
        -10.000000953674316
      ],
      "bbox_max": [
        -1526.6666259765625,
        2100.0,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1840.0,
      "bbox_min": [
        -1850.0001220703125,
        1750.0,
        -10.0
      ],
      "bbox_max": [
        -1840.0,
        2000.0,
        0.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1750.0,
      "bbox_min": [
        -1850.0001220703125,
        1750.0,
        -10.0
      ],
      "bbox_max": [
        -1840.0,
        1950.0,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 1949.9998779296875,
      "bbox_min": [
        -1850.0001220703125,
        1950.0,
        -10.0
      ],
      "bbox_max": [
        -1840.0,
        1950.0,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5270602107048035,
        0.7888013124465942,
        0.31622767448425293
      ],
      "plane_d": -1264.458984375,
      "bbox_min": [
        107.416259765625,
        1512.0,
        -10.000000953674316
      ],
      "bbox_max": [
        319.0323181152344,
        1819.3238525390625,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7888013124465942,
        0.5270602107048035,
        0.3162277936935425
      ],
      "plane_d": -754.0639038085938,
      "bbox_min": [
        107.416259765625,
        1512.0,
        -10.000000953674316
      ],
      "bbox_max": [
        208.00323486328125,
        1744.39990234375,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9304545521736145,
        0.1850789338350296,
        0.3162277638912201
      ],
      "plane_d": -177.34805297851562,
      "bbox_min": [
        107.416259765625,
        1512.0,
        -10.000000953674316
      ],
      "bbox_max": [
        133.8159942626953,
        1632.268310546875,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10106618702411652,
        -0.9432844519615173,
        0.3162279725074768
      ],
      "plane_d": 3427.828369140625,
      "bbox_min": [
        -2652.67138671875,
        3400.0,
        0.0
      ],
      "bbox_max": [
        -475.55438232421875,
        3864.445068359375,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.40394648909568787,
        -0.8583862781524658,
        0.31622806191444397
      ],
      "plane_d": 3509.28515625,
      "bbox_min": [
        -1263.684326171875,
        3500.0,
        0.0
      ],
      "bbox_max": [
        -475.55438232421875,
        3864.445068359375,
        150.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2700.0,
      "bbox_min": [
        -3400.0,
        -150.0,
        0.0
      ],
      "bbox_max": [
        2200.0,
        3400.0,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5567466616630554,
        -0.7170891761779785,
        0.41930466890335083
      ],
      "plane_d": 3860.257568359375,
      "bbox_min": [
        -3400.0,
        1330.0,
        0.0
      ],
      "bbox_max": [
        -2700.0,
        3381.37744140625,
        426.8134765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5895066857337952,
        -0.7432910799980164,
        0.3162282407283783
      ],
      "plane_d": 4052.2177734375,
      "bbox_min": [
        -3400.0,
        2755.17236328125,
        0.0
      ],
      "bbox_max": [
        -2700.0,
        3372.810546875,
        146.8248748779297
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9974586963653564,
        0.07124704867601395
      ],
      "plane_d": -1360.818603515625,
      "bbox_min": [
        -2720.0,
        1330.0,
        200.0
      ],
      "bbox_max": [
        -2700.0,
        2570.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9974586963653564,
        -0.0,
        0.07124704867601395
      ],
      "plane_d": 2678.888916015625,
      "bbox_min": [
        -2710.0,
        1330.0,
        200.0
      ],
      "bbox_max": [
        -2700.0,
        1350.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9974586963653564,
        0.07124704867601395
      ],
      "plane_d": 2529.270263671875,
      "bbox_min": [
        -2720.0,
        2550.0,
        200.0
      ],
      "bbox_max": [
        -2700.0,
        2570.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9974586963653564,
        -0.0,
        0.07124704867601395
      ],
      "plane_d": 2678.888916015625,
      "bbox_min": [
        -2710.0,
        2550.0,
        200.0
      ],
      "bbox_max": [
        -2700.0,
        2570.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -690.0,
      "bbox_min": [
        -2700.0,
        -150.0,
        0.0
      ],
      "bbox_max": [
        2200.0,
        3400.0,
        1180.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.8825817704200745,
        0.14508481323719025,
        0.4472133219242096
      ],
      "plane_d": 1239.3453369140625,
      "bbox_min": [
        -1580.0,
        86.37356567382812,
        0.0
      ],
      "bbox_max": [
        -1418.4259033203125,
        690.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": 1579.9998779296875,
      "bbox_min": [
        -1580.0,
        415.0,
        60.0
      ],
      "bbox_max": [
        -1580.0,
        460.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -650.0,
      "bbox_min": [
        -1665.0,
        423.6956481933594,
        100.0
      ],
      "bbox_max": [
        254.0325927734375,
        690.0,
        420.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -440.0,
      "bbox_min": [
        -1665.0,
        423.6956481933594,
        100.0
      ],
      "bbox_max": [
        -1560.0,
        480.0,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1580.0,
      "bbox_min": [
        -1580.0,
        423.6956481933594,
        100.0
      ],
      "bbox_max": [
        -1560.0,
        440.0,
        170.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": 1559.9998779296875,
      "bbox_min": [
        -1560.0,
        435.0,
        140.0
      ],
      "bbox_max": [
        -1560.0,
        440.0,
        170.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": 1559.9998779296875,
      "bbox_min": [
        -1580.0,
        440.0,
        100.0
      ],
      "bbox_max": [
        -1560.0,
        480.0,
        170.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 280.0,
      "bbox_min": [
        -100.0,
        650.0,
        160.0
      ],
      "bbox_max": [
        254.0325927734375,
        690.0,
        420.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 350.0,
      "bbox_min": [
        -100.0,
        650.0,
        280.0
      ],
      "bbox_max": [
        254.0325927734375,
        690.0,
        420.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -1.0,
        9.536743306171047e-08,
        0.0
      ],
      "plane_d": 254.03253173828125,
      "bbox_min": [
        254.0325927734375,
        650.0,
        350.0
      ],
      "bbox_max": [
        254.0325927734375,
        690.0,
        420.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 100.0,
      "bbox_min": [
        -100.0,
        650.0,
        280.0
      ],
      "bbox_max": [
        254.0325927734375,
        690.0,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        9.536743306171047e-08,
        0.0
      ],
      "plane_d": 254.03253173828125,
      "bbox_min": [
        254.0325927734375,
        650.0,
        280.0
      ],
      "bbox_max": [
        254.0325927734375,
        690.0,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 210.0,
      "bbox_min": [
        -100.0,
        650.0,
        160.0
      ],
      "bbox_max": [
        254.0325927734375,
        690.0,
        280.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        9.536743306171047e-08,
        0.0
      ],
      "plane_d": 254.03253173828125,
      "bbox_min": [
        254.0325927734375,
        650.0,
        210.0
      ],
      "bbox_max": [
        254.0325927734375,
        690.0,
        280.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 100.0,
      "bbox_min": [
        -100.0,
        650.0,
        160.0
      ],
      "bbox_max": [
        254.0325927734375,
        690.0,
        210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        9.536743306171047e-08,
        0.0
      ],
      "plane_d": 254.03253173828125,
      "bbox_min": [
        254.0325927734375,
        650.0,
        160.0
      ],
      "bbox_max": [
        254.0325927734375,
        690.0,
        210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1830.0,
      "bbox_min": [
        1645.0,
        1654.800048828125,
        500.0
      ],
      "bbox_max": [
        2130.0,
        1940.0999755859375,
        1180.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9688333868980408,
        -0.24771343171596527,
        -0.0
      ],
      "plane_d": 2410.359130859375,
      "bbox_min": [
        1660.0,
        1830.0,
        500.0
      ],
      "bbox_max": [
        2020.0,
        1940.0999755859375,
        1150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2740.887451171875,
      "bbox_min": [
        1660.0,
        1830.0,
        500.0
      ],
      "bbox_max": [
        2020.0,
        1940.0999755859375,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5996253490447998,
        -0.5996253490447998,
        -0.5299990773200989
      ],
      "plane_d": 2843.6669921875,
      "bbox_min": [
        1660.0,
        1830.0,
        980.0
      ],
      "bbox_max": [
        2020.0,
        1940.0999755859375,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1060.0,
      "bbox_min": [
        1865.3895263671875,
        1830.0,
        1060.0
      ],
      "bbox_max": [
        2020.0,
        1940.0999755859375,
        1130.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        1892.56787109375,
        1830.0,
        1130.0
      ],
      "bbox_max": [
        1971.7369384765625,
        1891.7369384765625,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1060.0,
      "bbox_min": [
        1660.0,
        1830.0,
        980.0
      ],
      "bbox_max": [
        1975.489501953125,
        1940.0999755859375,
        1130.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        1852.5001220703125,
        1830.375,
        1110.0
      ],
      "bbox_max": [
        1913.2427978515625,
        1851.050048828125,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1110.0,
      "bbox_min": [
        1852.5001220703125,
        1841.2916259765625,
        1110.0
      ],
      "bbox_max": [
        1873.0001220703125,
        1848.516845703125,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        3.75290255760774e-06
      ],
      "plane_d": 2632.51416015625,
      "bbox_min": [
        1675.58154296875,
        1830.0,
        1060.0
      ],
      "bbox_max": [
        1913.6177978515625,
        1846.6507568359375,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        1885.0001220703125,
        1830.0,
        1130.0
      ],
      "bbox_max": [
        1913.6177978515625,
        1837.9423828125,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1110.0,
      "bbox_min": [
        1848.03857421875,
        1830.0,
        1110.0
      ],
      "bbox_max": [
        1872.5,
        1846.6507568359375,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2499.056640625,
      "bbox_min": [
        1668.9998779296875,
        1830.0,
        980.0
      ],
      "bbox_max": [
        1704.19970703125,
        1865.1998291015625,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        8.719300694792764e-07,
        0.0
      ],
      "plane_d": 1659.9984130859375,
      "bbox_min": [
        1658.9056396484375,
        1654.800048828125,
        1059.6480712890625
      ],
      "bbox_max": [
        2020.0,
        1830.0,
        1180.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1060.0,
      "bbox_min": [
        1659.9998779296875,
        1654.800048828125,
        1059.6480712890625
      ],
      "bbox_max": [
        2020.0,
        1830.0,
        1130.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        1660.0,
        1720.0,
        1060.0
      ],
      "bbox_max": [
        1961.243408203125,
        1830.0,
        1130.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.9659263491630554,
        -0.2588171064853668,
        3.2501047826372087e-06
      ],
      "plane_d": 2319.75244140625,
      "bbox_min": [
        1800.0,
        1720.0,
        1060.0
      ],
      "bbox_max": [
        1930.0001220703125,
        1830.0,
        1130.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        3.75290255760774e-06
      ],
      "plane_d": 2632.51416015625,
      "bbox_min": [
        1800.0,
        1720.0,
        1060.0
      ],
      "bbox_max": [
        1917.9425048828125,
        1830.0,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1110.0,
      "bbox_min": [
        1800.0,
        1720.0,
        1110.0
      ],
      "bbox_max": [
        1880.0,
        1830.0,
        1110.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5996253490447998,
        -0.5996253490447998,
        -0.5299990773200989
      ],
      "plane_d": 2843.6669921875,
      "bbox_min": [
        1704.19970703125,
        1829.844482421875,
        1059.6480712890625
      ],
      "bbox_max": [
        1975.800048828125,
        1830.0,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2499.056640625,
      "bbox_min": [
        1704.19970703125,
        1829.844482421875,
        1059.6480712890625
      ],
      "bbox_max": [
        1704.355224609375,
        1830.0,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        1658.9056396484375,
        1767.4713134765625,
        1130.0
      ],
      "bbox_max": [
        1660.0,
        1771.8487548828125,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1530.0,
      "bbox_min": [
        -2700.0,
        2550.0,
        0.0
      ],
      "bbox_max": [
        -1530.0,
        3400.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10106618702411652,
        -0.9432844519615173,
        0.3162279725074768
      ],
      "plane_d": 3427.828369140625,
      "bbox_min": [
        -2700.0,
        2550.0,
        0.0
      ],
      "bbox_max": [
        -1530.0,
        3400.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5895066857337952,
        -0.7432910799980164,
        0.3162282407283783
      ],
      "plane_d": 4052.2177734375,
      "bbox_min": [
        -2700.0,
        2550.0,
        0.0
      ],
      "bbox_max": [
        -1530.0,
        3398.1728515625,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5567466616630554,
        -0.7170891761779785,
        0.41930466890335083
      ],
      "plane_d": 3860.257568359375,
      "bbox_min": [
        -2700.0,
        3372.810546875,
        146.8248748779297
      ],
      "bbox_max": [
        -2669.724609375,
        3398.1728515625,
        161.4759979248047
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9974586963653564,
        0.07124704867601395
      ],
      "plane_d": 2529.270263671875,
      "bbox_min": [
        -1550.0,
        2550.0,
        200.0
      ],
      "bbox_max": [
        -1530.0,
        2570.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9974586963653564,
        0.0,
        0.07124704867601395
      ],
      "plane_d": 1511.8624267578125,
      "bbox_min": [
        -1540.0,
        2550.0,
        200.0
      ],
      "bbox_max": [
        -1530.0,
        2570.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 2100.0,
      "bbox_min": [
        -1900.0,
        690.0,
        0.0
      ],
      "bbox_max": [
        -1517.6541748046875,
        2550.0,
        556.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1530.0,
      "bbox_min": [
        -1870.0,
        2100.0,
        0.0
      ],
      "bbox_max": [
        -1530.0,
        2550.0,
        556.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3594778776168823,
        -0.9298421740531921,
        0.07854465395212173
      ],
      "plane_d": 1490.041259765625,
      "bbox_min": [
        -1870.0,
        2100.0,
        130.0
      ],
      "bbox_max": [
        -1530.0,
        2381.661376953125,
        485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3594779074192047,
        -0.9298422336578369,
        0.07854417711496353
      ],
      "plane_d": 2730.958984375,
      "bbox_min": [
        -1753.12744140625,
        2280.72119140625,
        130.0
      ],
      "bbox_max": [
        -1661.9405517578125,
        2381.661376953125,
        485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9112057685852051,
        -0.4043944478034973,
        0.07854446023702621
      ],
      "plane_d": 2450.442138671875,
      "bbox_min": [
        -1753.12744140625,
        2298.338623046875,
        130.0
      ],
      "bbox_max": [
        -1661.9405517578125,
        2381.661376953125,
        485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9112057685852051,
        0.4043944180011749,
        0.07854437828063965
      ],
      "plane_d": 557.8760986328125,
      "bbox_min": [
        -1753.12744140625,
        2306.16845703125,
        130.0
      ],
      "bbox_max": [
        -1661.9405517578125,
        2381.661376953125,
        485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9327210783958435,
        -0.3605981171131134,
        0.0006637438200414181
      ],
      "plane_d": 2436.640869140625,
      "bbox_min": [
        -1753.12744140625,
        2306.16845703125,
        426.8799133300781
      ],
      "bbox_max": [
        -1688.00927734375,
        2364.470947265625,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.33692970871925354,
        -0.8735808730125427,
        -0.3511906564235687
      ],
      "plane_d": 1582.708251953125,
      "bbox_min": [
        -1753.12744140625,
        2306.16845703125,
        426.9013977050781
      ],
      "bbox_max": [
        -1726.9332275390625,
        2316.288330078125,
        426.95050048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8563946485519409,
        -0.37830743193626404,
        -0.35138562321662903
      ],
      "plane_d": 2480.470947265625,
      "bbox_min": [
        -1697.4476318359375,
        2317.655517578125,
        426.8799133300781
      ],
      "bbox_max": [
        -1688.00927734375,
        2338.953369140625,
        426.9678039550781
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9327210783958435,
        -0.3605981171131134,
        0.0006637438200414181
      ],
      "plane_d": 2436.640869140625,
      "bbox_min": [
        -1699.8333740234375,
        2340.0,
        429.07421875
      ],
      "bbox_max": [
        -1690.385986328125,
        2375.278076171875,
        485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9140291213989258,
        0.40564870834350586,
        -0.0
      ],
      "plane_d": 595.8441162109375,
      "bbox_min": [
        -1699.8333740234375,
        2340.0,
        460.0
      ],
      "bbox_max": [
        -1690.385986328125,
        2375.278076171875,
        485.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9327212572097778,
        -0.3605981767177582,
        0.0
      ],
      "plane_d": 2436.946533203125,
      "bbox_min": [
        -1699.8333740234375,
        2361.287353515625,
        460.0
      ],
      "bbox_max": [
        -1694.4244384765625,
        2375.278076171875,
        485.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8563946485519409,
        -0.37830743193626404,
        -0.35138562321662903
      ],
      "plane_d": 2480.470947265625,
      "bbox_min": [
        -1699.8333740234375,
        2317.318359375,
        426.8799133300781
      ],
      "bbox_max": [
        -1676.675537109375,
        2342.42822265625,
        485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4056476056575775,
        -0.914029598236084,
        -4.599850217346102e-05
      ],
      "plane_d": 1429.85986328125,
      "bbox_min": [
        -1699.8333740234375,
        2317.318359375,
        426.8799133300781
      ],
      "bbox_max": [
        -1676.675537109375,
        2342.42822265625,
        485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9140291213989258,
        -0.40564870834350586,
        0.0
      ],
      "plane_d": 2479.280029296875,
      "bbox_min": [
        -1691.463623046875,
        2326.370849609375,
        460.0
      ],
      "bbox_max": [
        -1676.675537109375,
        2342.42822265625,
        485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9140291213989258,
        0.40564870834350586,
        -0.0
      ],
      "plane_d": 595.8441162109375,
      "bbox_min": [
        -1691.463623046875,
        2340.0,
        460.0
      ],
      "bbox_max": [
        -1690.385986328125,
        2342.42822265625,
        485.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8560824394226074,
        -0.37993180751800537,
        -0.35039231181144714
      ],
      "plane_d": 2483.28173828125,
      "bbox_min": [
        -1726.0,
        2308.596435546875,
        429.10107421875
      ],
      "bbox_max": [
        -1679.344970703125,
        2327.900390625,
        485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4056476056575775,
        -0.914029598236084,
        -4.599850217346102e-05
      ],
      "plane_d": 1429.85986328125,
      "bbox_min": [
        -1726.0,
        2308.596435546875,
        429.10107421875
      ],
      "bbox_max": [
        -1679.344970703125,
        2327.900390625,
        485.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.9140291213989258,
        -0.40564870834350586,
        0.0
      ],
      "plane_d": 2479.280029296875,
      "bbox_min": [
        -1686.1229248046875,
        2312.6279296875,
        460.0
      ],
      "bbox_max": [
        -1679.344970703125,
        2327.900390625,
        475.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3605971038341522,
        -0.9327216744422913,
        0.0
      ],
      "plane_d": 2775.668701171875,
      "bbox_min": [
        -1726.0,
        2308.596435546875,
        460.0
      ],
      "bbox_max": [
        -1699.8333740234375,
        2318.712646484375,
        485.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.9974586963653564,
        0.07124704867601395
      ],
      "plane_d": 2080.4140625,
      "bbox_min": [
        -1870.0,
        2100.0,
        200.0
      ],
      "bbox_max": [
        -1530.0,
        2316.288330078125,
        485.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9974586963653564,
        -0.0,
        0.07124704867601395
      ],
      "plane_d": 1831.0491943359375,
      "bbox_min": [
        -1860.0,
        2100.0,
        200.0
      ],
      "bbox_max": [
        -1530.0,
        2316.288330078125,
        485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9974586963653564,
        -0.0,
        0.07124704867601395
      ],
      "plane_d": 1511.8624267578125,
      "bbox_min": [
        -1757.5755615234375,
        2100.0,
        200.0
      ],
      "bbox_max": [
        -1530.0,
        2316.288330078125,
        485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.33770379424095154,
        -0.873505711555481,
        -0.35063353180885315
      ],
      "plane_d": 1580.939208984375,
      "bbox_min": [
        -1757.5755615234375,
        2294.605712890625,
        426.90142822265625
      ],
      "bbox_max": [
        -1723.2684326171875,
        2316.288330078125,
        485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.33692970871925354,
        -0.8735808730125427,
        -0.3511906564235687
      ],
      "plane_d": 1582.708251953125,
      "bbox_min": [
        -1757.5755615234375,
        2294.605712890625,
        426.90142822265625
      ],
      "bbox_max": [
        -1723.2684326171875,
        2316.288330078125,
        485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9327212572097778,
        -0.3605981767177582,
        -3.2999985705828294e-05
      ],
      "plane_d": 2442.36767578125,
      "bbox_min": [
        -1757.5755615234375,
        2294.605712890625,
        426.951171875
      ],
      "bbox_max": [
        -1723.2684326171875,
        2309.652587890625,
        485.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.3605971038341522,
        -0.9327216744422913,
        0.0
      ],
      "plane_d": 1515.887451171875,
      "bbox_min": [
        -1757.5755615234375,
        2294.605712890625,
        460.0
      ],
      "bbox_max": [
        -1731.408935546875,
        2304.721923828125,
        475.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3605971038341522,
        -0.9327216744422913,
        0.0
      ],
      "plane_d": 2775.668701171875,
      "bbox_min": [
        -1726.0,
        2308.596435546875,
        460.0
      ],
      "bbox_max": [
        -1723.2684326171875,
        2309.652587890625,
        485.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3605971038341522,
        -0.9327216744422913,
        0.0
      ],
      "plane_d": 2775.668701171875,
      "bbox_min": [
        -1752.1666259765625,
        2308.596435546875,
        485.0
      ],
      "bbox_max": [
        -1690.385986328125,
        2361.287353515625,
        531.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3605971038341522,
        -0.9327216744422913,
        0.0
      ],
      "plane_d": 1530.88720703125,
      "bbox_min": [
        -1752.1666259765625,
        2308.596435546875,
        485.0
      ],
      "bbox_max": [
        -1690.385986328125,
        2361.287353515625,
        531.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9140291213989258,
        0.40564870834350586,
        -0.0
      ],
      "plane_d": 595.8441162109375,
      "bbox_min": [
        -1699.8333740234375,
        2318.712646484375,
        485.0
      ],
      "bbox_max": [
        -1690.385986328125,
        2361.287353515625,
        531.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9140291213989258,
        -0.40564870834350586,
        0.0
      ],
      "plane_d": 2494.280029296875,
      "bbox_min": [
        -1699.8333740234375,
        2318.712646484375,
        485.0
      ],
      "bbox_max": [
        -1690.385986328125,
        2340.0,
        531.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34209343791007996,
        -0.884858250617981,
        0.31622451543807983
      ],
      "plane_d": 2457.4130859375,
      "bbox_min": [
        -1755.8980712890625,
        2303.23583984375,
        531.0
      ],
      "bbox_max": [
        -1684.9156494140625,
        2376.76416015625,
        556.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3420935571193695,
        -0.8848586082458496,
        0.3162234425544739
      ],
      "plane_d": 1276.5076904296875,
      "bbox_min": [
        -1755.8980712890625,
        2303.23583984375,
        531.0
      ],
      "bbox_max": [
        -1684.9156494140625,
        2376.76416015625,
        556.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3225288689136505,
        0.834254264831543,
        -0.44720810651779175
      ],
      "plane_d": -1184.201171875,
      "bbox_min": [
        -1755.8980712890625,
        2303.23583984375,
        531.0
      ],
      "bbox_max": [
        -1684.9156494140625,
        2376.76416015625,
        556.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32252857089042664,
        -0.8342534899711609,
        -0.44720956683158875
      ],
      "plane_d": 2720.107421875,
      "bbox_min": [
        -1755.8980712890625,
        2303.23583984375,
        531.0
      ],
      "bbox_max": [
        -1684.9156494140625,
        2365.205322265625,
        556.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3225288689136505,
        -0.834254264831543,
        -0.44720810651779175
      ],
      "plane_d": 1606.739013671875,
      "bbox_min": [
        -1755.8980712890625,
        2303.23583984375,
        531.0
      ],
      "bbox_max": [
        -1684.9156494140625,
        2365.205322265625,
        556.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8671222925186157,
        0.38483428955078125,
        0.31623005867004395
      ],
      "plane_d": 389.4351806640625,
      "bbox_min": [
        -1699.8333740234375,
        2314.794677734375,
        531.0
      ],
      "bbox_max": [
        -1684.9156494140625,
        2365.205322265625,
        556.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.867123544216156,
        -0.38483482599258423,
        0.3162263035774231
      ],
      "plane_d": 2190.465087890625,
      "bbox_min": [
        -1699.8333740234375,
        2314.794677734375,
        531.0
      ],
      "bbox_max": [
        -1684.9156494140625,
        2365.205322265625,
        556.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8175309300422668,
        0.3628225326538086,
        -0.4472169280052185
      ],
      "plane_d": 770.4102783203125,
      "bbox_min": [
        -1699.8333740234375,
        2314.794677734375,
        531.0
      ],
      "bbox_max": [
        -1684.9156494140625,
        2365.205322265625,
        541.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8175334930419922,
        -0.3628236651420593,
        -0.447211354970932
      ],
      "plane_d": 2468.423828125,
      "bbox_min": [
        -1699.8333740234375,
        2314.794677734375,
        531.0
      ],
      "bbox_max": [
        -1684.9156494140625,
        2340.0,
        541.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1750.0,
      "bbox_min": [
        -1900.0,
        690.0,
        0.0
      ],
      "bbox_max": [
        -1517.6541748046875,
        2100.0,
        340.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1850.0,
      "bbox_min": [
        -1870.0,
        690.0,
        0.0
      ],
      "bbox_max": [
        -1517.6541748046875,
        1750.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9974586963653564,
        0.07124704867601395
      ],
      "plane_d": -1360.818603515625,
      "bbox_min": [
        -1870.0,
        1330.0,
        200.0
      ],
      "bbox_max": [
        -1850.0,
        1350.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9974586963653564,
        0.07124704867601395
      ],
      "plane_d": 1312.37060546875,
      "bbox_min": [
        -1870.0,
        1330.0,
        200.0
      ],
      "bbox_max": [
        -1850.0,
        1350.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9974586963653564,
        -0.0,
        0.07124704867601395
      ],
      "plane_d": 1831.0491943359375,
      "bbox_min": [
        -1860.0,
        1330.0,
        200.0
      ],
      "bbox_max": [
        -1850.0,
        1350.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8825817704200745,
        0.14508481323719025,
        0.4472133219242096
      ],
      "plane_d": 1239.3453369140625,
      "bbox_min": [
        -1551.5946044921875,
        690.0,
        0.0
      ],
      "bbox_max": [
        -1517.6541748046875,
        728.8226928710938,
        66.98198699951172
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1850.0,
      "bbox_min": [
        -1850.0,
        2000.0,
        0.0
      ],
      "bbox_max": [
        -1850.0,
        2100.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1950.0,
      "bbox_min": [
        -1900.0,
        1750.0,
        0.0
      ],
      "bbox_max": [
        -1815.0,
        2000.0,
        225.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1840.0,
      "bbox_min": [
        -1840.0,
        1950.0,
        0.0
      ],
      "bbox_max": [
        -1820.0,
        2000.0,
        225.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1820.0,
      "bbox_min": [
        -1820.0,
        1950.0,
        185.0
      ],
      "bbox_max": [
        -1820.0,
        2000.0,
        225.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1840.0,
      "bbox_min": [
        -1880.0,
        1750.0,
        0.0
      ],
      "bbox_max": [
        -1820.0,
        1950.0,
        225.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 185.0,
      "bbox_min": [
        -1880.0,
        1800.0,
        185.0
      ],
      "bbox_max": [
        -1840.0,
        1950.0,
        185.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8682432174682617,
        0.0,
        -0.49613896012306213
      ],
      "plane_d": 1671.9884033203125,
      "bbox_min": [
        -1840.0,
        1750.0,
        150.0
      ],
      "bbox_max": [
        -1820.0,
        1800.0,
        225.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1820.0,
      "bbox_min": [
        -1820.0,
        1750.0,
        185.0
      ],
      "bbox_max": [
        -1820.0,
        1800.0,
        225.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.980580747127533,
        0.1961161494255066
      ],
      "plane_d": -1482.6380615234375,
      "bbox_min": [
        -599.2283325195312,
        1500.0,
        0.0
      ],
      "bbox_max": [
        190.0,
        1715.052978515625,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9617391228675842,
        0.19130180776119232,
        0.1961161196231842
      ],
      "plane_d": -183.31097412109375,
      "bbox_min": [
        110.15185546875,
        1500.0,
        0.0
      ],
      "bbox_max": [
        190.0,
        1715.052978515625,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8153231143951416,
        0.5447813868522644,
        0.1961159110069275
      ],
      "plane_d": -779.4175415039062,
      "bbox_min": [
        133.8159942626953,
        1626.2855224609375,
        0.0
      ],
      "bbox_max": [
        190.0,
        1715.052978515625,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5447814464569092,
        0.8153231143951416,
        0.19611552357673645
      ],
      "plane_d": -1306.973876953125,
      "bbox_min": [
        190.0,
        1693.45361328125,
        0.0
      ],
      "bbox_max": [
        323.7144775390625,
        1816.1839599609375,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8153231143951416,
        0.5447813868522644,
        0.1961159110069275
      ],
      "plane_d": -779.4175415039062,
      "bbox_min": [
        190.0,
        1693.45361328125,
        0.0
      ],
      "bbox_max": [
        216.65475463867188,
        1741.9967041015625,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        9.536743306171047e-08,
        0.0
      ],
      "plane_d": 254.03253173828125,
      "bbox_min": [
        -50.0,
        690.0,
        160.0
      ],
      "bbox_max": [
        254.03260803222656,
        820.0,
        420.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 350.0,
      "bbox_min": [
        -50.0,
        690.0,
        210.0
      ],
      "bbox_max": [
        254.03260803222656,
        820.0,
        370.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.5555700659751892,
        0.8314698338508606,
        0.0
      ],
      "plane_d": -555.204833984375,
      "bbox_min": [
        68.63186645507812,
        713.5973510742188,
        350.0
      ],
      "bbox_max": [
        195.3977813720703,
        820.0,
        370.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314698338508606,
        0.5555699467658997,
        0.0
      ],
      "plane_d": -293.0999755859375,
      "bbox_min": [
        169.20310974121094,
        780.796875,
        350.0
      ],
      "bbox_max": [
        195.3977813720703,
        820.0,
        370.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 280.0,
      "bbox_min": [
        -50.0,
        690.0,
        210.0
      ],
      "bbox_max": [
        250.98464965820312,
        820.0,
        300.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.5555700659751892,
        0.8314698338508606,
        0.0
      ],
      "plane_d": -555.204833984375,
      "bbox_min": [
        68.63186645507812,
        713.5973510742188,
        280.0
      ],
      "bbox_max": [
        195.3977813720703,
        820.0,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314698338508606,
        0.5555699467658997,
        0.0
      ],
      "plane_d": -293.0999755859375,
      "bbox_min": [
        169.20310974121094,
        780.796875,
        280.0
      ],
      "bbox_max": [
        195.3977813720703,
        820.0,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 210.0,
      "bbox_min": [
        -50.0,
        690.0,
        210.0
      ],
      "bbox_max": [
        169.20310974121094,
        780.796875,
        230.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555700659751892,
        0.8314698338508606,
        0.0
      ],
      "plane_d": -555.204833984375,
      "bbox_min": [
        68.63186645507812,
        713.5973510742188,
        210.0
      ],
      "bbox_max": [
        169.20310974121094,
        780.796875,
        230.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 0.0,
      "bbox_min": [
        -625.0554809570312,
        820.0,
        60.0
      ],
      "bbox_max": [
        1645.0,
        2798.15673828125,
        1180.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1430.0,
      "bbox_min": [
        -625.0554809570312,
        830.0,
        60.0
      ],
      "bbox_max": [
        2.384185791015625e-07,
        1490.0,
        540.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1490.0,
      "bbox_min": [
        -595.0115356445312,
        1430.0,
        60.0
      ],
      "bbox_max": [
        0.0,
        1490.0,
        214.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9700985550880432,
        -0.2427113950252533,
        0.0
      ],
      "plane_d": 924.297119140625,
      "bbox_min": [
        -595.0115356445312,
        1430.0,
        60.0
      ],
      "bbox_max": [
        -580.0,
        1490.0,
        214.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4999999403953552,
        0.866025447845459,
        0.0
      ],
      "plane_d": -1107.953857421875,
      "bbox_min": [
        -625.0554809570312,
        830.0,
        60.0
      ],
      "bbox_max": [
        2.384185791015625e-07,
        1430.0,
        540.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 50.0,
      "bbox_min": [
        -500.0,
        830.0,
        60.0
      ],
      "bbox_max": [
        2.384185791015625e-07,
        1250.4873046875,
        500.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -830.0,
      "bbox_min": [
        -500.0,
        830.0,
        60.0
      ],
      "bbox_max": [
        -50.0,
        1250.4873046875,
        500.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.8660252094268799,
        -0.5000004768371582,
        0.0
      ],
      "plane_d": 674.0302734375,
      "bbox_min": [
        -309.5,
        830.0,
        60.0
      ],
      "bbox_max": [
        -50.0,
        1250.4873046875,
        500.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.8660256266593933,
        0.4999997317790985,
        -0.0
      ],
      "plane_d": -235.18533325195312,
      "bbox_min": [
        -309.5,
        848.59375,
        60.00611877441406
      ],
      "bbox_max": [
        -97.95298767089844,
        1211.7012939453125,
        500.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.8660256266593933,
        -0.4999997317790985,
        0.0
      ],
      "plane_d": 675.9923706054688,
      "bbox_min": [
        -309.5,
        848.59375,
        78.04346466064453
      ],
      "bbox_max": [
        -253.3668670654297,
        1006.4411010742188,
        500.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 225.0,
      "bbox_min": [
        -309.5,
        971.800048828125,
        200.0
      ],
      "bbox_max": [
        -289.4999694824219,
        1006.4411010742188,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 300.0,
      "bbox_min": [
        -309.5,
        971.800048828125,
        300.0
      ],
      "bbox_max": [
        -289.4999694824219,
        1006.4411010742188,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 200.0,
      "bbox_min": [
        -309.5,
        971.800048828125,
        200.0
      ],
      "bbox_max": [
        -289.4999694824219,
        1006.4411010742188,
        225.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -971.800048828125,
      "bbox_min": [
        -309.5,
        971.800048828125,
        210.0
      ],
      "bbox_max": [
        -289.4999694824219,
        971.800048828125,
        225.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6123724579811096,
        -0.3535531163215637,
        0.7071068286895752
      ],
      "plane_d": 421.4258117675781,
      "bbox_min": [
        -289.5,
        848.59375,
        78.04346466064453
      ],
      "bbox_max": [
        -253.3668670654297,
        911.17822265625,
        80.00611877441406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660256266593933,
        0.4999997317790985,
        -0.0
      ],
      "plane_d": -484.369873046875,
      "bbox_min": [
        -309.5,
        909.215576171875,
        60.00611877441406
      ],
      "bbox_max": [
        -97.95298767089844,
        1211.7012939453125,
        500.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 225.0,
      "bbox_min": [
        -309.5,
        909.215576171875,
        60.00611877441406
      ],
      "bbox_max": [
        -184.49986267089844,
        1115.0986328125,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 300.0,
      "bbox_min": [
        -309.5,
        971.800048828125,
        225.0
      ],
      "bbox_max": [
        -184.49986267089844,
        1115.0986328125,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8544728755950928,
        -0.5194960832595825,
        0.0
      ],
      "plane_d": 700.9478759765625,
      "bbox_min": [
        -229.5,
        971.800048828125,
        300.0
      ],
      "bbox_max": [
        -184.49986267089844,
        1115.0986328125,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660241961479187,
        0.5000022649765015,
        0.0
      ],
      "plane_d": -363.1294250488281,
      "bbox_min": [
        -224.5,
        1045.8167724609375,
        300.0
      ],
      "bbox_max": [
        -184.49986267089844,
        1115.0986328125,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8544728755950928,
        -0.5194960832595825,
        0.0
      ],
      "plane_d": 700.9478759765625,
      "bbox_min": [
        -229.5,
        971.800048828125,
        225.0
      ],
      "bbox_max": [
        -184.49986267089844,
        1115.0986328125,
        250.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660241961479187,
        0.5000022649765015,
        -0.0
      ],
      "plane_d": -363.12939453125,
      "bbox_min": [
        -224.5,
        1045.8167724609375,
        225.0
      ],
      "bbox_max": [
        -184.49986267089844,
        1115.0986328125,
        250.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 200.0,
      "bbox_min": [
        -309.5,
        909.215576171875,
        60.00611877441406
      ],
      "bbox_max": [
        -184.49986267089844,
        1115.0986328125,
        225.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8544728755950928,
        -0.5194960832595825,
        0.0
      ],
      "plane_d": 700.9478759765625,
      "bbox_min": [
        -289.4999694824219,
        971.800048828125,
        200.0
      ],
      "bbox_max": [
        -184.49986267089844,
        1115.0986328125,
        225.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660241961479187,
        0.5000022649765015,
        -0.0
      ],
      "plane_d": -363.12939453125,
      "bbox_min": [
        -289.4999694824219,
        971.800048828125,
        200.0
      ],
      "bbox_max": [
        -184.49986267089844,
        1115.0986328125,
        225.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -971.800048828125,
      "bbox_min": [
        -289.4999694824219,
        971.800048828125,
        210.0
      ],
      "bbox_max": [
        -229.5,
        971.800048828125,
        225.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6123727560043335,
        0.35355329513549805,
        0.7071065902709961
      ],
      "plane_d": -222.87403869628906,
      "bbox_min": [
        -289.5,
        909.215576171875,
        60.00611877441406
      ],
      "bbox_max": [
        -241.81982421875,
        991.800048828125,
        80.00611877441406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6123724579811096,
        -0.3535531163215637,
        0.7071068286895752
      ],
      "plane_d": 421.4258117675781,
      "bbox_min": [
        -254.5,
        909.215576171875,
        78.04346466064453
      ],
      "bbox_max": [
        -252.2337188720703,
        911.17822265625,
        80.00611877441406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6122788190841675,
        0.35349908471107483,
        0.7072150111198425
      ],
      "plane_d": -399.0260009765625,
      "bbox_min": [
        -134.50001525878906,
        1158.39990234375,
        60.00611877441406
      ],
      "bbox_max": [
        -97.95298767089844,
        1211.7012939453125,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 100.0,
      "bbox_min": [
        -288.3668518066406,
        830.0,
        60.0
      ],
      "bbox_max": [
        -50.0,
        1250.4873046875,
        260.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1050.0,
      "bbox_min": [
        -288.3668518066406,
        830.556396484375,
        60.0
      ],
      "bbox_max": [
        -100.0,
        1174.8543701171875,
        260.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6123724579811096,
        -0.3535531163215637,
        0.7071068286895752
      ],
      "plane_d": 421.4258117675781,
      "bbox_min": [
        -288.3668518066406,
        830.556396484375,
        60.00611877441406
      ],
      "bbox_max": [
        -100.0,
        1040.0,
        260.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6123727560043335,
        0.35355329513549805,
        0.7071065902709961
      ],
      "plane_d": -222.87403869628906,
      "bbox_min": [
        -252.2337188720703,
        911.17822265625,
        60.00611877441406
      ],
      "bbox_max": [
        -231.40599060058594,
        929.2155151367188,
        78.04346466064453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 110.0,
      "bbox_min": [
        -150.0,
        980.0,
        230.0
      ],
      "bbox_max": [
        -100.0,
        1040.0,
        260.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1040.0,
      "bbox_min": [
        -150.0,
        1040.0,
        230.0
      ],
      "bbox_max": [
        -110.0,
        1040.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -980.0,
      "bbox_min": [
        -110.0,
        980.0,
        230.0
      ],
      "bbox_max": [
        -100.0,
        980.0,
        260.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6122786402702332,
        -0.3534996509552002,
        0.7072148323059082
      ],
      "plane_d": 419.9613037109375,
      "bbox_min": [
        -144.5,
        1077.7781982421875,
        60.00611877441406
      ],
      "bbox_max": [
        -100.0,
        1174.8543701171875,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6122788190841675,
        0.35349908471107483,
        0.7072150111198425
      ],
      "plane_d": -399.0260009765625,
      "bbox_min": [
        -109.5,
        1158.39990234375,
        63.550559997558594
      ],
      "bbox_max": [
        -100.0,
        1174.8543701171875,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -82.0,
      "bbox_min": [
        -100.0,
        830.0,
        60.0
      ],
      "bbox_max": [
        -50.0,
        1250.4873046875,
        155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1050.0,
      "bbox_min": [
        -100.0,
        1050.0,
        60.0
      ],
      "bbox_max": [
        -50.0,
        1250.0,
        82.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6122786402702332,
        -0.3534996509552002,
        0.7072148323059082
      ],
      "plane_d": 419.9613037109375,
      "bbox_min": [
        -100.0,
        1134.8543701171875,
        60.0
      ],
      "bbox_max": [
        -50.0,
        1250.0,
        82.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6122788190841675,
        0.35349908471107483,
        0.7072150111198425
      ],
      "plane_d": -399.0260009765625,
      "bbox_min": [
        -100.0,
        1158.39990234375,
        60.0
      ],
      "bbox_max": [
        -50.0,
        1250.0,
        75.0040283203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1250.0,
      "bbox_min": [
        -50.843994140625,
        1250.0,
        60.0
      ],
      "bbox_max": [
        -50.0,
        1250.0,
        75.0040283203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1250.0,
      "bbox_min": [
        -50.843994140625,
        1250.0,
        74.27332305908203
      ],
      "bbox_max": [
        -50.0,
        1250.0,
        82.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 144.0,
      "bbox_min": [
        -100.0,
        830.0,
        82.0
      ],
      "bbox_max": [
        -50.0,
        1250.4873046875,
        155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1050.0,
      "bbox_min": [
        -100.0,
        1050.0,
        144.0
      ],
      "bbox_max": [
        -50.0,
        1050.0,
        155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1050.0,
      "bbox_min": [
        -100.0,
        1050.0,
        82.0
      ],
      "bbox_max": [
        -50.0,
        1250.4873046875,
        144.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1250.0,
      "bbox_min": [
        -50.843994140625,
        1250.0,
        82.0
      ],
      "bbox_max": [
        -50.0,
        1250.4873046875,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        -50.843994140625,
        1250.0,
        120.0
      ],
      "bbox_max": [
        -50.0,
        1250.4873046875,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 144.0,
      "bbox_min": [
        -50.0,
        830.0,
        60.0
      ],
      "bbox_max": [
        2.384185791015625e-07,
        1050.0,
        155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1050.0,
      "bbox_min": [
        -50.0,
        1050.0,
        144.0
      ],
      "bbox_max": [
        0.0,
        1050.0,
        155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 102.0,
      "bbox_min": [
        -50.0,
        830.0,
        60.0
      ],
      "bbox_max": [
        2.384185791015625e-07,
        1050.0,
        144.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.19509048759937286,
        0.9807852506637573,
        0.0
      ],
      "plane_d": -823.8062744140625,
      "bbox_min": [
        -50.0,
        830.0,
        102.0
      ],
      "bbox_max": [
        0.0,
        1050.0,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1050.0,
      "bbox_min": [
        -50.0,
        1050.0,
        102.0
      ],
      "bbox_max": [
        0.0,
        1050.0,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 123.99999237060547,
      "bbox_min": [
        -50.0,
        830.0,
        104.0
      ],
      "bbox_max": [
        0.0,
        1050.0,
        144.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 49.0,
      "bbox_min": [
        -50.0,
        1010.0,
        126.0
      ],
      "bbox_max": [
        -49.0,
        1030.0,
        144.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1030.0,
      "bbox_min": [
        -50.0,
        1015.0,
        126.0
      ],
      "bbox_max": [
        -49.0,
        1030.0,
        144.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1015.0,
      "bbox_min": [
        -50.0,
        1015.0,
        126.0
      ],
      "bbox_max": [
        -49.0,
        1015.0,
        144.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509048759937286,
        0.9807852506637573,
        0.0
      ],
      "plane_d": -823.8062744140625,
      "bbox_min": [
        -50.0,
        830.0,
        104.0
      ],
      "bbox_max": [
        0.0,
        839.9456176757812,
        124.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -82.0,
      "bbox_min": [
        -50.0,
        830.0,
        60.0
      ],
      "bbox_max": [
        2.384185791015625e-07,
        1050.0,
        102.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 79.99999237060547,
      "bbox_min": [
        -50.0,
        860.0,
        60.0
      ],
      "bbox_max": [
        2.384185791015625e-07,
        1050.0,
        82.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.19509023427963257,
        0.9807853102684021,
        -5.211193609966358e-08
      ],
      "plane_d": -853.2298583984375,
      "bbox_min": [
        -50.0,
        860.0,
        80.0
      ],
      "bbox_max": [
        1.9584635424507724e-07,
        893.3493041992188,
        82.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19508984684944153,
        0.9807853698730469,
        0.0
      ],
      "plane_d": -882.6535034179688,
      "bbox_min": [
        -50.0,
        890.0,
        80.0
      ],
      "bbox_max": [
        -33.16192626953125,
        893.3493041992188,
        82.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0858488604426384,
        0.03555978462100029,
        0.9956733584403992
      ],
      "plane_d": -107.93418884277344,
      "bbox_min": [
        -50.0,
        860.0,
        80.0
      ],
      "bbox_max": [
        -28.56973648071289,
        875.3493041992188,
        82.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19508984684944153,
        0.9807853698730469,
        0.0
      ],
      "plane_d": -882.6535034179688,
      "bbox_min": [
        -50.0,
        864.2627563476562,
        60.0
      ],
      "bbox_max": [
        2.384185791015625e-07,
        903.6550903320312,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0858488604426384,
        0.03555978462100029,
        0.9956733584403992
      ],
      "plane_d": -107.93418884277344,
      "bbox_min": [
        -33.161930084228516,
        864.2627563476562,
        76.20401763916016
      ],
      "bbox_max": [
        2.384185791015625e-07,
        899.9456176757812,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.08340271562337875,
        0.08340274542570114,
        0.9930195808410645
      ],
      "plane_d": -150.7300262451172,
      "bbox_min": [
        -7.90482234954834,
        898.3732299804688,
        76.20401763916016
      ],
      "bbox_max": [
        0.0,
        899.9456176757812,
        77.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11794932931661606,
        0.0,
        0.9930195808410645
      ],
      "plane_d": -75.53013610839844,
      "bbox_min": [
        -33.161930084228516,
        864.2627563476562,
        77.0
      ],
      "bbox_max": [
        2.384185791015625e-07,
        898.3732299804688,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509023427963257,
        0.9807853102684021,
        -5.211193609966358e-08
      ],
      "plane_d": -853.2298583984375,
      "bbox_min": [
        -28.569734573364258,
        864.2627563476562,
        77.33370208740234
      ],
      "bbox_max": [
        2.384185791015625e-07,
        869.9456176757812,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555707216262817,
        0.8314693570137024,
        0.0
      ],
      "plane_d": -751.3614501953125,
      "bbox_min": [
        -7.90482234954834,
        898.3732299804688,
        60.0
      ],
      "bbox_max": [
        0.0,
        903.6550903320312,
        77.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08340271562337875,
        0.08340274542570114,
        0.9930195808410645
      ],
      "plane_d": -150.7300262451172,
      "bbox_min": [
        -7.90482234954834,
        898.3732299804688,
        75.89246368408203
      ],
      "bbox_max": [
        0.0,
        903.6550903320312,
        77.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20112165808677673,
        0.0,
        0.9795663356781006
      ],
      "plane_d": -90.38052368164062,
      "bbox_min": [
        -50.0,
        830.0,
        82.0
      ],
      "bbox_max": [
        2.384185791015625e-07,
        869.9456176757812,
        102.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509023427963257,
        0.9807853102684021,
        -5.211193609966358e-08
      ],
      "plane_d": -853.2298583984375,
      "bbox_min": [
        -50.0,
        830.0,
        82.0
      ],
      "bbox_max": [
        1.639127589214695e-07,
        869.9456176757812,
        92.26585388183594
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509048759937286,
        0.9807852506637573,
        0.0
      ],
      "plane_d": -823.8062744140625,
      "bbox_min": [
        -50.0,
        830.0,
        82.0
      ],
      "bbox_max": [
        0.0,
        839.9456176757812,
        92.26585388183594
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509048759937286,
        0.9807852506637573,
        0.0
      ],
      "plane_d": -823.8062744140625,
      "bbox_min": [
        -50.0,
        830.0,
        82.0
      ],
      "bbox_max": [
        0.0,
        839.9456176757812,
        102.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1210.361328125,
      "bbox_min": [
        -625.0554809570312,
        1101.0775146484375,
        60.0
      ],
      "bbox_max": [
        -50.0,
        1430.0,
        540.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660242557525635,
        0.5000020861625671,
        0.0
      ],
      "plane_d": -363.1293029785156,
      "bbox_min": [
        -615.3160400390625,
        1101.0775146484375,
        60.0
      ],
      "bbox_max": [
        -119.50043487548828,
        1210.361328125,
        540.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4999999701976776,
        0.8660255074501038,
        0.0
      ],
      "plane_d": -783.4539794921875,
      "bbox_min": [
        -615.3160400390625,
        1101.0775146484375,
        60.0
      ],
      "bbox_max": [
        -239.5,
        1210.361328125,
        540.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9952487945556641,
        0.09736471623182297,
        -0.0
      ],
      "plane_d": 494.5460205078125,
      "bbox_min": [
        -615.3160400390625,
        1135.8218994140625,
        60.0
      ],
      "bbox_max": [
        -608.0238647460938,
        1210.361328125,
        214.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1130.4095458984375,
      "bbox_min": [
        -429.4999084472656,
        1101.0775146484375,
        60.00611877441406
      ],
      "bbox_max": [
        -239.5,
        1210.361328125,
        540.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 400.0,
      "bbox_min": [
        -391.0191650390625,
        1101.0775146484375,
        400.0
      ],
      "bbox_max": [
        -257.9808349609375,
        1130.4095458984375,
        540.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        4.882812936557457e-05
      ],
      "plane_d": -1101.1038818359375,
      "bbox_min": [
        -340.22125244140625,
        1101.0775146484375,
        500.0
      ],
      "bbox_max": [
        -308.78204345703125,
        1101.0794677734375,
        540.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660256266593933,
        0.4999997317790985,
        -0.0
      ],
      "plane_d": -233.222412109375,
      "bbox_min": [
        -429.4999084472656,
        1130.4095458984375,
        60.00611877441406
      ],
      "bbox_max": [
        -320.5,
        1210.361328125,
        500.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 400.0,
      "bbox_min": [
        -409.5,
        1130.4095458984375,
        400.0
      ],
      "bbox_max": [
        -383.3397521972656,
        1158.39990234375,
        400.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 400.0,
      "bbox_min": [
        -429.4999084472656,
        1130.4095458984375,
        60.00611877441406
      ],
      "bbox_max": [
        -320.5,
        1210.361328125,
        402.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 329.5,
      "bbox_min": [
        -329.5,
        1140.0,
        400.0
      ],
      "bbox_max": [
        -329.5,
        1147.0,
        402.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6123719215393066,
        0.35355281829833984,
        0.7071074843406677
      ],
      "plane_d": -221.4859161376953,
      "bbox_min": [
        -429.4999084472656,
        1158.39990234375,
        60.00611877441406
      ],
      "bbox_max": [
        -387.95294189453125,
        1210.361328125,
        80.00611877441406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 400.0,
      "bbox_min": [
        -320.5,
        1130.4095458984375,
        120.0
      ],
      "bbox_max": [
        -239.5,
        1210.361328125,
        400.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 295.0,
      "bbox_min": [
        -295.0,
        1200.4000244140625,
        120.0
      ],
      "bbox_max": [
        -295.0,
        1210.361328125,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8661856651306152,
        0.4997224807739258,
        0.0
      ],
      "plane_d": -362.76519775390625,
      "bbox_min": [
        -279.4776611328125,
        1158.39990234375,
        62.68523025512695
      ],
      "bbox_max": [
        -119.50043487548828,
        1210.361328125,
        500.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.8660252094268799,
        0.5000004768371582,
        0.0
      ],
      "plane_d": -795.2738647460938,
      "bbox_min": [
        -249.5,
        1158.39990234375,
        62.68523025512695
      ],
      "bbox_max": [
        -119.50043487548828,
        1210.361328125,
        500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660256266593933,
        0.4999997317790985,
        -0.0
      ],
      "plane_d": -484.369873046875,
      "bbox_min": [
        -139.49990844726562,
        1201.7012939453125,
        62.68523025512695
      ],
      "bbox_max": [
        -119.50043487548828,
        1210.361328125,
        500.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.6122788190841675,
        0.35349908471107483,
        0.7072150111198425
      ],
      "plane_d": -399.0260009765625,
      "bbox_min": [
        -139.49990844726562,
        1201.7012939453125,
        62.68523025512695
      ],
      "bbox_max": [
        -119.50043487548828,
        1210.361328125,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8661856651306152,
        0.4997224807739258,
        0.0
      ],
      "plane_d": -362.76519775390625,
      "bbox_min": [
        -625.0554809570312,
        1210.361328125,
        60.0
      ],
      "bbox_max": [
        -50.0,
        1430.0,
        500.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1219.021728515625,
      "bbox_min": [
        -625.0554809570312,
        1210.361328125,
        60.0
      ],
      "bbox_max": [
        -279.5,
        1430.0,
        500.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8660256266593933,
        0.4999997317790985,
        -0.0
      ],
      "plane_d": -233.222412109375,
      "bbox_min": [
        -616.1632690429688,
        1210.361328125,
        60.0
      ],
      "bbox_max": [
        -279.5,
        1219.021728515625,
        500.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9952487945556641,
        0.09736471623182297,
        -0.0
      ],
      "plane_d": 494.5460205078125,
      "bbox_min": [
        -616.1632690429688,
        1210.361328125,
        60.0
      ],
      "bbox_max": [
        -615.3160400390625,
        1219.021728515625,
        214.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 340.0,
      "bbox_min": [
        -434.5,
        1210.361328125,
        60.0
      ],
      "bbox_max": [
        -279.5,
        1219.021728515625,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6123719215393066,
        0.35355281829833984,
        0.7071074843406677
      ],
      "plane_d": -221.4859161376953,
      "bbox_min": [
        -434.5,
        1210.361328125,
        60.0
      ],
      "bbox_max": [
        -340.0,
        1219.021728515625,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9060451984405518,
        0.4231809079647064,
        -0.0
      ],
      "plane_d": -204.16278076171875,
      "bbox_min": [
        -355.0,
        1210.4000244140625,
        60.0
      ],
      "bbox_max": [
        -340.0,
        1219.021728515625,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 80.0,
      "bbox_min": [
        -355.0,
        1210.4000244140625,
        80.0
      ],
      "bbox_max": [
        -340.0,
        1219.021728515625,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -125.0,
      "bbox_min": [
        -355.0,
        1210.4000244140625,
        125.0
      ],
      "bbox_max": [
        -340.0,
        1219.021728515625,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 80.0,
      "bbox_min": [
        -341.4645080566406,
        1210.4000244140625,
        80.0
      ],
      "bbox_max": [
        -340.0,
        1213.535400390625,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -125.0,
      "bbox_min": [
        -341.4645080566406,
        1210.4000244140625,
        125.0
      ],
      "bbox_max": [
        -340.0,
        1213.535400390625,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 80.0,
      "bbox_min": [
        -354.7092590332031,
        1212.9288330078125,
        80.0
      ],
      "bbox_max": [
        -340.0,
        1219.021728515625,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -125.0,
      "bbox_min": [
        -354.7092590332031,
        1212.9288330078125,
        125.0
      ],
      "bbox_max": [
        -340.0,
        1219.021728515625,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 295.0,
      "bbox_min": [
        -340.0,
        1210.361328125,
        60.0
      ],
      "bbox_max": [
        -279.5,
        1219.021728515625,
        125.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 80.0,
      "bbox_min": [
        -340.0,
        1210.4000244140625,
        60.0
      ],
      "bbox_max": [
        -295.0,
        1219.021728515625,
        125.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -125.0,
      "bbox_min": [
        -310.0,
        1210.4000244140625,
        125.0
      ],
      "bbox_max": [
        -295.0,
        1219.021728515625,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1210.4000244140625,
      "bbox_min": [
        -310.0,
        1210.4000244140625,
        60.0
      ],
      "bbox_max": [
        -295.0,
        1215.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9060451984405518,
        0.4231809079647064,
        0.0
      ],
      "plane_d": -240.40463256835938,
      "bbox_min": [
        -301.4644775390625,
        1210.4000244140625,
        60.0
      ],
      "bbox_max": [
        -300.0,
        1213.5355224609375,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1210.4000244140625,
      "bbox_min": [
        -295.0,
        1210.4000244140625,
        60.0
      ],
      "bbox_max": [
        -279.5,
        1210.4000244140625,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9700985550880432,
        -0.2427113950252533,
        0.0
      ],
      "plane_d": 924.297119140625,
      "bbox_min": [
        -625.0554809570312,
        1219.021728515625,
        60.0
      ],
      "bbox_max": [
        -295.0,
        1430.0,
        214.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9952487945556641,
        0.09736471623182297,
        -0.0
      ],
      "plane_d": 494.5460205078125,
      "bbox_min": [
        -625.0554809570312,
        1219.021728515625,
        60.0
      ],
      "bbox_max": [
        -295.0,
        1430.0,
        214.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9863939881324768,
        -0.0,
        0.16439899802207947
      ],
      "plane_d": 512.9248657226562,
      "bbox_min": [
        -550.0,
        1219.021728515625,
        60.0
      ],
      "bbox_max": [
        -295.0,
        1430.0,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        -550.0,
        1250.0,
        60.0
      ],
      "bbox_max": [
        -530.0,
        1430.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1250.0,
      "bbox_min": [
        -550.0,
        1250.0,
        60.0
      ],
      "bbox_max": [
        -530.0,
        1250.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9863938689231873,
        0.16439898312091827
      ],
      "plane_d": 1380.951416015625,
      "bbox_min": [
        -540.0,
        1219.021728515625,
        60.0
      ],
      "bbox_max": [
        -295.0,
        1430.0,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.7071067094802856,
        0.7071067094802856
      ],
      "plane_d": -918.5513305664062,
      "bbox_min": [
        -516.0469970703125,
        1219.021728515625,
        60.0
      ],
      "bbox_max": [
        -295.0,
        1370.0,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6123719215393066,
        0.35355281829833984,
        0.7071074843406677
      ],
      "plane_d": -221.4859161376953,
      "bbox_min": [
        -434.5,
        1219.021728515625,
        60.0
      ],
      "bbox_max": [
        -295.0,
        1239.0279541015625,
        80.00611877441406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 340.0,
      "bbox_min": [
        -340.0,
        1230.0,
        60.0
      ],
      "bbox_max": [
        -310.0,
        1239.0279541015625,
        69.02786254882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 310.0,
      "bbox_min": [
        -310.0,
        1235.0,
        60.0
      ],
      "bbox_max": [
        -310.0,
        1239.02783203125,
        64.02790069580078
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 340.0,
      "bbox_min": [
        -475.0,
        1219.021728515625,
        60.0
      ],
      "bbox_max": [
        -295.0,
        1370.0,
        125.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1240.0,
      "bbox_min": [
        -475.0,
        1219.021728515625,
        60.0
      ],
      "bbox_max": [
        -340.0,
        1370.0,
        125.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -125.0,
      "bbox_min": [
        -355.0,
        1219.021728515625,
        80.0
      ],
      "bbox_max": [
        -340.0,
        1240.0,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 80.0,
      "bbox_min": [
        -355.0,
        1219.021728515625,
        80.0
      ],
      "bbox_max": [
        -340.0,
        1230.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -61.999996185302734,
      "bbox_min": [
        -475.0,
        1320.0,
        60.0
      ],
      "bbox_max": [
        -425.0,
        1370.0,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268595933914185,
        0.9238786101341248,
        0.0
      ],
      "plane_d": -1093.5050048828125,
      "bbox_min": [
        -472.835205078125,
        1320.0,
        60.0
      ],
      "bbox_max": [
        -425.0,
        1370.0,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268595933914185,
        -0.9238786101341248,
        0.0
      ],
      "plane_d": 1391.728515625,
      "bbox_min": [
        -472.835205078125,
        1320.0,
        60.0
      ],
      "bbox_max": [
        -425.0,
        1367.835205078125,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238791465759277,
        0.3826843202114105,
        0.0
      ],
      "plane_d": -122.06173706054688,
      "bbox_min": [
        -472.835205078125,
        1322.164794921875,
        60.0
      ],
      "bbox_max": [
        -425.0,
        1367.835205078125,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238791465759277,
        -0.3826843202114105,
        0.0
      ],
      "plane_d": 907.3590087890625,
      "bbox_min": [
        -472.835205078125,
        1322.164794921875,
        60.0
      ],
      "bbox_max": [
        -425.0,
        1367.835205078125,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38268694281578064,
        0.9238780736923218,
        0.0
      ],
      "plane_d": -1393.7281494140625,
      "bbox_min": [
        -472.835205078125,
        1322.164794921875,
        60.0
      ],
      "bbox_max": [
        -433.8530578613281,
        1367.835205078125,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268694281578064,
        0.9238780736923218,
        0.0
      ],
      "plane_d": -1049.3099365234375,
      "bbox_min": [
        -472.835205078125,
        1322.164794921875,
        60.0
      ],
      "bbox_max": [
        -450.0,
        1367.835205078125,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268694281578064,
        -0.9238780736923218,
        0.0
      ],
      "plane_d": 1435.9219970703125,
      "bbox_min": [
        -472.835205078125,
        1328.8531494140625,
        60.0
      ],
      "bbox_max": [
        -450.0,
        1367.835205078125,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238792061805725,
        0.3826843500137329,
        0.0
      ],
      "plane_d": -77.86785888671875,
      "bbox_min": [
        -472.835205078125,
        1328.8531494140625,
        60.0
      ],
      "bbox_max": [
        -466.1469421386719,
        1361.1468505859375,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238792061805725,
        -0.3826843500137329,
        0.0
      ],
      "plane_d": 951.5531005859375,
      "bbox_min": [
        -472.835205078125,
        1345.0,
        60.0
      ],
      "bbox_max": [
        -466.1469421386719,
        1361.1468505859375,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268595933914185,
        0.9238786101341248,
        0.0
      ],
      "plane_d": -1093.5050048828125,
      "bbox_min": [
        -475.0,
        1320.0,
        62.0
      ],
      "bbox_max": [
        -425.0,
        1370.0,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268595933914185,
        -0.9238786101341248,
        0.0
      ],
      "plane_d": 1391.728515625,
      "bbox_min": [
        -475.0,
        1320.0,
        62.0
      ],
      "bbox_max": [
        -425.0,
        1370.0,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238791465759277,
        0.3826843202114105,
        0.0
      ],
      "plane_d": -122.06173706054688,
      "bbox_min": [
        -475.0,
        1320.0,
        62.0
      ],
      "bbox_max": [
        -425.0,
        1370.0,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238791465759277,
        -0.3826843202114105,
        0.0
      ],
      "plane_d": 907.3590087890625,
      "bbox_min": [
        -475.0,
        1320.0,
        62.0
      ],
      "bbox_max": [
        -425.0,
        1370.0,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -64.0,
      "bbox_min": [
        -475.0,
        1320.0,
        62.0
      ],
      "bbox_max": [
        -425.0,
        1370.0,
        64.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        -0.38268694281578064,
        0.9238780736923218,
        0.0
      ],
      "plane_d": -1393.7281494140625,
      "bbox_min": [
        -472.835205078125,
        1322.164794921875,
        62.0
      ],
      "bbox_max": [
        -433.8530578613281,
        1367.835205078125,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268694281578064,
        0.9238780736923218,
        0.0
      ],
      "plane_d": -1049.3099365234375,
      "bbox_min": [
        -472.835205078125,
        1322.164794921875,
        62.0
      ],
      "bbox_max": [
        -450.0,
        1367.835205078125,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268694281578064,
        -0.9238780736923218,
        0.0
      ],
      "plane_d": 1435.9219970703125,
      "bbox_min": [
        -472.835205078125,
        1328.8531494140625,
        62.0
      ],
      "bbox_max": [
        -450.0,
        1367.835205078125,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238792061805725,
        0.3826843500137329,
        0.0
      ],
      "plane_d": -77.86785888671875,
      "bbox_min": [
        -472.835205078125,
        1328.8531494140625,
        62.0
      ],
      "bbox_max": [
        -466.1469421386719,
        1361.1468505859375,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238792061805725,
        -0.3826843500137329,
        0.0
      ],
      "plane_d": 951.5531005859375,
      "bbox_min": [
        -472.835205078125,
        1345.0,
        62.0
      ],
      "bbox_max": [
        -466.1469421386719,
        1361.1468505859375,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 295.0,
      "bbox_min": [
        -340.0,
        1219.021728515625,
        60.0
      ],
      "bbox_max": [
        -295.0,
        1270.0,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944272398948669,
        0.44721361994743347,
        0.0
      ],
      "plane_d": -286.2167053222656,
      "bbox_min": [
        -340.0,
        1219.021728515625,
        60.0
      ],
      "bbox_max": [
        -295.0,
        1270.0,
        125.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1240.0,
      "bbox_min": [
        -340.0,
        1219.021728515625,
        60.0
      ],
      "bbox_max": [
        -295.0,
        1270.0,
        125.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 80.0,
      "bbox_min": [
        -340.0,
        1219.021728515625,
        60.0
      ],
      "bbox_max": [
        -295.0,
        1240.0,
        125.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -84.99999237060547,
      "bbox_min": [
        -340.0,
        1219.021728515625,
        85.0
      ],
      "bbox_max": [
        -295.0,
        1240.0,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -125.0,
      "bbox_min": [
        -310.0,
        1219.021728515625,
        125.0
      ],
      "bbox_max": [
        -295.0,
        1240.0,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -64.99999237060547,
      "bbox_min": [
        -340.0,
        1235.0,
        60.0
      ],
      "bbox_max": [
        -310.0,
        1240.0,
        65.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -65.0,
      "bbox_min": [
        -340.0,
        1240.0,
        60.0
      ],
      "bbox_max": [
        -310.0,
        1270.0,
        65.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -64.99999237060547,
      "bbox_min": [
        -315.0000305175781,
        1260.0,
        60.0
      ],
      "bbox_max": [
        -310.0,
        1270.0,
        65.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 310.0,
      "bbox_min": [
        -310.0,
        1260.0,
        60.0
      ],
      "bbox_max": [
        -310.0,
        1263.2667236328125,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 50.0,
      "bbox_min": [
        -406.1922912597656,
        1210.361328125,
        60.0
      ],
      "bbox_max": [
        -50.0,
        1430.0,
        500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1219.021728515625,
      "bbox_min": [
        -406.1922912597656,
        1210.361328125,
        60.0
      ],
      "bbox_max": [
        -50.0,
        1430.0,
        500.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.8660256266593933,
        0.4999997317790985,
        -0.0
      ],
      "plane_d": -484.369873046875,
      "bbox_min": [
        -219.50009155273438,
        1210.361328125,
        60.00611877441406
      ],
      "bbox_max": [
        -117.17955017089844,
        1219.021728515625,
        500.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.8660252094268799,
        0.5000004768371582,
        0.0
      ],
      "plane_d": -795.2738647460938,
      "bbox_min": [
        -219.50009155273438,
        1210.361328125,
        120.00524139404297
      ],
      "bbox_max": [
        -214.5,
        1219.021728515625,
        500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6122788190841675,
        0.35349908471107483,
        0.7072150111198425
      ],
      "plane_d": -399.0260009765625,
      "bbox_min": [
        -144.5,
        1210.361328125,
        60.00611877441406
      ],
      "bbox_max": [
        -117.17955017089844,
        1219.021728515625,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        -406.1922912597656,
        1219.021728515625,
        60.0
      ],
      "bbox_max": [
        -50.0,
        1430.0,
        120.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.986393928527832,
        0.16439898312091827
      ],
      "plane_d": 1380.9515380859375,
      "bbox_min": [
        -400.42303466796875,
        1219.021728515625,
        60.0
      ],
      "bbox_max": [
        -50.843994140625,
        1430.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 350.0,
      "bbox_min": [
        -350.0,
        1410.0,
        60.0
      ],
      "bbox_max": [
        -350.0,
        1430.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9863938689231873,
        0.0,
        0.16439898312091827
      ],
      "plane_d": -78.91150665283203,
      "bbox_min": [
        -313.88458251953125,
        1219.021728515625,
        60.0
      ],
      "bbox_max": [
        -50.843994140625,
        1420.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1250.0,
      "bbox_min": [
        -70.0,
        1250.0,
        60.0
      ],
      "bbox_max": [
        -50.843994140625,
        1250.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.7069986462593079,
        0.7072150111198425
      ],
      "plane_d": -918.4239501953125,
      "bbox_min": [
        -313.88458251953125,
        1219.021728515625,
        60.0
      ],
      "bbox_max": [
        -121.40599822998047,
        1370.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6122788190841675,
        0.35349908471107483,
        0.7072150111198425
      ],
      "plane_d": -399.0260009765625,
      "bbox_min": [
        -144.5,
        1219.021728515625,
        60.00611877441406
      ],
      "bbox_max": [
        -121.40599822998047,
        1239.021728515625,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238791465759277,
        0.3826843202114105,
        -0.0
      ],
      "plane_d": -353.03155517578125,
      "bbox_min": [
        -222.835205078125,
        1322.164794921875,
        60.0
      ],
      "bbox_max": [
        -175.0,
        1367.835205078125,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238791465759277,
        -0.3826843202114105,
        0.0
      ],
      "plane_d": 676.3892211914062,
      "bbox_min": [
        -222.835205078125,
        1322.164794921875,
        60.0
      ],
      "bbox_max": [
        -175.0,
        1367.835205078125,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268694281578064,
        0.9238780736923218,
        -0.0
      ],
      "plane_d": -1144.981689453125,
      "bbox_min": [
        -222.835205078125,
        1322.164794921875,
        60.0
      ],
      "bbox_max": [
        -183.85305786132812,
        1367.835205078125,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38268694281578064,
        -0.9238780736923218,
        0.0
      ],
      "plane_d": 1187.175537109375,
      "bbox_min": [
        -222.835205078125,
        1328.8531494140625,
        60.0
      ],
      "bbox_max": [
        -183.85305786132812,
        1367.835205078125,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268694281578064,
        -0.9238780736923218,
        0.0
      ],
      "plane_d": 1340.2503662109375,
      "bbox_min": [
        -222.835205078125,
        1328.8531494140625,
        60.0
      ],
      "bbox_max": [
        -200.0,
        1367.835205078125,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238792061805725,
        -0.3826843500137329,
        0.0
      ],
      "plane_d": 720.583251953125,
      "bbox_min": [
        -222.835205078125,
        1328.8531494140625,
        60.0
      ],
      "bbox_max": [
        -216.14694213867188,
        1361.1468505859375,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238792061805725,
        0.3826843500137329,
        -0.0
      ],
      "plane_d": -308.837646484375,
      "bbox_min": [
        -222.835205078125,
        1328.8531494140625,
        60.0
      ],
      "bbox_max": [
        -216.14694213867188,
        1345.0,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 310.0,
      "bbox_min": [
        -310.0,
        1263.2667236328125,
        60.0
      ],
      "bbox_max": [
        -310.0,
        1270.0,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268595933914185,
        -0.9238786101341248,
        0.0
      ],
      "plane_d": 1296.0570068359375,
      "bbox_min": [
        -313.88458251953125,
        1263.2667236328125,
        62.0
      ],
      "bbox_max": [
        -175.0,
        1370.0,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238791465759277,
        0.3826843202114105,
        -0.0
      ],
      "plane_d": -353.03155517578125,
      "bbox_min": [
        -225.0,
        1320.0,
        62.0
      ],
      "bbox_max": [
        -175.0,
        1370.0,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238791465759277,
        -0.3826843202114105,
        0.0
      ],
      "plane_d": 676.3892211914062,
      "bbox_min": [
        -225.0,
        1320.0,
        62.0
      ],
      "bbox_max": [
        -175.0,
        1370.0,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -63.999996185302734,
      "bbox_min": [
        -225.0,
        1320.0,
        62.0
      ],
      "bbox_max": [
        -175.0,
        1370.0,
        64.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        0.38268694281578064,
        0.9238780736923218,
        -0.0
      ],
      "plane_d": -1144.981689453125,
      "bbox_min": [
        -222.835205078125,
        1322.164794921875,
        62.0
      ],
      "bbox_max": [
        -183.85305786132812,
        1367.835205078125,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38268694281578064,
        -0.9238780736923218,
        0.0
      ],
      "plane_d": 1187.175537109375,
      "bbox_min": [
        -222.835205078125,
        1328.8531494140625,
        62.0
      ],
      "bbox_max": [
        -183.85305786132812,
        1367.835205078125,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268694281578064,
        -0.9238780736923218,
        0.0
      ],
      "plane_d": 1340.2503662109375,
      "bbox_min": [
        -222.835205078125,
        1328.8531494140625,
        62.0
      ],
      "bbox_max": [
        -200.0,
        1367.835205078125,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238792061805725,
        -0.3826843500137329,
        0.0
      ],
      "plane_d": 720.583251953125,
      "bbox_min": [
        -222.835205078125,
        1328.8531494140625,
        62.0
      ],
      "bbox_max": [
        -216.14694213867188,
        1361.1468505859375,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238792061805725,
        0.3826843500137329,
        -0.0
      ],
      "plane_d": -308.837646484375,
      "bbox_min": [
        -222.835205078125,
        1328.8531494140625,
        62.0
      ],
      "bbox_max": [
        -216.14694213867188,
        1345.0,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 310.0,
      "bbox_min": [
        -313.88458251953125,
        1263.2667236328125,
        62.0
      ],
      "bbox_max": [
        -310.0,
        1270.0,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -64.99999237060547,
      "bbox_min": [
        -313.88458251953125,
        1263.2667236328125,
        65.0
      ],
      "bbox_max": [
        -310.0,
        1270.0,
        65.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        0.0,
        820.0,
        60.0
      ],
      "bbox_max": [
        1645.0,
        2798.15673828125,
        1180.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 80.0,
      "bbox_min": [
        0.0,
        839.9456176757812,
        60.0
      ],
      "bbox_max": [
        120.0,
        1513.9443359375,
        230.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        -0.6757246255874634,
        0.7371541261672974
      ],
      "plane_d": 796.7407836914062,
      "bbox_min": [
        0.0,
        1250.0,
        144.0
      ],
      "bbox_max": [
        120.0,
        1513.9443359375,
        230.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -109.99999237060547,
      "bbox_min": [
        0.0,
        1336.1817626953125,
        144.0
      ],
      "bbox_max": [
        120.0,
        1513.9443359375,
        230.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 10.0,
      "bbox_min": [
        0.0,
        1336.1817626953125,
        144.0
      ],
      "bbox_max": [
        110.0,
        1513.9443359375,
        230.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1490.0,
      "bbox_min": [
        10.0,
        1490.0,
        144.0
      ],
      "bbox_max": [
        110.0,
        1513.9443359375,
        230.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1495.0,
      "bbox_min": [
        16.0,
        1490.0,
        162.0
      ],
      "bbox_max": [
        106.0,
        1513.9443359375,
        219.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 217.0,
      "bbox_min": [
        16.0,
        1490.0,
        217.0
      ],
      "bbox_max": [
        93.0,
        1495.0,
        217.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 35.0,
      "bbox_min": [
        34.0,
        1495.0,
        211.52786254882812
      ],
      "bbox_max": [
        93.0,
        1513.9443359375,
        219.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.5218772888183594,
        -0.8530205488204956
      ],
      "plane_d": 970.2698364257812,
      "bbox_min": [
        35.0,
        1495.0,
        211.52786254882812
      ],
      "bbox_max": [
        93.0,
        1513.9443359375,
        219.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 89.99999237060547,
      "bbox_min": [
        35.0,
        1502.4483642578125,
        211.52786254882812
      ],
      "bbox_max": [
        92.0,
        1513.9443359375,
        218.25515747070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944272994995117,
        -0.44721364974975586
      ],
      "plane_d": -1259.0675048828125,
      "bbox_min": [
        90.0,
        1513.444091796875,
        211.52786254882812
      ],
      "bbox_max": [
        92.0,
        1513.944091796875,
        212.52786254882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9943787455558777,
        0.09470273554325104,
        -0.04735136777162552
      ],
      "plane_d": -42.71092987060547,
      "bbox_min": [
        35.0,
        1502.4483642578125,
        211.52786254882812
      ],
      "bbox_max": [
        90.0,
        1513.9443359375,
        218.25515747070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944272994995117,
        -0.44721364974975586
      ],
      "plane_d": -1259.0677490234375,
      "bbox_min": [
        35.0,
        1513.4443359375,
        211.52786254882812
      ],
      "bbox_max": [
        37.0,
        1513.9443359375,
        212.52786254882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 217.0,
      "bbox_min": [
        35.0,
        1495.0,
        217.0
      ],
      "bbox_max": [
        93.0,
        1504.5,
        219.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9943787455558777,
        0.09470273554325104,
        -0.04735136777162552
      ],
      "plane_d": -42.71092987060547,
      "bbox_min": [
        89.0,
        1495.0,
        217.0
      ],
      "bbox_max": [
        90.0,
        1504.5,
        219.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9945054650306702,
        0.10468478500843048,
        0.0
      ],
      "plane_d": -122.69056701660156,
      "bbox_min": [
        34.0,
        1495.0,
        217.0
      ],
      "bbox_max": [
        35.0,
        1505.0,
        219.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 217.0,
      "bbox_min": [
        34.0,
        1495.0,
        217.0
      ],
      "bbox_max": [
        35.0,
        1504.5,
        217.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9943788051605225,
        0.09470274299383163,
        -0.04735137149691582
      ],
      "plane_d": -97.40176391601562,
      "bbox_min": [
        34.0,
        1495.0,
        217.0
      ],
      "bbox_max": [
        35.0,
        1505.0,
        219.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1490.0,
      "bbox_min": [
        0.0,
        1490.0,
        144.0
      ],
      "bbox_max": [
        10.0,
        1490.0,
        214.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1490.0,
      "bbox_min": [
        110.0,
        1490.0,
        144.0
      ],
      "bbox_max": [
        120.0,
        1490.0,
        214.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1270.0,
      "bbox_min": [
        0.0,
        1250.0,
        144.0
      ],
      "bbox_max": [
        120.0,
        1270.0,
        175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8320503234863281,
        0.5547002553939819,
        0.0
      ],
      "plane_d": -693.3753051757812,
      "bbox_min": [
        0.0,
        1250.0,
        144.0
      ],
      "bbox_max": [
        120.0,
        1270.0,
        175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320503234863281,
        0.5547002553939819,
        0.0
      ],
      "plane_d": -793.2213134765625,
      "bbox_min": [
        10.0,
        1250.0,
        144.0
      ],
      "bbox_max": [
        120.0,
        1270.0,
        175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.371390700340271,
        0.9284767508506775,
        0.0
      ],
      "plane_d": -1170.8092041015625,
      "bbox_min": [
        10.0,
        1265.0,
        144.0
      ],
      "bbox_max": [
        110.0,
        1270.0,
        175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.371390700340271,
        0.9284767508506775,
        0.0
      ],
      "plane_d": -1215.3760986328125,
      "bbox_min": [
        97.5,
        1265.0,
        144.0
      ],
      "bbox_max": [
        110.0,
        1270.0,
        175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -82.0,
      "bbox_min": [
        0.0,
        839.9456176757812,
        80.0
      ],
      "bbox_max": [
        120.0,
        1490.0,
        144.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -110.0,
      "bbox_min": [
        10.0,
        874.949462890625,
        80.0
      ],
      "bbox_max": [
        120.0,
        1490.0,
        82.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1310.0,
      "bbox_min": [
        10.0,
        874.949462890625,
        80.0
      ],
      "bbox_max": [
        110.0,
        1490.0,
        82.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1490.0,
      "bbox_min": [
        10.0,
        1490.0,
        80.0
      ],
      "bbox_max": [
        110.0,
        1490.0,
        82.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1270.0,
      "bbox_min": [
        10.0,
        874.949462890625,
        80.0
      ],
      "bbox_max": [
        110.0,
        1270.0,
        82.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807853102684021,
        0.1950903683900833,
        0.0
      ],
      "plane_d": -106.81968688964844,
      "bbox_min": [
        10.0,
        874.949462890625,
        80.0
      ],
      "bbox_max": [
        110.0,
        1270.0,
        82.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1000.0,
      "bbox_min": [
        90.0,
        1000.0,
        80.0
      ],
      "bbox_max": [
        110.0,
        1000.0,
        82.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314695358276367,
        0.5555703639984131,
        0.0
      ],
      "plane_d": -459.8338928222656,
      "bbox_min": [
        10.0,
        874.949462890625,
        80.0
      ],
      "bbox_max": [
        110.0,
        1270.0,
        82.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555704832077026,
        0.8314694762229919,
        0.0
      ],
      "plane_d": -721.9380493164062,
      "bbox_min": [
        10.0,
        874.949462890625,
        80.0
      ],
      "bbox_max": [
        110.0,
        1270.0,
        82.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.371390700340271,
        0.9284767508506775,
        0.0
      ],
      "plane_d": -1170.8092041015625,
      "bbox_min": [
        10.0,
        1265.0,
        80.0
      ],
      "bbox_max": [
        110.0,
        1270.0,
        82.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.371390700340271,
        0.9284767508506775,
        0.0
      ],
      "plane_d": -1215.3760986328125,
      "bbox_min": [
        97.5,
        1265.0,
        80.0
      ],
      "bbox_max": [
        110.0,
        1270.0,
        82.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320503234863281,
        0.5547002553939819,
        0.0
      ],
      "plane_d": -793.2213134765625,
      "bbox_min": [
        110.0,
        1000.0,
        80.0
      ],
      "bbox_max": [
        120.0,
        1490.0,
        82.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1000.0,
      "bbox_min": [
        110.0,
        1000.0,
        80.0
      ],
      "bbox_max": [
        120.0,
        1000.0,
        82.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1490.0,
      "bbox_min": [
        110.0,
        1490.0,
        80.0
      ],
      "bbox_max": [
        120.0,
        1490.0,
        82.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8320503234863281,
        0.5547002553939819,
        0.0
      ],
      "plane_d": -693.3753051757812,
      "bbox_min": [
        0.0,
        869.9456176757812,
        80.0
      ],
      "bbox_max": [
        10.0,
        1490.0,
        82.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1050.0,
      "bbox_min": [
        0.0,
        869.9456176757812,
        80.0
      ],
      "bbox_max": [
        10.0,
        1050.0,
        82.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555704832077026,
        0.8314694762229919,
        0.0
      ],
      "plane_d": -721.9380493164062,
      "bbox_min": [
        1.6391277313232422e-07,
        869.9456176757812,
        80.0
      ],
      "bbox_max": [
        10.0,
        874.949462890625,
        82.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509023427963257,
        0.9807853102684021,
        -5.211193609966358e-08
      ],
      "plane_d": -853.2298583984375,
      "bbox_min": [
        1.6391277313232422e-07,
        869.9456176757812,
        80.0
      ],
      "bbox_max": [
        3.5756804943084717,
        870.6568603515625,
        82.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1490.0,
      "bbox_min": [
        0.0,
        1490.0,
        80.0
      ],
      "bbox_max": [
        10.0,
        1490.0,
        82.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 124.0,
      "bbox_min": [
        0.0,
        839.9456176757812,
        82.0
      ],
      "bbox_max": [
        120.0,
        1490.0,
        144.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -109.99999237060547,
      "bbox_min": [
        10.0,
        841.9347534179688,
        124.0
      ],
      "bbox_max": [
        120.0,
        1490.0,
        144.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.6757246255874634,
        0.7371541261672974
      ],
      "plane_d": 796.7407836914062,
      "bbox_min": [
        10.0,
        841.9347534179688,
        124.0
      ],
      "bbox_max": [
        110.0,
        1490.0,
        144.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1490.0,
      "bbox_min": [
        10.0,
        1490.0,
        124.0
      ],
      "bbox_max": [
        110.0,
        1490.0,
        144.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1270.0,
      "bbox_min": [
        10.0,
        841.9347534179688,
        124.0
      ],
      "bbox_max": [
        110.0,
        1270.0,
        144.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555703639984131,
        0.8314695358276367,
        -1.0388886195755731e-08
      ],
      "plane_d": -692.5145874023438,
      "bbox_min": [
        10.0,
        841.9347534179688,
        124.0
      ],
      "bbox_max": [
        110.0,
        1270.0,
        144.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8314693570137024,
        0.5555705428123474,
        0.0
      ],
      "plane_d": -430.4105224609375,
      "bbox_min": [
        10.0,
        841.9347534179688,
        124.0
      ],
      "bbox_max": [
        110.0,
        1270.0,
        144.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9807852506637573,
        0.19509023427963257,
        2.494266198027617e-07
      ],
      "plane_d": -77.39603424072266,
      "bbox_min": [
        10.0,
        841.9347534179688,
        124.0
      ],
      "bbox_max": [
        110.0,
        1270.0,
        144.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.19509048759937286,
        0.9807852506637573,
        0.0
      ],
      "plane_d": -823.8062744140625,
      "bbox_min": [
        10.0,
        841.9347534179688,
        124.0
      ],
      "bbox_max": [
        110.0,
        1000.0,
        144.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1000.0,
      "bbox_min": [
        88.2238540649414,
        991.0707397460938,
        124.0
      ],
      "bbox_max": [
        110.0,
        1000.0,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807853102684021,
        0.1950903683900833,
        0.0
      ],
      "plane_d": -106.81968688964844,
      "bbox_min": [
        88.2238540649414,
        991.0707397460938,
        124.0
      ],
      "bbox_max": [
        90.0,
        1000.0,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807853698730469,
        0.195090189576149,
        0.0
      ],
      "plane_d": -77.39594268798828,
      "bbox_min": [
        110.0,
        949.7265625,
        124.0
      ],
      "bbox_max": [
        120.0,
        1490.0,
        144.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8320503234863281,
        0.5547002553939819,
        0.0
      ],
      "plane_d": -793.2213134765625,
      "bbox_min": [
        110.0,
        1000.0,
        124.0
      ],
      "bbox_max": [
        120.0,
        1490.0,
        144.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1000.0,
      "bbox_min": [
        110.0,
        1000.0,
        124.0
      ],
      "bbox_max": [
        120.0,
        1000.0,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1490.0,
      "bbox_min": [
        110.0,
        1490.0,
        124.0
      ],
      "bbox_max": [
        120.0,
        1490.0,
        144.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8320503234863281,
        0.5547002553939819,
        0.0
      ],
      "plane_d": -693.3753051757812,
      "bbox_min": [
        0.0,
        839.9456176757812,
        124.0
      ],
      "bbox_max": [
        10.0,
        1490.0,
        144.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509048759937286,
        0.9807852506637573,
        0.0
      ],
      "plane_d": -823.8062744140625,
      "bbox_min": [
        0.0,
        839.9456176757812,
        124.0
      ],
      "bbox_max": [
        10.0,
        1050.0,
        144.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1050.0,
      "bbox_min": [
        0.0,
        1050.0,
        124.0
      ],
      "bbox_max": [
        10.0,
        1050.0,
        144.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1490.0,
      "bbox_min": [
        0.0,
        1490.0,
        124.0
      ],
      "bbox_max": [
        10.0,
        1490.0,
        144.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -104.0,
      "bbox_min": [
        0.0,
        839.9456176757812,
        82.0
      ],
      "bbox_max": [
        120.0,
        1490.0,
        124.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 102.0,
      "bbox_min": [
        0.0,
        839.9456176757812,
        82.0
      ],
      "bbox_max": [
        120.0,
        1490.0,
        104.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 10.0,
      "bbox_min": [
        0.0,
        839.9456176757812,
        102.0
      ],
      "bbox_max": [
        110.0,
        1490.0,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1310.0,
      "bbox_min": [
        10.0,
        841.9347534179688,
        102.0
      ],
      "bbox_max": [
        110.0,
        1490.0,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1490.0,
      "bbox_min": [
        10.0,
        1490.0,
        102.0
      ],
      "bbox_max": [
        110.0,
        1490.0,
        104.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1210.0,
      "bbox_min": [
        10.0,
        841.9347534179688,
        102.0
      ],
      "bbox_max": [
        110.0,
        1270.0,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555703639984131,
        0.8314695358276367,
        -1.0388886195755731e-08
      ],
      "plane_d": -692.5145874023438,
      "bbox_min": [
        10.0,
        841.9347534179688,
        102.0
      ],
      "bbox_max": [
        110.0,
        1000.0,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1000.0,
      "bbox_min": [
        90.0,
        1000.0,
        102.0
      ],
      "bbox_max": [
        110.0,
        1000.0,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314695358276367,
        0.5555703639984131,
        0.0
      ],
      "plane_d": -459.8338928222656,
      "bbox_min": [
        10.0,
        841.9347534179688,
        102.0
      ],
      "bbox_max": [
        79.34313201904297,
        946.42431640625,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509048759937286,
        0.9807852506637573,
        0.0
      ],
      "plane_d": -823.8062744140625,
      "bbox_min": [
        10.0,
        841.9347534179688,
        102.0
      ],
      "bbox_max": [
        15.056183815002441,
        842.9404907226562,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555704832077026,
        0.8314694762229919,
        0.0
      ],
      "plane_d": -721.9380493164062,
      "bbox_min": [
        40.736900329589844,
        895.4871826171875,
        102.0
      ],
      "bbox_max": [
        48.99494934082031,
        901.0050659179688,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1270.0,
      "bbox_min": [
        10.0,
        1210.0,
        102.0
      ],
      "bbox_max": [
        110.0,
        1270.0,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3205961585044861,
        0.0,
        0.9472159743309021
      ],
      "plane_d": -69.65679931640625,
      "bbox_min": [
        10.0,
        1210.0,
        102.0
      ],
      "bbox_max": [
        110.0,
        1270.0,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.371390700340271,
        0.9284767508506775,
        0.0
      ],
      "plane_d": -1215.3760986328125,
      "bbox_min": [
        97.5,
        1265.0,
        102.0
      ],
      "bbox_max": [
        110.0,
        1270.0,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.371390700340271,
        0.9284767508506775,
        0.0
      ],
      "plane_d": -1170.8092041015625,
      "bbox_min": [
        10.0,
        1265.0,
        102.0
      ],
      "bbox_max": [
        22.5,
        1270.0,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8320503234863281,
        0.5547002553939819,
        0.0
      ],
      "plane_d": -693.3753051757812,
      "bbox_min": [
        0.0,
        839.9456176757812,
        102.0
      ],
      "bbox_max": [
        10.0,
        1490.0,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509048759937286,
        0.9807852506637573,
        0.0
      ],
      "plane_d": -823.8062744140625,
      "bbox_min": [
        0.0,
        839.9456176757812,
        102.0
      ],
      "bbox_max": [
        10.0,
        1210.0,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1050.0,
      "bbox_min": [
        0.0,
        1050.0,
        102.0
      ],
      "bbox_max": [
        10.0,
        1210.0,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1210.0,
      "bbox_min": [
        0.0,
        1210.0,
        102.0
      ],
      "bbox_max": [
        10.0,
        1210.0,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1490.0,
      "bbox_min": [
        0.0,
        1490.0,
        102.0
      ],
      "bbox_max": [
        10.0,
        1490.0,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320503234863281,
        0.5547002553939819,
        0.0
      ],
      "plane_d": -793.2213134765625,
      "bbox_min": [
        110.0,
        1000.0,
        102.0
      ],
      "bbox_max": [
        120.0,
        1490.0,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1000.0,
      "bbox_min": [
        110.0,
        1000.0,
        102.0
      ],
      "bbox_max": [
        120.0,
        1000.0,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1490.0,
      "bbox_min": [
        110.0,
        1490.0,
        102.0
      ],
      "bbox_max": [
        120.0,
        1490.0,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -110.0,
      "bbox_min": [
        0.0,
        839.9456176757812,
        82.0
      ],
      "bbox_max": [
        120.0,
        1490.0,
        102.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 10.0,
      "bbox_min": [
        0.0,
        839.9456176757812,
        82.0
      ],
      "bbox_max": [
        110.0,
        1490.0,
        102.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1490.0,
      "bbox_min": [
        10.0,
        841.9347534179688,
        82.0
      ],
      "bbox_max": [
        110.0,
        1490.0,
        102.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1310.0,
      "bbox_min": [
        10.0,
        841.9347534179688,
        82.0
      ],
      "bbox_max": [
        110.0,
        1310.0,
        102.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1270.0,
      "bbox_min": [
        10.0,
        841.9347534179688,
        82.0
      ],
      "bbox_max": [
        110.0,
        1270.0,
        102.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3205961585044861,
        0.0,
        0.9472159743309021
      ],
      "plane_d": -69.65679931640625,
      "bbox_min": [
        10.0,
        841.9347534179688,
        82.0
      ],
      "bbox_max": [
        110.0,
        1270.0,
        102.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314695358276367,
        0.5555703639984131,
        0.0
      ],
      "plane_d": -459.8338928222656,
      "bbox_min": [
        25.000009536743164,
        884.97216796875,
        82.0
      ],
      "bbox_max": [
        110.0,
        1270.0,
        102.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807853102684021,
        0.1950903683900833,
        0.0
      ],
      "plane_d": -106.81968688964844,
      "bbox_min": [
        25.000009536743164,
        884.97216796875,
        82.0
      ],
      "bbox_max": [
        110.0,
        1270.0,
        102.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1000.0,
      "bbox_min": [
        90.0,
        1000.0,
        82.0
      ],
      "bbox_max": [
        110.0,
        1000.0,
        102.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555704832077026,
        0.8314694762229919,
        0.0
      ],
      "plane_d": -721.9380493164062,
      "bbox_min": [
        25.000009536743164,
        884.97216796875,
        82.0
      ],
      "bbox_max": [
        110.0,
        1270.0,
        102.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.371390700340271,
        0.9284767508506775,
        0.0
      ],
      "plane_d": -1215.3760986328125,
      "bbox_min": [
        97.5,
        1265.0,
        82.0
      ],
      "bbox_max": [
        110.0,
        1270.0,
        102.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314695358276367,
        0.5555703639984131,
        0.0
      ],
      "plane_d": -459.8338928222656,
      "bbox_min": [
        10.0,
        841.9347534179688,
        82.0
      ],
      "bbox_max": [
        84.09092712402344,
        1270.0,
        102.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555703639984131,
        0.8314695358276367,
        -1.0388886195755731e-08
      ],
      "plane_d": -692.5145874023438,
      "bbox_min": [
        10.0,
        841.9347534179688,
        92.14508056640625
      ],
      "bbox_max": [
        60.18052291870117,
        873.0916137695312,
        102.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509048759937286,
        0.9807852506637573,
        0.0
      ],
      "plane_d": -823.8062744140625,
      "bbox_min": [
        10.0,
        841.9347534179688,
        92.14508056640625
      ],
      "bbox_max": [
        15.056183815002441,
        842.9404907226562,
        102.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555704832077026,
        0.8314694762229919,
        0.0
      ],
      "plane_d": -721.9380493164062,
      "bbox_min": [
        10.0,
        874.949462890625,
        82.0
      ],
      "bbox_max": [
        84.09092712402344,
        1270.0,
        102.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807853102684021,
        0.1950903683900833,
        0.0
      ],
      "plane_d": -106.81968688964844,
      "bbox_min": [
        10.0,
        946.42431640625,
        82.0
      ],
      "bbox_max": [
        84.09092712402344,
        1270.0,
        102.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.371390700340271,
        0.9284767508506775,
        0.0
      ],
      "plane_d": -1170.8092041015625,
      "bbox_min": [
        10.0,
        1265.0,
        82.0
      ],
      "bbox_max": [
        22.5,
        1270.0,
        102.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8320503234863281,
        0.5547002553939819,
        0.0
      ],
      "plane_d": -693.3753051757812,
      "bbox_min": [
        0.0,
        839.9456176757812,
        82.0
      ],
      "bbox_max": [
        10.0,
        1490.0,
        102.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1050.0,
      "bbox_min": [
        0.0,
        839.9456176757812,
        82.0
      ],
      "bbox_max": [
        10.0,
        1050.0,
        102.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509048759937286,
        0.9807852506637573,
        0.0
      ],
      "plane_d": -823.8062744140625,
      "bbox_min": [
        0.0,
        839.9456176757812,
        82.0
      ],
      "bbox_max": [
        10.0,
        874.949462890625,
        102.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555704832077026,
        0.8314694762229919,
        0.0
      ],
      "plane_d": -721.9380493164062,
      "bbox_min": [
        0.0,
        867.943359375,
        82.0
      ],
      "bbox_max": [
        10.0,
        874.949462890625,
        94.55589294433594
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20112165808677673,
        0.0,
        0.9795663356781006
      ],
      "plane_d": -90.38052368164062,
      "bbox_min": [
        0.0,
        867.943359375,
        92.26585388183594
      ],
      "bbox_max": [
        3.5756804943084717,
        870.6568603515625,
        93.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509023427963257,
        0.9807853102684021,
        -5.211193609966358e-08
      ],
      "plane_d": -853.2298583984375,
      "bbox_min": [
        0.0,
        868.2676391601562,
        82.0
      ],
      "bbox_max": [
        3.5756804943084717,
        870.6568603515625,
        93.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20112165808677673,
        0.0,
        0.9795663356781006
      ],
      "plane_d": -90.38052368164062,
      "bbox_min": [
        3.8616164488303184e-08,
        868.2676391601562,
        92.26585388183594
      ],
      "bbox_max": [
        3.5756804943084717,
        870.6568603515625,
        93.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1490.0,
      "bbox_min": [
        0.0,
        1490.0,
        82.0
      ],
      "bbox_max": [
        10.0,
        1490.0,
        102.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320503234863281,
        0.5547002553939819,
        0.0
      ],
      "plane_d": -793.2213134765625,
      "bbox_min": [
        110.0,
        1000.0,
        82.0
      ],
      "bbox_max": [
        120.0,
        1490.0,
        102.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1000.0,
      "bbox_min": [
        110.0,
        1000.0,
        82.0
      ],
      "bbox_max": [
        120.0,
        1000.0,
        102.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1490.0,
      "bbox_min": [
        110.0,
        1490.0,
        82.0
      ],
      "bbox_max": [
        120.0,
        1490.0,
        102.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 10.0,
      "bbox_min": [
        0.0,
        839.9456176757812,
        104.0
      ],
      "bbox_max": [
        120.0,
        1490.0,
        124.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -110.0,
      "bbox_min": [
        10.0,
        841.9347534179688,
        104.0
      ],
      "bbox_max": [
        120.0,
        1490.0,
        124.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1490.0,
      "bbox_min": [
        10.0,
        841.9347534179688,
        104.0
      ],
      "bbox_max": [
        110.0,
        1490.0,
        124.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1310.0,
      "bbox_min": [
        10.0,
        841.9347534179688,
        104.0
      ],
      "bbox_max": [
        110.0,
        1314.3636474609375,
        124.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.6757246255874634,
        0.7371541261672974
      ],
      "plane_d": 796.7407836914062,
      "bbox_min": [
        10.0,
        1310.0,
        120.0
      ],
      "bbox_max": [
        110.0,
        1314.3636474609375,
        124.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1270.0,
      "bbox_min": [
        10.0,
        841.9347534179688,
        104.0
      ],
      "bbox_max": [
        110.0,
        1270.0,
        124.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555703639984131,
        0.8314695358276367,
        -1.0388886195755731e-08
      ],
      "plane_d": -692.5145874023438,
      "bbox_min": [
        10.0,
        841.9347534179688,
        104.0
      ],
      "bbox_max": [
        110.0,
        1270.0,
        124.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8314693570137024,
        0.5555705428123474,
        0.0
      ],
      "plane_d": -430.4105224609375,
      "bbox_min": [
        10.0,
        841.9347534179688,
        104.0
      ],
      "bbox_max": [
        110.0,
        1270.0,
        124.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8314695358276367,
        0.5555703639984131,
        0.0
      ],
      "plane_d": -459.8338928222656,
      "bbox_min": [
        10.0,
        841.9347534179688,
        104.0
      ],
      "bbox_max": [
        110.0,
        1270.0,
        124.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807852506637573,
        0.19509023427963257,
        2.494266198027617e-07
      ],
      "plane_d": -77.39603424072266,
      "bbox_min": [
        107.05951690673828,
        934.9437866210938,
        114.0
      ],
      "bbox_max": [
        110.0,
        949.7265625,
        124.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9807853102684021,
        0.1950903683900833,
        0.0
      ],
      "plane_d": -106.81968688964844,
      "bbox_min": [
        10.0,
        946.42431640625,
        104.0
      ],
      "bbox_max": [
        110.0,
        1270.0,
        124.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1000.0,
      "bbox_min": [
        90.0,
        1000.0,
        104.0
      ],
      "bbox_max": [
        110.0,
        1000.0,
        124.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.371390700340271,
        0.9284767508506775,
        0.0
      ],
      "plane_d": -1170.8092041015625,
      "bbox_min": [
        10.0,
        1265.0,
        104.0
      ],
      "bbox_max": [
        110.0,
        1270.0,
        124.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.371390700340271,
        0.9284767508506775,
        0.0
      ],
      "plane_d": -1215.3760986328125,
      "bbox_min": [
        97.5,
        1265.0,
        104.0
      ],
      "bbox_max": [
        110.0,
        1270.0,
        124.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807853698730469,
        0.195090189576149,
        0.0
      ],
      "plane_d": -77.39594268798828,
      "bbox_min": [
        110.0,
        949.7265625,
        104.0
      ],
      "bbox_max": [
        120.0,
        1490.0,
        124.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8320503234863281,
        0.5547002553939819,
        0.0
      ],
      "plane_d": -793.2213134765625,
      "bbox_min": [
        110.0,
        1000.0,
        104.0
      ],
      "bbox_max": [
        120.0,
        1490.0,
        124.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1000.0,
      "bbox_min": [
        110.0,
        1000.0,
        104.0
      ],
      "bbox_max": [
        120.0,
        1000.0,
        124.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1490.0,
      "bbox_min": [
        110.0,
        1490.0,
        104.0
      ],
      "bbox_max": [
        120.0,
        1490.0,
        124.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8320503234863281,
        0.5547002553939819,
        0.0
      ],
      "plane_d": -693.3753051757812,
      "bbox_min": [
        0.0,
        839.9456176757812,
        104.0
      ],
      "bbox_max": [
        10.0,
        1490.0,
        124.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509048759937286,
        0.9807852506637573,
        0.0
      ],
      "plane_d": -823.8062744140625,
      "bbox_min": [
        0.0,
        839.9456176757812,
        104.0
      ],
      "bbox_max": [
        10.0,
        1050.0,
        124.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1050.0,
      "bbox_min": [
        0.0,
        1050.0,
        104.0
      ],
      "bbox_max": [
        10.0,
        1050.0,
        124.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1490.0,
      "bbox_min": [
        0.0,
        1490.0,
        104.0
      ],
      "bbox_max": [
        10.0,
        1490.0,
        124.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -110.0,
      "bbox_min": [
        0.0,
        869.9456176757812,
        60.0
      ],
      "bbox_max": [
        120.0,
        1490.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 10.0,
      "bbox_min": [
        0.0,
        869.9456176757812,
        60.0
      ],
      "bbox_max": [
        110.0,
        1490.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1250.0,
      "bbox_min": [
        10.0,
        874.949462890625,
        60.0
      ],
      "bbox_max": [
        110.0,
        1490.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.049578726291656494,
        0.1196933388710022,
        0.9915722608566284
      ],
      "plane_d": -183.64974975585938,
      "bbox_min": [
        10.0,
        874.949462890625,
        60.0
      ],
      "bbox_max": [
        110.0,
        1000.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06570588052272797,
        0.06570590287446976,
        0.9956733584403992
      ],
      "plane_d": -134.10910034179688,
      "bbox_min": [
        10.0,
        874.949462890625,
        60.0
      ],
      "bbox_max": [
        90.0,
        1000.0,
        79.09492492675781
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.16403737664222717,
        0.9864540696144104
      ],
      "plane_d": -223.22462463378906,
      "bbox_min": [
        10.0,
        910.3368530273438,
        60.0
      ],
      "bbox_max": [
        90.0,
        1000.0,
        73.95751190185547
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.045137323439121246,
        0.10897087305784225,
        0.9930195808410645
      ],
      "plane_d": -173.246337890625,
      "bbox_min": [
        10.0,
        910.3368530273438,
        60.0
      ],
      "bbox_max": [
        79.34313201904297,
        1000.0,
        73.95751190185547
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314697742462158,
        0.5555700659751892,
        0.0
      ],
      "plane_d": -489.2572021484375,
      "bbox_min": [
        10.0,
        910.3368530273438,
        60.0
      ],
      "bbox_max": [
        60.0,
        1000.0,
        73.95751190185547
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807853102684021,
        0.19509047269821167,
        0.0
      ],
      "plane_d": -136.2433624267578,
      "bbox_min": [
        10.0,
        910.3368530273438,
        60.0
      ],
      "bbox_max": [
        60.0,
        1000.0,
        73.95751190185547
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555707216262817,
        0.8314693570137024,
        0.0
      ],
      "plane_d": -751.3614501953125,
      "bbox_min": [
        10.0,
        910.3368530273438,
        60.0
      ],
      "bbox_max": [
        27.78174591064453,
        922.21826171875,
        73.95751190185547
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314695358276367,
        0.5555703639984131,
        0.0
      ],
      "plane_d": -459.8338928222656,
      "bbox_min": [
        10.0,
        874.949462890625,
        67.0
      ],
      "bbox_max": [
        79.34313201904297,
        946.42431640625,
        79.09492492675781
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08340271562337875,
        0.08340274542570114,
        0.9930195808410645
      ],
      "plane_d": -150.7300262451172,
      "bbox_min": [
        10.0,
        899.2013549804688,
        72.0
      ],
      "bbox_max": [
        48.99494934082031,
        922.21826171875,
        75.4266357421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555707216262817,
        0.8314693570137024,
        0.0
      ],
      "plane_d": -751.3614501953125,
      "bbox_min": [
        10.0,
        910.3368530273438,
        72.0
      ],
      "bbox_max": [
        27.78174591064453,
        922.21826171875,
        74.49137878417969
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807853102684021,
        0.1950903683900833,
        0.0
      ],
      "plane_d": -106.81968688964844,
      "bbox_min": [
        10.0,
        874.949462890625,
        60.0
      ],
      "bbox_max": [
        110.0,
        1000.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1000.0,
      "bbox_min": [
        90.0,
        1000.0,
        60.0
      ],
      "bbox_max": [
        110.0,
        1000.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555704832077026,
        0.8314694762229919,
        0.0
      ],
      "plane_d": -721.9380493164062,
      "bbox_min": [
        10.0,
        874.949462890625,
        73.99998474121094
      ],
      "bbox_max": [
        48.99494934082031,
        901.0050659179688,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1490.0,
      "bbox_min": [
        10.0,
        1310.0,
        60.0
      ],
      "bbox_max": [
        110.0,
        1490.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1310.0,
      "bbox_min": [
        10.0,
        1310.0,
        60.0
      ],
      "bbox_max": [
        110.0,
        1310.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0858488455414772,
        0.03555978089570999,
        0.995673418045044
      ],
      "plane_d": -107.93418884277344,
      "bbox_min": [
        0.0,
        869.9456176757812,
        60.0
      ],
      "bbox_max": [
        10.0,
        1490.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5555707216262817,
        0.8314693570137024,
        0.0
      ],
      "plane_d": -751.3614501953125,
      "bbox_min": [
        0.0,
        898.7388305664062,
        60.0
      ],
      "bbox_max": [
        10.0,
        1250.0,
        76.30537414550781
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08340271562337875,
        0.08340274542570114,
        0.9930195808410645
      ],
      "plane_d": -150.7300262451172,
      "bbox_min": [
        0.0,
        898.7388305664062,
        74.49137878417969
      ],
      "bbox_max": [
        10.0,
        910.3368530273438,
        76.30537414550781
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1050.0,
      "bbox_min": [
        0.0,
        1050.0,
        60.0
      ],
      "bbox_max": [
        10.0,
        1250.0,
        70.90319061279297
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1250.0,
      "bbox_min": [
        0.0,
        1250.0,
        60.0
      ],
      "bbox_max": [
        10.0,
        1250.0,
        63.76032638549805
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1490.0,
      "bbox_min": [
        0.0,
        869.9456176757812,
        60.0
      ],
      "bbox_max": [
        10.0,
        1490.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1250.0,
      "bbox_min": [
        0.0,
        869.9456176757812,
        62.89810562133789
      ],
      "bbox_max": [
        10.0,
        1250.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555704832077026,
        0.8314694762229919,
        0.0
      ],
      "plane_d": -721.9380493164062,
      "bbox_min": [
        1.9584635424507724e-07,
        869.9456176757812,
        76.29277801513672
      ],
      "bbox_max": [
        10.0,
        874.949462890625,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509023427963257,
        0.9807853102684021,
        -5.211193609966358e-08
      ],
      "plane_d": -853.2298583984375,
      "bbox_min": [
        1.9584635424507724e-07,
        869.9456176757812,
        77.0
      ],
      "bbox_max": [
        3.5756804943084717,
        870.6568603515625,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1250.0,
      "bbox_min": [
        110.0,
        1000.0,
        60.0
      ],
      "bbox_max": [
        120.0,
        1490.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1000.0,
      "bbox_min": [
        110.0,
        1000.0,
        60.0
      ],
      "bbox_max": [
        120.0,
        1000.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1490.0,
      "bbox_min": [
        110.0,
        1490.0,
        60.0
      ],
      "bbox_max": [
        120.0,
        1490.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1490.0,
      "bbox_min": [
        120.0,
        1205.0,
        60.0
      ],
      "bbox_max": [
        190.0,
        1693.45361328125,
        214.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807853102684021,
        0.19509030878543854,
        0.0
      ],
      "plane_d": -174.94122314453125,
      "bbox_min": [
        120.0,
        1500.0,
        60.0
      ],
      "bbox_max": [
        190.0,
        1693.45361328125,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8314695954322815,
        0.5555702447891235,
        0.0
      ],
      "plane_d": -782.8532104492188,
      "bbox_min": [
        145.1197509765625,
        1626.2855224609375,
        60.0
      ],
      "bbox_max": [
        190.0,
        1693.45361328125,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 75.0,
      "bbox_min": [
        120.0,
        1205.0,
        60.0
      ],
      "bbox_max": [
        190.0,
        1345.0,
        75.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.25881069898605347,
        0.9659281373023987,
        0.0
      ],
      "plane_d": -1213.117431640625,
      "bbox_min": [
        120.0,
        1205.0,
        60.0
      ],
      "bbox_max": [
        190.0,
        1345.0,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1205.0,
      "bbox_min": [
        180.0,
        1205.0,
        60.0
      ],
      "bbox_max": [
        190.0,
        1205.0,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.70711350440979,
        0.7071000337600708,
        -5.754504854849074e-06
      ],
      "plane_d": -968.2886962890625,
      "bbox_min": [
        120.0,
        1214.3779296875,
        60.0
      ],
      "bbox_max": [
        190.0,
        1345.0,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071118354797363,
        -0.7071017026901245,
        0.0
      ],
      "plane_d": 834.8184204101562,
      "bbox_min": [
        120.0,
        1236.79248046875,
        60.0
      ],
      "bbox_max": [
        190.0,
        1345.0,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25881069898605347,
        -0.9659281373023987,
        0.0
      ],
      "plane_d": 1249.999267578125,
      "bbox_min": [
        120.0,
        1236.79248046875,
        60.0
      ],
      "bbox_max": [
        190.0,
        1345.0,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659253358840942,
        -0.2588212490081787,
        -0.0
      ],
      "plane_d": 470.9080810546875,
      "bbox_min": [
        120.0,
        1236.79248046875,
        60.0
      ],
      "bbox_max": [
        167.94091796875,
        1313.20751953125,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659253358840942,
        0.2588212490081787,
        0.0
      ],
      "plane_d": -189.0861358642578,
      "bbox_min": [
        145.8818359375,
        1236.79248046875,
        60.0
      ],
      "bbox_max": [
        167.94091796875,
        1313.20751953125,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071121335029602,
        -0.7071014642715454,
        -0.0
      ],
      "plane_d": 993.290771484375,
      "bbox_min": [
        151.7926025390625,
        1236.79248046875,
        60.0
      ],
      "bbox_max": [
        167.94091796875,
        1313.20751953125,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071094512939453,
        0.7071041464805603,
        -5.75447211303981e-06
      ],
      "plane_d": -809.821533203125,
      "bbox_min": [
        151.7926025390625,
        1297.05908203125,
        60.0
      ],
      "bbox_max": [
        167.94091796875,
        1313.20751953125,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.965927004814148,
        0.25881466269493103,
        -0.0
      ],
      "plane_d": -445.9000549316406,
      "bbox_min": [
        120.0,
        1240.0,
        60.0
      ],
      "bbox_max": [
        129.3782958984375,
        1310.0,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1250.0,
      "bbox_min": [
        120.0,
        1250.0,
        60.0
      ],
      "bbox_max": [
        126.69873046875,
        1250.0,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659240245819092,
        -0.2588256597518921,
        -7.860709956730716e-06
      ],
      "plane_d": 214.09259033203125,
      "bbox_min": [
        120.0,
        1300.0,
        60.0
      ],
      "bbox_max": [
        129.3782958984375,
        1310.0,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1300.0,
      "bbox_min": [
        120.0,
        1300.0,
        60.0
      ],
      "bbox_max": [
        126.69873046875,
        1300.0,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7757101058959961,
        0.6237488389015198,
        0.0959751307964325
      ],
      "plane_d": -827.3330078125,
      "bbox_min": [
        998.7774047851562,
        2530.0,
        250.1707000732422
      ],
      "bbox_max": [
        1021.6588745117188,
        2550.0,
        305.1265869140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7757101058959961,
        0.6237488389015198,
        0.0959751307964325
      ],
      "plane_d": -827.3330078125,
      "bbox_min": [
        943.349853515625,
        2420.0,
        181.13720703125
      ],
      "bbox_max": [
        1510.0,
        2530.0,
        360.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1510.0,
      "bbox_min": [
        1510.0,
        2420.0,
        270.0
      ],
      "bbox_max": [
        1510.0,
        2425.0,
        360.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1830.0,
      "bbox_min": [
        190.0,
        820.0,
        60.0
      ],
      "bbox_max": [
        1645.0,
        2350.0,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5877842307090759,
        -0.8090178370475769,
        0.0
      ],
      "plane_d": 1301.7037353515625,
      "bbox_min": [
        450.0,
        1110.0,
        160.0
      ],
      "bbox_max": [
        582.7122802734375,
        1384.3714599609375,
        550.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9510564208030701,
        -0.3090174198150635,
        0.0
      ],
      "plane_d": 882.6156005859375,
      "bbox_min": [
        510.5146179199219,
        1223.5849609375,
        160.0
      ],
      "bbox_max": [
        582.7122802734375,
        1384.3714599609375,
        550.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9510564208030701,
        0.3090174198150635,
        0.0
      ],
      "plane_d": 88.44082641601562,
      "bbox_min": [
        510.5146179199219,
        1285.0,
        160.0
      ],
      "bbox_max": [
        582.7122802734375,
        1384.3714599609375,
        550.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5877842307090759,
        0.8090178370475769,
        0.0
      ],
      "plane_d": -777.47216796875,
      "bbox_min": [
        530.4696044921875,
        1346.4150390625,
        160.0
      ],
      "bbox_max": [
        582.7122802734375,
        1384.3714599609375,
        550.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 190.0,
      "bbox_min": [
        450.0,
        1110.0,
        190.0
      ],
      "bbox_max": [
        490.0,
        1240.0,
        330.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1240.0,
      "bbox_min": [
        450.0,
        1240.0,
        190.0
      ],
      "bbox_max": [
        490.0,
        1240.0,
        330.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1240.0,
      "bbox_min": [
        190.0,
        820.0,
        60.0
      ],
      "bbox_max": [
        450.0,
        1804.8802490234375,
        420.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        9.536743306171047e-08,
        0.0
      ],
      "plane_d": 254.03253173828125,
      "bbox_min": [
        190.0,
        820.0,
        60.0
      ],
      "bbox_max": [
        450.0,
        1240.0,
        420.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -970.0,
      "bbox_min": [
        254.03262329101562,
        970.0,
        160.0
      ],
      "bbox_max": [
        450.0,
        1240.0,
        420.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.371390700340271,
        -0.0,
        -0.9284767508506775
      ],
      "plane_d": 272.97216796875,
      "bbox_min": [
        254.03262329101562,
        1000.0,
        190.0
      ],
      "bbox_max": [
        450.0,
        1240.0,
        192.38694763183594
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 190.0,
      "bbox_min": [
        440.0,
        1110.0,
        190.0
      ],
      "bbox_max": [
        450.0,
        1240.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 210.0,
      "bbox_min": [
        190.0,
        820.0,
        60.0
      ],
      "bbox_max": [
        254.03265380859375,
        1240.0,
        370.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.371390700340271,
        -0.0,
        -0.9284767508506775
      ],
      "plane_d": 272.97216796875,
      "bbox_min": [
        210.0,
        820.0,
        60.0
      ],
      "bbox_max": [
        254.03265380859375,
        1240.0,
        370.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 350.0,
      "bbox_min": [
        210.0,
        820.0,
        280.0
      ],
      "bbox_max": [
        254.03262329101562,
        970.0,
        370.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8314698338508606,
        0.5555699467658997,
        0.0
      ],
      "plane_d": -293.0999755859375,
      "bbox_min": [
        210.0,
        841.853759765625,
        350.0
      ],
      "bbox_max": [
        236.40264892578125,
        881.3681640625,
        370.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807853102684021,
        0.1950903981924057,
        0.0
      ],
      "plane_d": 59.91377258300781,
      "bbox_min": [
        210.0,
        820.0,
        280.0
      ],
      "bbox_max": [
        254.03262329101562,
        970.0,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 280.0,
      "bbox_min": [
        224.19573974609375,
        820.0,
        280.0
      ],
      "bbox_max": [
        241.07882690429688,
        881.3681640625,
        280.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 280.0,
      "bbox_min": [
        210.0,
        820.0,
        280.0
      ],
      "bbox_max": [
        236.40264892578125,
        881.3681640625,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314698338508606,
        0.5555699467658997,
        0.0
      ],
      "plane_d": -293.0999755859375,
      "bbox_min": [
        210.0,
        841.853759765625,
        280.0
      ],
      "bbox_max": [
        236.40264892578125,
        881.3681640625,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.70711350440979,
        0.7071000337600708,
        0.0
      ],
      "plane_d": -699.5860595703125,
      "bbox_min": [
        210.0,
        1210.3587646484375,
        60.0
      ],
      "bbox_max": [
        250.6217041015625,
        1240.0,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 75.0,
      "bbox_min": [
        210.0,
        1210.3587646484375,
        60.0
      ],
      "bbox_max": [
        225.0001220703125,
        1236.79248046875,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25881069898605347,
        0.9659281373023987,
        0.0
      ],
      "plane_d": -1114.7694091796875,
      "bbox_min": [
        210.0,
        1210.3587646484375,
        60.0
      ],
      "bbox_max": [
        225.0001220703125,
        1214.3779296875,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 75.0,
      "bbox_min": [
        190.0,
        820.0,
        60.0
      ],
      "bbox_max": [
        210.0,
        1236.24072265625,
        370.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314698338508606,
        0.5555699467658997,
        0.0
      ],
      "plane_d": -293.0999755859375,
      "bbox_min": [
        195.3977813720703,
        820.0,
        280.0
      ],
      "bbox_max": [
        210.0,
        841.853759765625,
        370.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 280.0,
      "bbox_min": [
        195.3977813720703,
        820.0,
        280.0
      ],
      "bbox_max": [
        210.0,
        841.853759765625,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25881069898605347,
        0.9659281373023987,
        0.0
      ],
      "plane_d": -1114.7694091796875,
      "bbox_min": [
        190.0,
        1205.0,
        60.0
      ],
      "bbox_max": [
        210.0,
        1210.3587646484375,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1205.0,
      "bbox_min": [
        190.0,
        1205.0,
        60.0
      ],
      "bbox_max": [
        200.0,
        1205.0,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1310.0,
      "bbox_min": [
        190.0,
        1310.0,
        60.0
      ],
      "bbox_max": [
        450.0,
        1804.8802490234375,
        340.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1460.0,
      "bbox_min": [
        190.0,
        1310.0,
        60.0
      ],
      "bbox_max": [
        450.0,
        1804.8802490234375,
        340.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.5555703639984131,
        0.8314696550369263,
        0.0
      ],
      "plane_d": -1320.8570556640625,
      "bbox_min": [
        190.0,
        1460.0,
        60.0
      ],
      "bbox_max": [
        450.0,
        1804.8802490234375,
        340.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8314701318740845,
        0.5555695295333862,
        0.0
      ],
      "plane_d": -674.9655151367188,
      "bbox_min": [
        190.0,
        1460.0,
        60.0
      ],
      "bbox_max": [
        450.0,
        1733.34521484375,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555697083473206,
        0.8314700126647949,
        0.0
      ],
      "plane_d": -1212.971435546875,
      "bbox_min": [
        230.0,
        1460.0,
        140.0
      ],
      "bbox_max": [
        450.0,
        1719.423583984375,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9797557592391968,
        0.2001969814300537,
        0.0
      ],
      "plane_d": -75.3988037109375,
      "bbox_min": [
        230.0,
        1460.0,
        140.0
      ],
      "bbox_max": [
        450.0,
        1719.423583984375,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999943971633911,
        0.003364049829542637,
        0.0
      ],
      "plane_d": 225.0872039794922,
      "bbox_min": [
        230.0,
        1460.0,
        140.0
      ],
      "bbox_max": [
        450.0,
        1719.423583984375,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314698934555054,
        0.5555699467658997,
        0.0
      ],
      "plane_d": -645.5426635742188,
      "bbox_min": [
        230.0,
        1460.0,
        140.0
      ],
      "bbox_max": [
        450.0,
        1719.423583984375,
        240.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9807853102684021,
        0.1950903832912445,
        0.0
      ],
      "plane_d": -37.63140869140625,
      "bbox_min": [
        230.0,
        1460.0,
        140.0
      ],
      "bbox_max": [
        450.0,
        1719.423583984375,
        240.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5555697083473206,
        0.8314700722694397,
        0.0
      ],
      "plane_d": -1183.548095703125,
      "bbox_min": [
        252.0435028076172,
        1460.0,
        140.0
      ],
      "bbox_max": [
        450.0,
        1719.423583984375,
        240.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 240.0,
      "bbox_min": [
        252.0435028076172,
        1460.0,
        140.0
      ],
      "bbox_max": [
        450.0,
        1719.423583984375,
        240.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 260.0,
      "bbox_min": [
        260.0,
        1460.0,
        140.0
      ],
      "bbox_max": [
        260.0,
        1500.0,
        240.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 240.0,
      "bbox_min": [
        315.64971923828125,
        1634.350341796875,
        240.0
      ],
      "bbox_max": [
        440.13531494140625,
        1717.5289306640625,
        240.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 240.0,
      "bbox_min": [
        230.0,
        1460.0,
        240.0
      ],
      "bbox_max": [
        274.462890625,
        1572.7098388671875,
        240.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 239.99998474121094,
      "bbox_min": [
        231.15760803222656,
        1507.89892578125,
        240.0
      ],
      "bbox_max": [
        358.3660888671875,
        1698.2799072265625,
        240.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.8314695954322815,
        0.5555702447891235,
        0.0
      ],
      "plane_d": -782.8532104492188,
      "bbox_min": [
        190.0,
        1693.45361328125,
        60.0
      ],
      "bbox_max": [
        216.65475463867188,
        1733.34521484375,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 270.0,
      "bbox_min": [
        190.0,
        1310.0,
        60.0
      ],
      "bbox_max": [
        300.0,
        1460.0,
        240.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 300.0,
      "bbox_min": [
        300.0,
        1415.0,
        190.0
      ],
      "bbox_max": [
        300.0,
        1460.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 74.99999237060547,
      "bbox_min": [
        190.0,
        1310.0,
        60.0
      ],
      "bbox_max": [
        250.6217041015625,
        1345.0,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.70711350440979,
        -0.7071000337600708,
        0.0
      ],
      "plane_d": 1103.51904296875,
      "bbox_min": [
        190.0,
        1310.0,
        60.0
      ],
      "bbox_max": [
        250.6217041015625,
        1345.0,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25881069898605347,
        -0.9659281373023987,
        0.0
      ],
      "plane_d": 1348.347412109375,
      "bbox_min": [
        190.0,
        1335.6220703125,
        60.0
      ],
      "bbox_max": [
        225.0001220703125,
        1345.0,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1549.9998779296875,
      "bbox_min": [
        1075.0,
        1470.0,
        500.0
      ],
      "bbox_max": [
        1549.9998779296875,
        1550.0,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1470.0,
      "bbox_min": [
        1075.0,
        1470.0,
        515.0
      ],
      "bbox_max": [
        1175.0,
        1540.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1075.0,
      "bbox_min": [
        1075.0,
        1470.0,
        515.0
      ],
      "bbox_max": [
        1075.0,
        1540.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1549.9998779296875,
      "bbox_min": [
        1549.9998779296875,
        1550.0,
        500.0
      ],
      "bbox_max": [
        1549.9998779296875,
        1689.9998779296875,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 139.99998474121094,
      "bbox_min": [
        440.0,
        2340.0,
        140.0
      ],
      "bbox_max": [
        590.0,
        2350.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        6.71764951221121e-07,
        0.0
      ],
      "plane_d": 1549.998779296875,
      "bbox_min": [
        1550.0,
        1830.0,
        500.0
      ],
      "bbox_max": [
        1550.0,
        1910.0,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        6.71764951221121e-07,
        0.0
      ],
      "plane_d": 1549.998779296875,
      "bbox_min": [
        1272.792236328125,
        1910.0,
        305.0
      ],
      "bbox_max": [
        1588.2843017578125,
        2327.08837890625,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -326.482421875,
      "bbox_min": [
        1550.0001220703125,
        2011.7158203125,
        500.0
      ],
      "bbox_max": [
        1588.2843017578125,
        2050.0,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -705.0000610351562,
      "bbox_min": [
        1272.792236328125,
        2269.812744140625,
        305.0
      ],
      "bbox_max": [
        1330.06787109375,
        2327.08837890625,
        310.0
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [],
  "tutorial_messages": []
}